! function (t, e) {
   "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.UnbxdSearch = e() : t.UnbxdSearch = e()
}(self, () => (() => {
   var t = {
         759(t) {
            var e;
            "undefined" != typeof self && self, e = () => (() => {
               "use strict";
               var t = {
                     d: (e, r) => {
                        for (var a in r) t.o(r, a) && !t.o(e, a) && Object.defineProperty(e, a, {
                           enumerable: !0,
                           get: r[a]
                        })
                     },
                     o: (t, e) => Object.prototype.hasOwnProperty.call(t, e)
                  },
                  e = {};
               t.d(e, {
                  default: () => De
               });
               const r = {
                     siteKey: "api key",
                     apiKey: "site key",
                     isFlag: !0,
                     searchEndPoint: "https://search.unbxd.io/",
                     productType: "SEARCH",
                     searchPath: "",
                     productAttributes: ["title"],
                     defaultFilters: null,
                     spellCheck: {
                        enabled: !1
                     },
                     pageSize: 5,
                     startPageNo: 0,
                     facetMultiSelect: !0,
                     updateUrls: !0,
                     variants: void 0,
                     extraParams: {},
                     facetMultilevel: !0,
                     facetDepth: 6,
                     showSwatches: !0,
                     allowExternalUrlParams: !1,
                     swatchMap: {},
                     onEvent: function () {},
                     getCategoryId: function () {
                        return encodeURIComponent(window.UnbxdAnalyticsConf.page) || decodeURIComponent(location.pathname.split("category-path")[1].split("/").pop())
                     },
                     setCategoryId: function (t, e) {
                        var r, a = t.level,
                           n = (t.parent, t.name),
                           o = (t.action, []),
                           i = Number(a),
                           s = e.getBreadCrumbsList();
                        s.forEach(function (t, e) {
                           t.filterField;
                           var r = t.value;
                           i >= e && o.push(r)
                        }), i > s.length && o.push(n), r = o.join(">"), window.UnbxdAnalyticsConf && (window.UnbxdAnalyticsConf.page = 'categoryPath:' + r)
                     },
                     url: {},
                     applyMultipleFilters: !1,
                     hashMode: !1,
                     pagination: {
                        type: "INFINITE_SCROLL"
                     },
                     onQueryRedirect: function (t, e, r) {
                        if (e) {
                           var a = e.value;
                           return "url" === e.type && (history.state && history.state.replace && history.replaceState(null, "", r), location.href = a), !1
                        }
                     },
                     onBackFromRedirect: function (t) {
                        new URLSearchParams(t ? location.hash.substring(1) : location.search).get("redirected") && history.go(-1)
                     },
                     onNoUnbxdKeyRouting: function () {
                        history.go()
                     }
                  },
                  a = "FETCH_ERROR",
                  n = "AFTER_API_CALL",
                  o = "BEFORE_API_CALL",
                  i = "RUNTIME_ERROR",
                  s = {
                     ALLOWED_QUERY_PARAM_SEPARATORS: ["&", "~", "^", ",", "_", ":", ";", "|", "$", "@"],
                     ALLOWED_KEY_VALUE_REPLACERS: ["=", ":"],
                     ALLOWED_VALUE_SEPARATORS: ["&", "~", "^", ",", "-", "_", ":", ";", "|", "$", "@"],
                     ALLOWED_RANGE_SEPARATORS: ["-"],
                     ALLOWED_PAGINATION_TYPE: ["CLICK_N_SCROLL", "INFINITE_SCROLL", "FIXED_PAGINATION"],
                     ALLOWED_PRODUCT_TYPE: ["SEARCH", "CATEGORY"],
                     ALLOWED_DEFAULT_OPEN: ["ALL", "NONE", "FIRST"],
                     ALLOWED_SORT_ACTIONS: ["click", "change"],
                     ALLOWED_PAGESIZE_ACTIONS: ["click", "change"],
                     ALLOWED_PAGINATION_ACTIONS: ["click", "change"],
                     EXPECTED_PARAMS: ["QUERY", "FILTERS", "PAGE_NUMBER", "PAGE_SIZE", "SORT", "VIEW_TYPE"],
                     DEFAULT_VALUE_SEPARATOR: ",",
                     DEFAULT_KEY_VALUE_REPLACER: "=",
                     DEFAULT_QUERY_PARAM_SEPARATOR: "&",
                     DEFAULT_RANGE_SEPARATOR: "-",
                     DEFAULT_PAGINATION_TYPE: "CLICK_N_SCROLL",
                     DEFAULT_PRODUCT_TYPE: "SEARCH",
                     DEFAULT_VALUE_FOR_DEFAULT_OPEN: "ALL",
                     DEFAULT_SORT_ACTION: "change",
                     DEFAULT_PAGESIZE_ACTION: "change",
                     DEFAULT_PAGINATION_ACTION: "click",
                     MAX_HEIGHT_DIFF_TO_TRIGGER_NEXT_PAGE: 1e3
                  };

               function c(t) {
                  return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, c(t)
               }

               function l(t, e) {
                  if (t === e) return !0;
                  if ("object" !== c(t) || "object" !== c(e) || null === t || null === e) return !1;
                  if (Object.keys(t).length !== Object.keys(e).length) return !1;
                  for (var r = 0, a = Object.keys(t); r < a.length; r++) {
                     var n = a[r];
                     if (!Object.keys(e).includes(n) || !l(t[n], e[n])) return !1
                  }
                  return !0
               }
               var u = {
                  encodeQueryParam: function () {
                     var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                     for (Array.isArray(t) && (t = null != t[0] ? t[0] : ""); Array.isArray(t);) t = null != t[0] ? t[0] : "";
                     "string" != typeof t && (t = null == t ? "" : "object" == typeof t && "function" == typeof t.trim ? t.trim() : String(t));
                     var e = t.trim();
                     return e = e.replace(/\%26/gim, "&"), (e = (e = encodeURIComponent(e)).replace(/\%20/gim, "+")).replace(/\++/gim, "+")
                  },
                  decodeQueryParam: function () {
                     var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                     for (Array.isArray(t) && (t = null != t[0] ? t[0] : ""); Array.isArray(t);) t = null != t[0] ? t[0] : "";
                     "string" != typeof t && (t = null == t ? "" : "object" == typeof t && "function" == typeof t.trim ? t.trim() : String(t));
                     try {
                        var e = t.replace(/\+/gim, " ");
                        return e = e.replace(/\s{2,}/gim, " "), (e = decodeURIComponent(e)).trim()
                     } catch (r) {
                        return t.replace(/\+/gim, " ").trim()
                     }
                  },
                  getDeviceInfo: function () {
                     var t = "Desktop";
                     return window.outerWidth < 768 ? t = "Mobile" : window.outerWidth < 992 && (t = "Tablet"), t
                  },
                  decodeAndParse: function (t) {
                     var e = t;
                     return 0 === t.indexOf('"') && (e = t.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\")), this.decodeCookie(e)
                  },
                  decodeCookie: function (t) {
                     return decodeURIComponent(t.replace(/\+/g, " "))
                  },
                  cookie: function (t) {
                     for (var e, r = document.cookie.split("; "), a = 0, n = r.length; a < n; a++) {
                        var o = r[a].split("="),
                           i = this.decodeCookie(o.shift()),
                           s = o.join("=");
                        if (t && t === i) try {
                           e = this.decodeAndParse(s);
                           break
                        } catch (t) {
                           this.log(t)
                        }
                     }
                     return e
                  },
                  readCookie: function (t) {
                     try {
                        return this.cookie("unbxd.".concat(t))
                     } catch (t) {
                        this.log(t)
                     }
                  },
                  getUserId: function () {
                     return this.readCookie("userId")
                  },
                  getDefaultRequestHeaders: function (t) {
                     var e = this.getUserId(),
                        r = {
                           "unbxd-device-type": this.getDeviceInfo()
                        };
                     return e && (r["unbxd-user-id"] = e), r
                  },
                  encodeEachFacetValue: function (t) {
                     var e = this.getValuesSeparatorFacets(),
                        r = t.split(e),
                        a = "";
                     return r.forEach(function (t, r) {
                        a += 0 === r ? encodeURIComponent(t) : e + encodeURIComponent(t)
                     }), a
                  },
                  isFilterStr: function (t) {
                     var e = (this.options || {}).url,
                        r = (void 0 === e ? {} : e).facetsParam,
                        a = r.algo,
                        n = r.keyReplacer,
                        o = void 0 === n ? {} : n,
                        i = r.rangeFacets,
                        s = void 0 === i ? [] : i,
                        c = this.getSearchQueryParam(),
                        l = this.getBrowseQueryParam(),
                        u = this.getSortParam(),
                        d = !1;
                     return [c, l, this.getPageViewParam(), u, this.getPageSizeParam(), this.getPageNoParam(), "count"].includes(t) ? d = !1 : "category-filter" === t ? d = !0 : "KEY_VALUE_REPLACER" === a ? d = Object.values(o).includes(t) || s.includes(t) || t.includes("_uFilter") : "DEFAULT" !== a || "filter" !== t && !t.includes("filter") || (d = !0), d
                  },
                  getValuesSeparatorFacets: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).facetsParam,
                        r = (void 0 === e ? {} : e).multiValueSeparator,
                        a = s.DEFAULT_VALUE_SEPARATOR;
                     return s.ALLOWED_VALUE_SEPARATORS.includes(r) ? r : a
                  },
                  getQueryParamSeparator: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).queryParamSeparator,
                        r = s.DEFAULT_QUERY_PARAM_SEPARATOR;
                     return s.ALLOWED_QUERY_PARAM_SEPARATORS.includes(e) ? e : r
                  },
                  getKeyValueSeparator: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).keyValueSeparator,
                        r = s.DEFAULT_KEY_VALUE_REPLACER;
                     return s.ALLOWED_KEY_VALUE_REPLACERS.includes(e) ? e : r
                  },
                  getRangeSeparator: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).facetsParam,
                        r = (void 0 === e ? {} : e).rangeSeparator,
                        a = s.DEFAULT_RANGE_SEPARATOR;
                     return s.ALLOWED_RANGE_SEPARATORS.includes(r) ? r : a
                  },
                  getSortParam: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).sortParam,
                        r = void 0 === e ? {} : e,
                        a = r.algo,
                        n = r.keyReplacer;
                     return "KEY_VALUE_REPLACER" === a ? void 0 === n ? {} : n : "sort"
                  },
                  getPageViewParam: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).pageViewParam,
                        r = void 0 === e ? {} : e,
                        a = r.algo,
                        n = r.keyReplacer;
                     return "KEY_VALUE_REPLACER" === a ? void 0 === n ? {} : n : "viewType"
                  },
                  getPageSizeParam: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).pageSizeParam,
                        r = void 0 === e ? {} : e,
                        a = r.algo,
                        n = r.keyReplacer;
                     return "KEY_VALUE_REPLACER" === a ? void 0 === n ? {} : n : "rows"
                  },
                  getPageNoParam: function () {
                     var t = (this.options || {}).url,
                        e = (void 0 === t ? {} : t).pageNoParam,
                        r = void 0 === e ? {} : e,
                        a = r.algo,
                        n = r.keyReplacer,
                        o = void 0 === n ? {} : n,
                        i = r.usePageNo;
                     return "KEY_VALUE_REPLACER" === a ? o : i ? "page" : "start"
                  },
                  getHashMode: function () {
                     var t = (this.options || {}).url;
                     return (void 0 === t ? {} : t).hashMode || this.options.hashMode
                  },
                  getUpdateUrls: function () {
                     return !0
                  },
                  getAllowExternalUrlParams: function () {
                     var t = (this.options || {}).url;
                     return (void 0 === t ? {} : t).allowExternalUrlParams || this.options.allowExternalUrlParams
                  },
                  getBrowseQueryParam: function () {
                     var t = this.options.url,
                        e = (void 0 === t ? {} : t).browseQueryParam,
                        r = void 0 === e ? {} : e,
                        a = r.algo,
                        n = void 0 === a ? "DEFAULT" : a,
                        o = r.keyReplacer;
                     return "DEFAULT" === n || void 0 === o ? "p" : o
                  },
                  getSearchQueryParam: function () {
                     var t = this.options.url,
                        e = (void 0 === t ? {} : t).searchQueryParam,
                        r = void 0 === e ? {} : e,
                        a = r.algo,
                        n = void 0 === a ? "DEFAULT" : a,
                        o = r.keyReplacer;
                     return "DEFAULT" === n || void 0 === o ? "q" : o
                  },
                  getHeightDiffToTriggerNextPage: function () {
                     var t = (this.options || {}).pagination,
                        e = (void 0 === t ? {} : t).heightDiffToTriggerNextPage,
                        r = s.MAX_HEIGHT_DIFF_TO_TRIGGER_NEXT_PAGE;
                     return this.options.pagination.heightDiffToTriggerNextPage = e > r ? r : e, this.options.pagination.heightDiffToTriggerNextPage
                  },
                  getPaginationType: function () {
                     var t = (this.options || {}).pagination,
                        e = (void 0 === t ? {} : t).type,
                        r = s.ALLOWED_PAGINATION_TYPE,
                        a = s.DEFAULT_PAGINATION_TYPE;
                     return this.options.pagination.type = r.includes(e) ? e : a, this.options.pagination.type
                  },
                  getSearchParamValue: function (t) {
                     var e = t;
                     return t || (e = this.getHashMode() ? window.location.hash : window.location.search), e
                  },
                  getProductType: function () {
                     var t = (this.options || {}).products,
                        e = (void 0 === t ? {} : t).productType,
                        r = s.ALLOWED_PRODUCT_TYPE,
                        a = s.DEFAULT_PRODUCT_TYPE;
                     return this.options.products.productType = r.includes(e) ? e : a, this.options.products.productType
                  },
                  getDefaultOpen: function () {
                     var t = (this.options || {}).facet,
                        e = (void 0 === t ? {} : t).defaultOpen,
                        r = s.ALLOWED_DEFAULT_OPEN,
                        a = s.DEFAULT_VALUE_FOR_DEFAULT_OPEN;
                     return this.options.facet.defaultOpen = r.includes(e) ? e : a, this.options.facet.defaultOpen
                  },
                  getSortAction: function () {
                     var t = (this.options || {}).sort,
                        e = (void 0 === t ? {} : t).action,
                        r = s.ALLOWED_SORT_ACTIONS,
                        a = s.DEFAULT_SORT_ACTION;
                     return this.options.sort.action = r.includes(e) ? e : a, this.options.sort.action
                  },
                  getPageSizeAction: function () {
                     var t = (this.options || {}).pagesize.action,
                        e = s.ALLOWED_PAGESIZE_ACTIONS,
                        r = s.DEFAULT_PAGESIZE_ACTION;
                     return this.options.pagesize.action = e.includes(t) ? t : r, this.options.pagesize.action
                  },
                  getPaginationAction: function () {
                     var t = (this.options || {}).pagination,
                        e = (void 0 === t ? {} : t).action,
                        r = s.ALLOWED_PAGINATION_ACTIONS,
                        a = s.DEFAULT_PAGINATION_ACTION;
                     return this.options.pagination.action = r.includes(e) ? e : a, this.options.pagination.action
                  },
                  deepCompareUrlParams: function (t, e) {
                     var r = this.getPageNoParam();
                     return t[r] && delete t[r], e[r] && delete e[r], l(t, e)
                  }
               };
               const d = u;

               function p(t) {
                  return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, p(t)
               }

               function h(t, e) {
                  return function (t) {
                     if (Array.isArray(t)) return t
                  }(t) || function (t, e) {
                     var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                     if (null != r) {
                        var a, n, o, i, s = [],
                           c = !0,
                           l = !1;
                        try {
                           if (o = (r = r.call(t)).next, 0 === e) {
                              if (Object(r) !== r) return;
                              c = !1
                           } else
                              for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                        } catch (t) {
                           l = !0, n = t
                        } finally {
                           try {
                              if (!c && null != r.return && (i = r.return(), Object(i) !== i)) return
                           } finally {
                              if (l) throw n
                           }
                        }
                        return s
                     }
                  }(t, e) || function (t, e) {
                     if (t) {
                        if ("string" == typeof t) return f(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f(t, e) : void 0
                     }
                  }(t, e) || function () {
                     throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                  }()
               }

               function f(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function g(t, e) {
                  return function (t) {
                     if (Array.isArray(t)) return t
                  }(t) || function (t, e) {
                     var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                     if (null != r) {
                        var a, n, o, i, s = [],
                           c = !0,
                           l = !1;
                        try {
                           if (o = (r = r.call(t)).next, 0 === e) {
                              if (Object(r) !== r) return;
                              c = !1
                           } else
                              for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                        } catch (t) {
                           l = !0, n = t
                        } finally {
                           try {
                              if (!c && null != r.return && (i = r.return(), Object(i) !== i)) return
                           } finally {
                              if (l) throw n
                           }
                        }
                        return s
                     }
                  }(t, e) || function (t, e) {
                     if (t) {
                        if ("string" == typeof t) return y(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? y(t, e) : void 0
                     }
                  }(t, e) || function () {
                     throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                  }()
               }

               function y(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function v(t) {
                  return function (t) {
                     if (Array.isArray(t)) return m(t)
                  }(t) || function (t) {
                     if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t)
                  }(t) || function (t, e) {
                     if (t) {
                        if ("string" == typeof t) return m(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? m(t, e) : void 0
                     }
                  }(t) || function () {
                     throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                  }()
               }

               function m(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function b(t) {
                  return b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, b(t)
               }

               function S(t) {
                  return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, S(t)
               }

               function E(t) {
                  return E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, E(t)
               }

               function P(t) {
                  return P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, P(t)
               }

               function F(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function A(t) {
                  return A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, A(t)
               }

               function w(t, e, r) {
                  return (e = function (t) {
                     var e = function (t) {
                        if ("object" != A(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                           var r = e.call(t, "string");
                           if ("object" != A(r)) return r;
                           throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return String(t)
                     }(t);
                     return "symbol" == A(e) ? e : e + ""
                  }(e)) in t ? Object.defineProperty(t, e, {
                     value: r,
                     enumerable: !0,
                     configurable: !0,
                     writable: !0
                  }) : t[e] = r, t
               }
               var R = d.isFilterStr,
                  U = {
                     extraParamUrlString: function () {
                        try {
                           var t = this.options.extraParams,
                              e = "";
                           return Object.keys(t).forEach(function (r) {
                              e += "&".concat(r, "=").concat("function" == typeof t[r] ? t[r]() : t[r])
                           }), e
                        } catch (t) {
                           this.onError("extraParamsFromUrlToString.js", t, i)
                        }
                     },
                     renderFromUrl: function () {
                        var t = this,
                           e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                        try {
                           var r = !1,
                              a = this.getQueryParams(e),
                              n = this.getProductType(),
                              o = this.getSearchQueryParam(),
                              s = this.getBrowseQueryParam(),
                              c = this.getKeyValueSeparator(),
                              l = o;
                           if ("SEARCH" !== n && (a[l = s] = this.getCategoryId()), "object" === p(a) && a[l]) {
                              var u = (this.options || {}).url,
                                 h = void 0 === u ? {} : u,
                                 f = h.facetsParam,
                                 g = void 0 === f ? {} : f,
                                 y = h.pageNoParam,
                                 v = void 0 === y ? {} : y,
                                 m = h.sortParam,
                                 b = void 0 === m ? {} : m,
                                 S = a[o],
                                 E = a[encodeURIComponent(this.getPageNoParam())],
                                 P = a[encodeURIComponent(this.getSortParam())],
                                 F = a["KEY_VALUE_REPLACER" === g.algo ? g.filterReplacer : "filter"],
                                 A = a[encodeURIComponent(this.getPageSizeParam())];
                              if (r = !0, this.state.userInput !== S && (this.state.userInput = d.decodeQueryParam(S)), "KEY_VALUE_REPLACER" === g.algo && !g.showFilterStr) {
                                 var w = [];
                                 Object.keys(a).forEach(function (e) {
                                    t.isFilterStr(decodeURIComponent(e)) && w.push("".concat(e).concat(c).concat(a[e]))
                                 }), F = w
                              }
                              var R = this.getFilterFromParams(F);
                              this.state.rangeFacet = R.rangeFacet, this.state.selectedFacets = R.selectedFilters;
                              var U = this.options.url.seoFriendlyUrl;
                              P && U && "KEY_VALUE_REPLACER" === b.algo ? this.state.selectedSort = this.getKeyByValue(b.valueReplacer, decodeURIComponent(P)) : P && U && "KEY_VALUE_REPLACER" !== b.algo ? this.state.selectedSort = decodeURIComponent(P) : this.state.selectedSort = "", A || (A = Number(this.options.pagesize.pageSize)), v.usePageNo ? this.state.startPageNo = E ? Number((E - 1) * A) : 0 : this.state.startPageNo = E ? Number(E) : 0, this.state.isBack = !1, this.state.pageSize = A, this.state.categoryFilter = this.getCategoryFilterFromParams(a), r && this.getResults()
                           }
                        } catch (t) {
                           this.onError("setStateFromUrl.js", t, i)
                        }
                     },
                     getQueryParams: function (t) {
                        try {
                           var e = this.getQueryParamSeparator(),
                              r = this.getKeyValueSeparator(),
                              a = (t || "" === t ? t : (this.getHashMode() ? window.location.hash : window.location.search).substr(1)).split(e),
                              n = [];
                           a.forEach(function (t, e) {
                              t.indexOf(r) > 0 ? n.push(t) : n[e - 1] = "".concat(n[e - 1], "&").concat(t)
                           });
                           for (var o = {}, s = 0; s < n.length; s++) {
                              var c = h(n[s].split(r), 2),
                                 l = c[0],
                                 u = c[1];
                              void 0 === o[l] ? o[l] = u : "string" == typeof o[l] ? (o[l] = [o[l]], o[l].push(u)) : o[l].push(u)
                           }
                           return o
                        } catch (t) {
                           return this.onError("getQueryParams.js", t, i), -1
                        }
                     },
                     urlFlattenFacets: function () {
                        try {
                           var t = "",
                              e = this.state.selectedFacets,
                              r = this.options.defaultFilters || {};
                           return Object.keys(e).forEach(function (a) {
                              var n = e[a];
                              n.length && (t += "&filter="), n.forEach(function (e, n) {
                                 var o = e.name,
                                    i = e.dataId;
                                 void 0 !== r[a] && r[a] === o || (o = "".concat("%22").concat(i).concat("%22"), t += 0 === n ? "".concat(a, "%3A").concat(o) : " OR ".concat(a, "%3A").concat(o))
                              })
                           }), t
                        } catch (t) {
                           return this.onError("facetsToUrlString.js", t, i), -1
                        }
                     },
                     facetsToWebUrlString: function () {
                        try {
                           var t = (this.options || {}).url,
                              e = (void 0 === t ? {} : t).facetsParam,
                              r = void 0 === e ? {} : e,
                              a = this.getQueryParamSeparator(),
                              n = this.getKeyValueSeparator(),
                              o = r.algo,
                              s = "";
                           if ("KEY_VALUE_REPLACER" === (void 0 === o ? "DEFAULT" : o)) {
                              var c, l = this.state.selectedFacets,
                                 u = this.options.defaultFilters || {},
                                 d = Object.keys(l),
                                 p = [];
                              c = d.filter(function (t) {
                                 return !p.includes(t)
                              }), p = [].concat(v(p), v(c));
                              var h = r.showFilterStr,
                                 f = r.filterReplacer,
                                 g = r.keyReplacer,
                                 y = r.valueReplacer,
                                 m = this.getValuesSeparatorFacets();
                              p.forEach(function (t) {
                                 var e = l[t],
                                    r = "";
                                 e.length && (s += h ? "".concat(a).concat(f, "=") : "".concat(a), g && Object.keys(g).length > 0 && (r = t in g ? g[t] : ""), s += "".concat(r ? encodeURIComponent(r) : t).concat(n)), e.forEach(function (e, r) {
                                    var a = e.name,
                                       n = a;
                                    void 0 !== u[t] && u[t] === a || (y && Object.keys(y).length > 0 && y[t] && y[t][a] && (n = y[t][a]), s += 0 === r ? "".concat(encodeURIComponent(n)) : "".concat(m).concat(encodeURIComponent(n)))
                                 })
                              })
                           } else {
                              var b = this.state.selectedFacets,
                                 S = this.options.defaultFilters || {};
                              Object.keys(b).forEach(function (t) {
                                 var e = b[t];
                                 e.length && ("HASH" === r.algo ? s += "" !== s ? a : "" : s += "".concat(a, "filter").concat(n)), e.forEach(function (e, r) {
                                    var a = e.name,
                                       n = e.dataId;
                                    void 0 !== S[t] && S[t] === a || (a = "".concat("%22").concat(n).concat("%22"), s += 0 === r ? "".concat(t, "%3A").concat(a) : " OR ".concat(t, "%3A").concat(a))
                                 })
                              })
                           }
                           return s
                        } catch (t) {
                           return this.onError("facetsToWebUrlString.js", t, i), -1
                        }
                     },
                     getDefaultFiltersStr: function () {
                        try {
                           var t = "",
                              e = this.options.defaultFilters;
                           return null !== e && Object.keys(e).forEach(function (r) {
                              t += "&filter=".concat(r, ":").concat(JSON.stringify(e[r]))
                           }), t
                        } catch (t) {
                           return this.onError("getDefaultFiltersString.js", t, i), -1
                        }
                     },
                     getShowVariantsStr: function () {
                        try {
                           var t = this.options.variants;
                           return t && "boolean" == typeof t.enabled ? "&variants=".concat(t.enabled) : ""
                        } catch (t) {
                           return this.onError("getShowVariantsUrlString.js", t, i), -1
                        }
                     },
                     getVariantAttributesStr: function () {
                        try {
                           var t = this.options.variants;
                           if (t) {
                              var e = t.enabled,
                                 r = t.attributes;
                              return r && e ? "&variants.fields=".concat(r.join(",")) : ""
                           }
                           return ""
                        } catch (t) {
                           return this.onError("getVariantAttributesUrlString.js", t, i), -1
                        }
                     },
                     getVariantsCountStr: function () {
                        try {
                           var t = this.options.variants;
                           if (t) {
                              var e = t.enabled,
                                 r = t.count;
                              return r && e ? "&variants.count=".concat(r) : ""
                           }
                           return ""
                        } catch (t) {
                           return this.onError("getVariantsCountUrlString.js", t, i), -1
                        }
                     },
                     getVariantsGroupByStr: function () {
                        try {
                           var t = this.options.variants;
                           if (t) {
                              var e = t.enabled,
                                 r = t.groupBy;
                              return r && e ? "&variants.groupBy=".concat(r) : ""
                           }
                           return ""
                        } catch (t) {
                           return this.onError("getVariantsGroupByUrlString.js", t, i), -1
                        }
                     },
                     getProductAttributesStr: function () {
                        try {
                           return this.options.productAttributes ? "&fields=".concat(this.options.productAttributes.join(",")) : ""
                        } catch (t) {
                           return this.onError("getProductAttributesUrlString.js", t, i), -1
                        }
                     },
                     getPageSizeStr: function () {
                        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        try {
                           var e = (this.options || {}).url,
                              r = (void 0 === e ? {} : e).pageNoParam;
                           return !t && (void 0 === r ? {} : r).usePageNo ? "&count=".concat(this.state.pageSize) : "&rows=".concat(this.state.pageSize)
                        } catch (t) {
                           return this.onError("getPageSizeUrlString.js", t, i), -1
                        }
                     },
                     getPageStartStr: function () {
                        var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        try {
                           var e = (this.options || {}).url,
                              r = (void 0 === e ? {} : e).pageNoParam;
                           return !t && (void 0 === r ? {} : r).usePageNo ? "&page=".concat(Math.floor(this.state.startPageNo / this.state.pageSize) + 1) : "&start=".concat(this.state.startPageNo)
                        } catch (t) {
                           return this.onError("getPaginationStartUrlString.js", t, i), -1
                        }
                     },
                     getNewUrlState: function (t) {
                        var e = this;
                        try {
                           var r = this.options,
                              a = r.url,
                              n = void 0 === a ? {} : a,
                              o = n.sortParam,
                              s = void 0 === o ? {} : o,
                              c = n.pageSizeParam,
                              l = void 0 === c ? {} : c,
                              u = n.pageNoParam,
                              p = void 0 === u ? {} : u,
                              h = n.pageViewParam,
                              f = void 0 === h ? {} : h,
                              g = n.browseQueryParam,
                              y = void 0 === g ? {} : g,
                              v = n.searchQueryParam,
                              m = void 0 === v ? {} : v,
                              b = r.browseQueryParam,
                              S = void 0 === b ? "p" : b,
                              E = this.getProductType(),
                              P = this.getSearchQueryParam(),
                              F = this.getBrowseQueryParam(),
                              A = this.getKeyValueSeparator(),
                              w = this.state.userInput,
                              R = "",
                              U = this.getBaseUrl();
                           for (Array.isArray(w) && (w = null != w[0] ? w[0] : ""); Array.isArray(w);) w = null != w[0] ? w[0] : "";
                           "string" != typeof w && (w = null == w ? "" : "object" == typeof w && "function" == typeof w.trim ? w.trim() : String(w));
                           if ("BROWSE" === E || "CATEGORY" === E) {
                              R = "", w = this.getCategoryId();
                              var C = "/category?";
                              this.webUrl = U + C + (y.addToUrl ? "".concat(F).concat(A).concat(w) : ""), this.apiUrl = "".concat(U).concat(C).concat(S, "=").concat(w)
                           }
                           if ("CATEGORY" === E && (R = "&pagetype=boolean"), "SEARCH" === E) {
                              var N = "/search?";
                              this.webUrl = U + N + (m.addToUrl ? "".concat(P).concat(A).concat(d.encodeQueryParam(w)) : ""), this.apiUrl = "".concat(U).concat(N, "q=").concat(d.encodeQueryParam(w))
                           }
                           var O = this.urlFlattenFacets(),
                              T = this.getShowVariantsStr(),
                              L = this.getVariantAttributesStr(),
                              I = this.getVariantsCountStr(),
                              j = this.getVariantsGroupByStr(),
                              k = this.getProductAttributesStr() + this.getDefaultFiltersStr(),
                              _ = this.getSortUrlString(),
                              V = this.getSpellCheckUrlString(),
                              x = this.getRangeFilterStr(),
                              M = this.categoryFilterUrlStr(),
                              X = this.getUcParamUrlString(),
                              D = this.options.facetMultiSelect ? "&facet.multiselect=true" : "&facet.multiselect=false",
                              B = this.apiUrl + M + D + O + T + L + I + j + k + _ + V + x + R + this.getPageSizeStr(!0) + this.getPageStartStr(!0) + this.extraParamUrlString() + "&facet.version=V2" + (X || ""),
                              W = this.webUrl + function () {
                                 var t = (e.options || {}).url,
                                    r = (void 0 === t ? {} : t).facetsParam,
                                    a = void 0 === r ? {} : r,
                                    n = e.getQueryParamSeparator(),
                                    o = "";
                                 if (a.addToUrl) {
                                    var i = e.categoryFilterWebUrlString() + e.facetsToWebUrlString() + e.getRangeFilterWebString();
                                    if ("HASH" === a.algo) {
                                       var s = window.btoa(i);
                                       o = s ? "".concat(n, "filter=").concat(s) : ""
                                    } else o = i
                                 }
                                 return o
                              }() + (s.addToUrl ? this.getSortWebUrlString() : "") + (l.addToUrl ? this.getPageSizeWebUrlString() : "") + (p.addToUrl ? this.getPaginationStartWebUrlString() : "") + (f.addToUrl ? this.getViewTypeForWebUrl() : "") + (window.unbxdImageSearch && window.unbxdImageSearch.isVisualSearchEnabled && window.unbxdImageSearch.isVisualSearchEnabled() && window.unbxdImageSearch.getVisualSearchQueryParams ? window.unbxdImageSearch.getVisualSearchQueryParams() : "");
                           return this.state.currentApiUrl = B, this.state.currentWebUrl = W, t ? B : W
                        } catch (t) {
                           return this.onError("getNewUrlState.js", t, i), -1
                        }
                     },
                     getRangeFilterStr: function () {
                        try {
                           var t = this.state.rangeFacet,
                              e = Object.keys(t),
                              r = "";
                           return e.forEach(function (e) {
                              var a = t[e];
                              Array.isArray(a) ? a.length > 0 && (r += "&filter=".concat(e, "%3A").concat(a.join(" OR ".concat(e, "%3A")))) : r += "&filter=".concat(e, "%3A").concat(a)
                           }), r
                        } catch (t) {
                           return this.onError("getRangeFilterString.js", t, i), -1
                        }
                     },
                     getRangeFilterWebString: function () {
                        try {
                           var t = this.options.url,
                              e = (void 0 === t ? {} : t).facetsParam,
                              r = void 0 === e ? {} : e,
                              a = this.getQueryParamSeparator(),
                              n = this.getValuesSeparatorFacets(),
                              o = this.getKeyValueSeparator(),
                              s = "";
                           if ("KEY_VALUE_REPLACER" === r.algo) {
                              var c = this.state.rangeFacet,
                                 l = Object.keys(c),
                                 u = this.getRangeSeparator();
                              l.forEach(function (t) {
                                 s += "".concat(a).concat(Object.keys(r.keyReplacer).length > 0 && t in r.keyReplacer ? r.keyReplacer[t] : t).concat(o), c[t].forEach(function (t, e) {
                                    s += 0 === e ? "".concat(t.replace(/\[|\]/g, "").split(" TO ").join(u)) : "".concat(n).concat(t.replace(/\[|\]/g, "").split(" TO ").join(u))
                                 })
                              })
                           } else {
                              var d = this.state.rangeFacet;
                              Object.keys(d).forEach(function (t) {
                                 var e = d[t];
                                 Array.isArray(e) ? e.length > 0 && ("HASH" === r.algo ? s += "".concat(a).concat(t, "%3A").concat(e.join(" OR ".concat(t, "%3A"))) : s += "".concat(a, "filter").concat(o).concat(t, "%3A").concat(e.join(" OR ".concat(t, "%3A")))) : s += "&filter".concat(o).concat(t, "%3A").concat(e)
                              })
                           }
                           return s
                        } catch (t) {
                           return this.onError("getRangeFilterWebString.js", t, i), -1
                        }
                     },
                     categoryFilterUrlStr: function () {
                        var t = this;
                        try {
                           var e = this.state.categoryFilter,
                              r = void 0 === e ? {} : e,
                              a = "",
                              n = Object.keys(r),
                              o = "%22";
                           return n.forEach(function (e) {
                              var n = t.getAFacetByName(e)[0],
                                 i = t.getBreadCrumbsList(e),
                                 s = null;
                              if (n) {
                                 var c = n.filterField,
                                    l = n.values,
                                    u = r[e].map(function (e, r) {
                                       if (s = l.find(function (r) {
                                             return t.cleanFacetValue(encodeURIComponent(r.name)) === t.cleanFacetValue(e)
                                          }), i) {
                                          var a = i.find(function (t) {
                                             return t.value === e
                                          });
                                          a && (s = {
                                             name: a.value
                                          })
                                       }
                                       return s && t.encodeCategoryFacetValue(s.name).split(o).join(""), r > 0 ? ">".concat(t.encodeCategoryFacetValue(e).split(o).join("")) : t.encodeCategoryFacetValue(e).split(o).join("")
                                    });
                                 a += "categoryPath" === c ? "&category-filter=".concat(u.join("")) : "&filter=".concat(c, ':"').concat(u.join(""), '"')
                              } else if (r && r.categoryPath) {
                                 var d = "";
                                 r.categoryPath.forEach(function (e) {
                                    e.split(">").forEach(function (e) {
                                       var r = t.encodeCategoryFacetValue(e).split("%22").join("");
                                       "" !== d ? d += ">".concat(r) : d = r
                                    })
                                 }), a += "&category-filter=".concat(d)
                              }
                           }), a
                        } catch (t) {
                           return this.onError("categoryFilterUrlString.js", t, i), -1
                        }
                     },
                     categoryFilterWebUrlString: function () {
                        var t = this;
                        try {
                           var e = this.state.categoryFilter,
                              r = void 0 === e ? {} : e,
                              a = this.getKeyValueSeparator(),
                              n = "",
                              o = Object.keys(r),
                              s = "%22";
                           return o.forEach(function (e) {
                              var o = t.getAFacetByName(e)[0],
                                 i = t.getBreadCrumbsList(e),
                                 c = null,
                                 l = t.getQueryParamSeparator();
                              if (o) {
                                 var u = o.filterField,
                                    d = o.values,
                                    p = r[e].map(function (e, r) {
                                       if (c = d.find(function (r) {
                                             return t.cleanFacetValue(encodeURIComponent(r.name)) === t.cleanFacetValue(e)
                                          }), i) {
                                          var a = i.find(function (t) {
                                             return t.value === e
                                          });
                                          a && (c = {
                                             name: a.value
                                          })
                                       }
                                       return c && t.encodeCategoryFacetValue(c.name).split(s).join(""), r > 0 ? ">".concat(t.encodeCategoryFacetValue(e).split(s).join("")) : t.encodeCategoryFacetValue(e).split(s).join("")
                                    });
                                 n += "categoryPath" === u ? "".concat(l, "category-filter").concat(a).concat(p.join("")) : "".concat(l, "filter").concat(a).concat(u, ':"').concat(p.join(""), '"')
                              } else if (r && r.categoryPath) {
                                 var h = "";
                                 r.categoryPath.forEach(function (e) {
                                    e.split(">").forEach(function (e) {
                                       var r = t.encodeCategoryFacetValue(e).split("%22").join("");
                                       "" !== h ? h += ">".concat(r) : h = r
                                    })
                                 }), n += "".concat(l, "category-filter").concat(a).concat(h)
                              }
                           }), n
                        } catch (t) {
                           return this.onError("categoryFilterWebUrlString.js", t, i), -1
                        }
                     },
                     getSortUrlString: function () {
                        try {
                           var t = this.getSelectedSort();
                           return t ? "&sort=".concat(encodeURI(t)) : ""
                        } catch (t) {
                           return this.onError("getSortUrlString.js", t, i), -1
                        }
                     },
                     getSortWebUrlString: function () {
                        try {
                           var t = this.getSelectedSort();
                           if (t) {
                              var e = this.options || {},
                                 r = e.url,
                                 a = (void 0 === r ? {} : r).sortParam,
                                 n = void 0 === a ? {} : a,
                                 o = e.url,
                                 s = void 0 === o ? {} : o,
                                 c = this.getQueryParamSeparator(),
                                 l = this.getKeyValueSeparator();
                              if (s && n && "KEY_VALUE_REPLACER" === n.algo) {
                                 var u = n.keyReplacer,
                                    d = void 0 === u ? "sort" : u,
                                    p = n.valueReplacer,
                                    h = void 0 === p ? {} : p,
                                    f = t;
                                 return Object.keys(h).length > 0 && h[t] && (f = h[t]), "".concat(c).concat(encodeURIComponent(d)).concat(l).concat(encodeURIComponent(f))
                              }
                              return "".concat(c, "sort").concat(l).concat(encodeURI(t))
                           }
                           return ""
                        } catch (t) {
                           return this.onError("getSortWebUrlString.js", t, i), -1
                        }
                     },
                     getSpellCheckUrlString: function () {
                        try {
                           return this.options.spellCheck.enabled ? "&spellcheck=".concat(!0) : ""
                        } catch (t) {
                           return this.onError("getSpellCheckUrlString.js", t, i), -1
                        }
                     },
                     getBaseUrl: function () {
                        try {
                           var t = this.options,
                              e = t.searchEndPoint,
                              r = t.siteKey,
                              a = t.apiKey;
                           return "".concat(e).concat(a, "/").concat(r)
                        } catch (t) {
                           return this.onError("getBaseUrl.js", t, i), -1
                        }
                     },
                     getStateFromUrl: function () {
                        var t = this;
                        try {
                           var e, r = (this.options || {}).url,
                              a = void 0 === r ? {} : r,
                              n = a.facetsParam,
                              o = void 0 === n ? {} : n,
                              s = a.pageNoParam,
                              c = void 0 === s ? {} : s,
                              l = this.getSearchQueryParam(),
                              u = this.getKeyValueSeparator();
                           e = "KEY_VALUE_REPLACER" !== o.algo && "HASH" !== o.algo || o.showFilterStr ? this.getQueryParams() : this.getCustomQueryParams();
                           var d = {},
                              p = this.options.pagesize.pageSize;
                           if ("object" === b(e)) {
                              var h = e,
                                 f = h[l],
                                 g = h[encodeURIComponent(this.getPageNoParam())],
                                 y = h[encodeURIComponent(this.getPageSizeParam())],
                                 v = h[encodeURIComponent(this.getSortParam())],
                                 m = h.count,
                                 S = h.rows,
                                 E = void 0 === S ? p : S,
                                 P = e["KEY_VALUE_REPLACER" === o.algo ? o.filterReplacer : "filter"];
                              if (this.state.userInput !== f && (d.userInput = f), "KEY_VALUE_REPLACER" === o.algo && !o.showFilterStr) {
                                 var F = [];
                                 Object.keys(e).forEach(function (r) {
                                    t.isFilterStr(r) && (F.length ? F.push("".concat(r).concat(u).concat(e[r])) : F.push("".concat(r).concat(u).concat(e, "[item]")))
                                 }), P = F
                              }
                              var A = this.getFilterFromParams(P);
                              d.rangeFacet = A.rangeFacet, d.selectedFacets = A.selectedFilters, d.selectedSort = v || "", c.usePageNo ? d.startPageNo = g ? (g - 1) * m : 0 : d.startPageNo = y || 0, d.pageSize = Number(E), d.categoryFilter = this.getCategoryFilterFromParams(e)
                           }
                           return d
                        } catch (t) {
                           return this.onError("getStateFromUrl.js", t, i), -1
                        }
                     },
                     getUcParamUrlString: function () {
                        try {
                           var t = this.getQueryParams();
                           return t.uc_param ? "&uc_param=".concat(t.uc_param) : ""
                        } catch (t) {
                           return this.onError("getUcParamUrlString.js", t, i), -1
                        }
                     },
                     getViewTypeForWebUrl: function () {
                        try {
                           var t, e = this.state.productViewType,
                              r = this.options.url,
                              a = r.pageViewParam,
                              n = (void 0 === a ? {} : a).valuesReplacer,
                              o = void 0 === n ? {
                                 GRID: "GRID",
                                 LIST: "LIST"
                              } : n,
                              s = r.pageViewParam,
                              c = void 0 === s ? {} : s,
                              l = this.getQueryParamSeparator(),
                              u = this.getKeyValueSeparator(),
                              d = "KEY_VALUE_REPLACER" === c.algo ? c.keyReplacer : "viewType";
                           return t = "GRID" === e ? "KEY_VALUE_REPLACER" === c.algo ? encodeURIComponent(o.GRID) : "GRID" : "KEY_VALUE_REPLACER" === c.algo ? encodeURIComponent(o.LIST) : "LIST", "".concat(l).concat(encodeURIComponent(d)).concat(u).concat(t)
                        } catch (e) {
                           return this.onError("getViewTypeForWebUrl.js", e, i), -1
                        }
                     },
                     getPageSizeWebUrlString: function () {
                        try {
                           var t = (this.options || {}).url,
                              e = (void 0 === t ? {} : t).pageSizeParam,
                              r = void 0 === e ? {} : e,
                              a = r.algo,
                              n = r.keyReplacer,
                              o = this.getQueryParamSeparator(),
                              s = this.getKeyValueSeparator();
                           return "".concat(o).concat("KEY_VALUE_REPLACER" === a ? encodeURIComponent(n) : "rows").concat(s).concat(this.state.pageSize)
                        } catch (t) {
                           return this.onError("getPageSizeWebUrlString.js", t, i), -1
                        }
                     },
                     getPaginationStartWebUrlString: function () {
                        try {
                           var t = this.options.url,
                              e = (void 0 === t ? {} : t).pageNoParam,
                              r = void 0 === e ? {} : e,
                              a = r.algo,
                              n = r.usePageNo,
                              o = r.keyReplacer,
                              s = this.getQueryParamSeparator(),
                              c = this.getKeyValueSeparator(),
                              l = "".concat(s);
                           return l += "KEY_VALUE_REPLACER" === a ? encodeURIComponent(o) : n ? "page" : "start", l += "".concat(c).concat(n ? Math.ceil(this.state.startPageNo / this.state.pageSize) + 1 : this.state.startPageNo)
                        } catch (t) {
                           return this.onError("getPaginationStartWebUrlString.js", t, i), -1
                        }
                     },
                     getCustomQueryParams: function () {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                        try {
                           var e = (this.options || {}).url,
                              r = void 0 === e ? {} : e,
                              a = r.facetsParam,
                              n = (void 0 === a ? {} : a).showFilterStr,
                              o = r.facetsParam,
                              s = void 0 === o ? {} : o,
                              c = {},
                              l = this.getQueryParamSeparator(),
                              u = this.getKeyValueSeparator();
                           return n || this.getSearchParamValue(t).substr(1).split(l).forEach(function (t) {
                              if (t.indexOf(u) > 0)
                                 if ("HASH" === s.algo && "filter" === t.split("=")[0]) {
                                    var e = g(t.split("filter=")[1], 1)[0];
                                    c.filter = e
                                 } else {
                                    var r = g(t.split(u), 2),
                                       a = r[0],
                                       n = r[1];
                                    c[a] = n
                                 }
                           }), c
                        } catch (t) {
                           return this.onError("getCustomQueryParams.js", t, i), -1
                        }
                     },
                     readSortWebUrl: function (t) {
                        try {
                           var e = this.options.url.sortParam,
                              r = e.algo,
                              a = void 0 === r ? "DEFAULT" : r,
                              n = e.keyReplacer,
                              o = void 0 === n ? "sort" : n,
                              s = this.getCustomQueryParams(t)[encodeURIComponent(this.getSortParam())];
                           return s ? function (t, e, r) {
                              return (e = function (t) {
                                 var e = function (t) {
                                    if ("object" != S(t) || !t) return t;
                                    var e = t[Symbol.toPrimitive];
                                    if (void 0 !== e) {
                                       var r = e.call(t, "string");
                                       if ("object" != S(r)) return r;
                                       throw new TypeError("@@toPrimitive must return a primitive value.")
                                    }
                                    return String(t)
                                 }(t);
                                 return "symbol" == S(e) ? e : e + ""
                              }(e)) in t ? Object.defineProperty(t, e, {
                                 value: r,
                                 enumerable: !0,
                                 configurable: !0,
                                 writable: !0
                              }) : t[e] = r, t
                           }({}, "KEY_VALUE_REPLACER" === a ? o : "sort", [decodeURIComponent(s)]) : ""
                        } catch (t) {
                           return this.onError("readSortWebUrl.js", t, i), -1
                        }
                     },
                     readPageViewWebUrl: function (t) {
                        try {
                           var e = this.options.url,
                              r = (void 0 === e ? {} : e).pageViewParam,
                              a = void 0 === r ? {} : r,
                              n = a.algo,
                              o = void 0 === n ? "DEFAULT" : n,
                              s = a.keyReplacer,
                              c = this.getCustomQueryParams(t),
                              l = {};
                           if ("KEY_VALUE_REPLACER" === o) {
                              var u = c[encodeURIComponent(s)];
                              u && (l = function (t, e, r) {
                                 return (e = function (t) {
                                    var e = function (t) {
                                       if ("object" != E(t) || !t) return t;
                                       var e = t[Symbol.toPrimitive];
                                       if (void 0 !== e) {
                                          var r = e.call(t, "string");
                                          if ("object" != E(r)) return r;
                                          throw new TypeError("@@toPrimitive must return a primitive value.")
                                       }
                                       return String(t)
                                    }(t);
                                    return "symbol" == E(e) ? e : e + ""
                                 }(e)) in t ? Object.defineProperty(t, e, {
                                    value: r,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                 }) : t[e] = r, t
                              }({}, s, [decodeURIComponent(u)]))
                           } else {
                              var d = c.viewType;
                              d && (l = {
                                 viewType: [d]
                              })
                           }
                           return l
                        } catch (t) {
                           return this.onError("readPageViewWebUrl.js", t, i), -1
                        }
                     },
                     readPageSizeWebUrl: function (t) {
                        try {
                           var e = this.options.url.pageSizeParam,
                              r = e.algo,
                              a = void 0 === r ? "DEFAULT" : r,
                              n = e.keyReplacer,
                              o = this.getCustomQueryParams(t),
                              s = {};
                           if ("KEY_VALUE_REPLACER" === a) {
                              var c = o[encodeURIComponent(n)];
                              c && (s = function (t, e, r) {
                                 return (e = function (t) {
                                    var e = function (t) {
                                       if ("object" != P(t) || !t) return t;
                                       var e = t[Symbol.toPrimitive];
                                       if (void 0 !== e) {
                                          var r = e.call(t, "string");
                                          if ("object" != P(r)) return r;
                                          throw new TypeError("@@toPrimitive must return a primitive value.")
                                       }
                                       return String(t)
                                    }(t);
                                    return "symbol" == P(e) ? e : e + ""
                                 }(e)) in t ? Object.defineProperty(t, e, {
                                    value: r,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                 }) : t[e] = r, t
                              }({}, n, [c]))
                           } else {
                              var l = o.rows;
                              l && (s = {
                                 rows: [l]
                              })
                           }
                           return s
                        } catch (t) {
                           return this.onError("readPageSizeWebUrl.js", t, i), -1
                        }
                     },
                     readFacetsWebUrl: function () {
                        var t = this,
                           e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                        try {
                           var r = this.options.url,
                              a = (void 0 === r ? {} : r).facetsParam,
                              n = void 0 === a ? {} : a,
                              o = this.getSearchQueryParam(),
                              s = this.getQueryParamSeparator(),
                              c = {},
                              l = this.readQueryParamsFromUrl(e),
                              u = this.getKeyValueSeparator();
                           switch (n.algo) {
                              case "KEY_VALUE_REPLACER":
                                 var d = e;
                                 d || (d = this.getHashMode() ? window.location.hash : window.location.search);
                                 var p = this.getHashMode() ? d : d.substr(1),
                                    h = p && p.split(s) || [],
                                    f = {};
                                 h && h.length && h.forEach(function (e) {
                                    if ("" !== e) {
                                       var r = "";
                                       if (e.indexOf(u) > 0) {
                                          var a = function (t, e) {
                                                return function (t) {
                                                   if (Array.isArray(t)) return t
                                                }(t) || function (t, e) {
                                                   var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                                                   if (null != r) {
                                                      var a, n, o, i, s = [],
                                                         c = !0,
                                                         l = !1;
                                                      try {
                                                         if (o = (r = r.call(t)).next, 0 === e) {
                                                            if (Object(r) !== r) return;
                                                            c = !1
                                                         } else
                                                            for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                                                      } catch (t) {
                                                         l = !0, n = t
                                                      } finally {
                                                         try {
                                                            if (!c && null != r.return && (i = r.return(), Object(i) !== i)) return
                                                         } finally {
                                                            if (l) throw n
                                                         }
                                                      }
                                                      return s
                                                   }
                                                }(t, e) || function (t, e) {
                                                   if (t) {
                                                      if ("string" == typeof t) return F(t, e);
                                                      var r = {}.toString.call(t).slice(8, -1);
                                                      return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? F(t, e) : void 0
                                                   }
                                                }(t, e) || function () {
                                                   throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                                                }()
                                             }(r = e.split(u), 2),
                                             n = a[0],
                                             o = a[1];
                                          f[n] = o
                                       }
                                       t.isFilterStr(decodeURIComponent(r[0])) && (c[r[0]] = [r[1]])
                                    }
                                 });
                                 break;
                              case "HASH":
                                 Object.keys(l).forEach(function (e) {
                                    e !== o && t.isFilterStr(e) && (c[e] = [decodeURIComponent(window.atob(l[e]))])
                                 });
                                 break;
                              default:
                                 Object.keys(l).forEach(function (e) {
                                    e !== o && t.isFilterStr(e) && (c[e] = l[e])
                                 })
                           }
                           return c
                        } catch (t) {
                           return this.onError("readFacetsWebUrl.js", t, i), -1
                        }
                     },
                     readPageNoWebUrl: function (t) {
                        try {
                           var e = this.options.url,
                              r = (void 0 === e ? {} : e).pageNoParam,
                              a = void 0 === r ? {} : r,
                              n = a.algo,
                              o = void 0 === n ? "DEFAULT" : n,
                              s = a.keyReplacer,
                              c = a.usePageNo,
                              l = this.getCustomQueryParams(t),
                              u = {};
                           if ("KEY_VALUE_REPLACER" === o) {
                              var d = l[encodeURIComponent(s)];
                              d && (u = w({}, s, [d]))
                           } else {
                              var p = l[c ? "page" : "start"];
                              p && (u = w({}, c ? "page" : "start", [p]))
                           }
                           return u
                        } catch (t) {
                           return this.onError("readPageNoWebUrl.js", t, i), -1
                        }
                     },
                     readQueryParamsFromUrl: function (t) {
                        var e = this;
                        try {
                           var r = this.options.url,
                              a = (void 0 === r ? {} : r).facetsParam,
                              n = void 0 === a ? {} : a,
                              o = this.getSearchQueryParam(),
                              s = this.getBrowseQueryParam(),
                              c = this.getQueryParamSeparator(),
                              l = this.getKeyValueSeparator(),
                              u = this.getSearchParamValue(t),
                              d = "",
                              p = (d = this.getHashMode() ? "#" === u[0] ? u.substr(1) : u : u.substr(1)) ? d.split(c) : [],
                              h = {};
                           return p.forEach(function (t) {
                              if ("" !== t) {
                                 var r = t.split(l);
                                 if (e.isFilterStr(decodeURIComponent(r[0]))) switch (n.algo) {
                                    case "HASH":
                                       h.filter = [r];
                                       break;
                                    case "KEY_VALUE_REPLACER":
                                       Object.keys(h).includes(r[0]) ? h[r[0]].push(r[1]) : h[r[0]] = [r[1]];
                                       break;
                                    default:
                                       t.includes("category-filter".concat(l)) ? h[r[0]] = [decodeURIComponent(r[1])] : Object.keys(h).includes("filter") ? r.length > 2 ? h.filter.push(decodeURIComponent(r.splice(1, r.length).join(":"))) : h.filter.push(decodeURIComponent(r[1])) : r.length > 2 ? h.filter = [decodeURIComponent(r.splice(1, r.length).join(":"))] : h.filter = [decodeURIComponent(r[1])]
                                 } else r[0] === o || r[0] === s ? h[r[0]] = [r[1]] : h[decodeURIComponent(r[0])] = [decodeURIComponent(r[1])]
                              }
                           }), h
                        } catch (t) {
                           return this.onError("readQueryParamsFromUrl.js", t, i), -1
                        }
                     },
                     getValuesSeparatorFacets: d.getValuesSeparatorFacets,
                     getQueryParamSeparator: d.getQueryParamSeparator,
                     getRangeSeparator: d.getRangeSeparator,
                     getSortParam: d.getSortParam,
                     getPageViewParam: d.getPageViewParam,
                     getPageSizeParam: d.getPageSizeParam,
                     getPageNoParam: d.getPageNoParam,
                     isFilterStr: R,
                     getHashMode: d.getHashMode,
                     getUpdateUrls: d.getUpdateUrls,
                     getAllowExternalUrlParams: d.getAllowExternalUrlParams,
                     getBrowseQueryParam: d.getBrowseQueryParam,
                     getSearchQueryParam: d.getSearchQueryParam,
                     getKeyValueSeparator: d.getKeyValueSeparator,
                     getHeightDiffToTriggerNextPage: d.getHeightDiffToTriggerNextPage,
                     getPaginationType: d.getPaginationType,
                     getSearchParamValue: d.getSearchParamValue,
                     getProductType: d.getProductType,
                     getDefaultOpen: d.getDefaultOpen,
                     getSortAction: d.getSortAction,
                     getPageSizeAction: d.getPageSizeAction,
                     getPaginationAction: d.getPaginationAction,
                     setRoutingStrategies: function (t) {
                        try {
                           var e = this.getPaginationType(),
                              r = this.getPageNoParam(),
                              a = this.getHashMode() ? window.location.hash : window.location.search,
                              n = this.getQueryParams(this.getHashMode() ? a.split("#")[1] : a.split("?")[1]),
                              o = this.getQueryParams(this.getHashMode() ? t.split("#")[1] : (null == t ? void 0 : t.split("?")[1]) || ""),
                              s = ("INFINITE_SCROLL" === e || "CLICK_N_SCROLL" === e) && n[r] !== o[r] && d.deepCompareUrlParams.bind(this)(n, o),
                              c = t;
                           "" === t && (c = window.location.pathname), s ? history.replaceState(null, "", c) : history.pushState(null, "", c)
                        } catch (e) {
                           this.onError("Failed to update URL, falling back to window.location.href - setRoutingStrategies.js", e, i), window.location.href = t
                        }
                     }
                  };

               function C(t) {
                  try {
                     this.state.startPageNo = Number(t)
                  } catch (t) {
                     this.onError("setPageStart.js", t, i)
                  }
               }

               function N() {
                  try {
                     var t = this.getSearchResults();
                     if (!t) return null;
                     var e = t.numberOfProducts,
                        r = t.products,
                        a = t.start;
                     a = Number(a);
                     var n = Number(this.state.pageSize),
                        o = 0;
                     e > 0 && (o = e % n === 0 ? e / n : Math.floor(e / n) + 1);
                     var s = Math.floor(a / n) + 1,
                        c = !(a + n >= e || a >= e),
                        l = !(a - n < 0 || a <= 0);
                     return {
                        numberOfProducts: e,
                        start: a,
                        productsLn: r.length,
                        rows: n,
                        noOfPages: o,
                        currentPage: s || 0,
                        isNext: c,
                        isPrev: l
                     }
                  } catch (t) {
                     return this.onError("getPaginationInfo.js", t, i), -1
                  }
               }

               function O(t) {
                  try {
                     "number" == typeof t && t === parseInt(t, 10) && (this.state.pageSize = Number(t), this.state.startPageNo = 0)
                  } catch (t) {
                     this.onError("setPageSize.js", t, i)
                  }
               }

               function T(t) {
                  try {
                     Array.isArray(t) ? this.options.productAttributes = t : this.options.productAttributes = "*"
                  } catch (t) {
                     this.onError("setProductAttributes.js", t, i)
                  }
               }

               function L(t) {
                  try {
                     var e = this.options.variants,
                        r = void 0 === e ? {} : e;
                     "boolean" == typeof t && (r.enabled = t), this.options.variants = r
                  } catch (t) {
                     this.onError("setShowVariants.js", t, i)
                  }
               }

               function I(t) {
                  try {
                     var e = this.options.variants,
                        r = void 0 === e ? {} : e;
                     "number" == typeof t && (r.count = t), this.options.variants = r
                  } catch (t) {
                     this.onError("setVariantsCount.js", t, i)
                  }
               }

               function j(t) {
                  try {
                     var e = this.options.variants,
                        r = void 0 === e ? {} : e;
                     Array.isArray(t) && (r.attributes = t), this.options.variants = r
                  } catch (t) {
                     this.onError("setVariantsAttributes.js", t, i)
                  }
               }

               function k(t) {
                  try {
                     var e = this.options.variants,
                        r = void 0 === e ? {} : e;
                     "string" == typeof t && t.length > 0 && (r.groupBy = t), this.options.variants = r
                  } catch (t) {
                     this.onError("setVariantsGroupBy.js", t, i)
                  }
               }

               function _() {
                  try {
                     return this.state.responseObj && this.state.responseObj.searchMetaData || null
                  } catch (t) {
                     return this.onError("getSearchMetaDetails.js", t, i), -1
                  }
               }

               function V() {
                  try {
                     var t = this.getResponseObj();
                     return t && t.response || null
                  } catch (t) {
                     return this.onError("getSearchResults.js", t, i), -1
                  }
               }

               function x() {
                  try {
                     var t = this.getSearchMeta();
                     return t && t.queryParams || null
                  } catch (t) {
                     return this.onError("getSearchQueryParams.js", t, i), -1
                  }
               }

               function M() {
                  try {
                     if (this.state.responseObj) {
                        var t = this.state.responseObj.searchMetaData.queryParams;
                        return t[this.getSearchQueryParam()] || t[this.getBrowseQueryParam()]
                     }
                     return ""
                  } catch (t) {
                     return this.onError("getSearchQuery.js", t, i), -1
                  }
               }

               function X(t) {
                  return X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, X(t)
               }
               const D = function t(e) {
                  if (null === e) return null;
                  if ("object" !== X(e)) return e;
                  var r = Array.isArray(e) ? [] : {};
                  return Object.keys(e).forEach(function (a) {
                     var n = e[a];
                     r[a] = t(n)
                  }), r
               };

               function B(t) {
                  return B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, B(t)
               }

               function W(t) {
                  return function (t) {
                     if (Array.isArray(t)) return H(t)
                  }(t) || function (t) {
                     if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t)
                  }(t) || function (t, e) {
                     if (t) {
                        if ("string" == typeof t) return H(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? H(t, e) : void 0
                     }
                  }(t) || function () {
                     throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                  }()
               }

               function H(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function z(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                     var a = Object.getOwnPropertySymbols(t);
                     e && (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable
                     })), r.push.apply(r, a)
                  }
                  return r
               }

               function Q(t) {
                  for (var e = 1; e < arguments.length; e++) {
                     var r = null != arguments[e] ? arguments[e] : {};
                     e % 2 ? z(Object(r), !0).forEach(function (e) {
                        K(t, e, r[e])
                     }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : z(Object(r)).forEach(function (e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e))
                     })
                  }
                  return t
               }

               function K(t, e, r) {
                  return (e = function (t) {
                     var e = function (t) {
                        if ("object" != B(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                           var r = e.call(t, "string");
                           if ("object" != B(r)) return r;
                           throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return String(t)
                     }(t);
                     return "symbol" == B(e) ? e : e + ""
                  }(e)) in t ? Object.defineProperty(t, e, {
                     value: r,
                     enumerable: !0,
                     configurable: !0,
                     writable: !0
                  }) : t[e] = r, t
               }

               function q() {
                  var t = this,
                     e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                     r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "";
                  try {
                     var s = this.state,
                        c = s.userInput,
                        l = s.isHistory,
                        u = s.isBack,
                        p = "" === e ? c : e;
                     if (this.state.userInput = p, this.state.currentApiUrl = this.getNewUrlState(!0), this.state.isLoading) return !1;
                     this.state.isLoading = !0;
                     var h = this,
                        f = this.options.variants,
                        g = this.getProductType();
                     if (!this.getHashMode() && this.getUpdateUrls() && !l && !u) {
                        this.state.isBack = !1;
                        var y = this.state.currentWebUrl.split("".concat(g.toLocaleLowerCase(), "?"))[1];
                        if (decodeURIComponent(window.location.search) !== "?".concat(d.decodeQueryParam(y))) return this.setUrl(!0), !1
                     }
                     this.callBack(this, o);
                     var v = new Headers,
                        m = d.getDefaultRequestHeaders(this);
                     Object.keys(m).forEach(function (t) {
                        v.append(t, m[t])
                     });
                     var b = fetch(this.state.currentApiUrl, {
                           headers: v,
                           method: "GET"
                        }),
                        S = function (e, r) {
                           t.state.isLoading = !1, t.state.userInput = p, e && t.callBack(h, e, {
                              error: r
                           })
                        };
                     return b.then(function (e) {
                        return t.state.requestId = e && e.headers ? e.headers.get("X-Request-Id") : "", e.json()
                     }).then(function (e) {
                        if (t.state.isLoading = !1, t.state.userInput = p, e && !e.error) {
                           var o = D(e);
                           f && f.enabled && (o = t.processVariantMap(o)), t.state.responseObj = o;
                           var i = t.getDidYouMeanFromResponse();
                           i && (t.state.didYouMean = i, t.state.noResultQuery = t.state.userInput);
                           var s = o,
                              c = s.facets,
                              d = s.response,
                              g = void 0 === d ? {} : d;
                           if (c) {
                              var y = t.getFacets(),
                                 v = t.modifyFacetsList(y);
                              o.facets = Q(Q({}, c), {}, {
                                 text: {
                                    list: v
                                 }
                              })
                           }
                           if (g) {
                              var m = g.products,
                                 b = void 0 === m ? [] : m,
                                 E = t.getPaginationType();
                              "INFINITE_SCROLL" === E || "CLICK_N_SCROLL" === E ? t.state.products = "prev" === r ? [].concat(W(b), W(t.state.products)) : [].concat(W(t.state.products), W(b)) : "FIXED_PAGINATION" === E && (t.state.products = b)
                           }
                           t.state.responseObj = o, t.setSort(), t.getUpdateUrls() && l && !u && (t.state.isBack = !1, t.setUrl(!1), t.updateSelectedFacetsCount()), t.callBack(h, n)
                        } else S(a, e.error)
                     }).catch(function (t) {
                        return S(a, t), -1
                     }), !0
                  } catch (t) {
                     return this.onError("getResultsFromApi.js", t, i), -1
                  }
               }

               function Y(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function G() {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  try {
                     var e = this.options.variants.mapping,
                        r = void 0 === e ? {} : e,
                        a = Object.keys(r),
                        n = D(t);
                     if (t.response && t.response.products) {
                        var o = n.response.products.map(function (t) {
                           var e = D(t),
                              n = e,
                              o = n.variants,
                              i = void 0 === o ? [] : o,
                              s = n.relevantDocument,
                              c = e;
                           if ("variant" === s && i.length > 0) {
                              var l = function (t, e) {
                                 return function (t) {
                                    if (Array.isArray(t)) return t
                                 }(t) || function (t, e) {
                                    var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                                    if (null != r) {
                                       var a, n, o, i, s = [],
                                          c = !0,
                                          l = !1;
                                       try {
                                          if (o = (r = r.call(t)).next, 0 === e) {
                                             if (Object(r) !== r) return;
                                             c = !1
                                          } else
                                             for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                                       } catch (t) {
                                          l = !0, n = t
                                       } finally {
                                          try {
                                             if (!c && null != r.return && (i = r.return(), Object(i) !== i)) return
                                          } finally {
                                             if (l) throw n
                                          }
                                       }
                                       return s
                                    }
                                 }(t, e) || function (t, e) {
                                    if (t) {
                                       if ("string" == typeof t) return Y(t, e);
                                       var r = {}.toString.call(t).slice(8, -1);
                                       return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Y(t, e) : void 0
                                    }
                                 }(t, e) || function () {
                                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                                 }()
                              }(i, 1);
                              e = l[0], a.forEach(function (t) {
                                 var a = r[t];
                                 c[t] = e[a]
                              })
                           }
                           var u = [];
                           return i.forEach(function (t) {
                              var e = t;
                              a.forEach(function (a) {
                                 var n = r[a];
                                 n && (e[a] = t[n])
                              }), u.push(e)
                           }), c.variants = u, c
                        });
                        n.response.products = o
                     }
                     return n
                  } catch (t) {
                     return this.onError("processVariantsMap.js", t, i), -1
                  }
               }

               function $(t, e) {
                  try {
                     return this.state.products.find(function (r) {
                        return r[t] === e
                     })
                  } catch (t) {
                     return this.onError("getProductByPropValue.js", t, i), -1
                  }
               }

               function Z() {
                  var t = this;
                  try {
                     var e = this.getSearchQueryParams(),
                        r = e,
                        a = r[e],
                        n = r.filter;
                     this.state.userInput = a;
                     var o = [],
                        s = "__",
                        c = ":";
                     if (n) {
                        if (Array.isArray(n)) n.forEach(function (t) {
                           var e = t.replaceAll(c, s);
                           e = encodeURIComponent(e).replaceAll(s, c), o.push(e)
                        });
                        else {
                           var l = n.replaceAll(c, s);
                           l = encodeURIComponent(l).replaceAll(s, c), o = [l]
                        }
                        r.filter = o
                     }
                     var u = this.getFilterFromParams(o);
                     this.state.rangeFacet = u.rangeFacet;
                     var d = u.selectedFilters,
                        p = null;
                     d ? Object.keys(d).forEach(function (e) {
                        if (t.isCategoryFacet(e)) {
                           p = e;
                           var r = d[e][0].dataId;
                           t.state.categoryFilter[p] = r.split(">"), t.state.selectedFacets[p] && delete t.state.selectedFacets[p]
                        } else t.state.selectedFacets[e] = d[e]
                     }) : this.state.selectedFacets = {}, 0 === Object.keys(this.state.categoryFilter).length && (this.state.categoryFilter = this.getCategoryFilterFromParams(r)), this.state.breadcrumbs = this.getBreadCrumbs(p)
                  } catch (t) {
                     this.onError("setStateFromData.js", t, i)
                  }
               }
               const J = function (t) {
                  try {
                     var e = t.siteName,
                        r = t.siteKey,
                        a = t.searchEndPoint,
                        n = t.defaultFilters,
                        o = t.spellCheck,
                        s = t.pageSize,
                        c = t.startPageNo,
                        l = t.facetDepth,
                        u = t.facetMultilevel,
                        d = t.facetMultiSelect,
                        p = t.updateUrls,
                        h = t.extraParams,
                        f = t.onEvent,
                        g = t.getCategoryId,
                        y = t.applyMultipleFilters,
                        v = t.hashMode;
                     this.state.pageSize = s || this.state.pageSize, this.state.startPageNo = c || this.state.startPageNo, this.options.siteName = e || this.options.siteName, this.options.siteKey = r || this.options.siteKey, this.options.searchEndPoint = a || this.options.searchEndPoint, this.options.defaultFilters = n || this.options.defaultFilters, this.options.spellCheck = o || this.options.spellCheck, this.options.startPageNo = c || this.options.startPageNo, this.options.applyMultipleFilters = y || this.options.applyMultipleFilters, this.options.facetDepth = l || this.options.facetDepth, this.options.facetMultilevel = u || this.options.facetMultilevel, this.options.facetMultiSelect = d || this.options.facetMultiSelect, this.options.updateUrls = p || this.options.url.updateUrls || this.options.updateUrls, this.options.extraParams = h || this.options.extraParams, this.options.onEvent = f || this.options.onEvent, this.options.getCategoryId = g || this.options.getCategoryId, this.options.hashMode = v || this.getHashMode()
                  } catch (t) {
                     this.onError("setSearchConfigurations.js", t, i)
                  }
               };
               var tt = function (t) {
                     try {
                        var e = this.state,
                           r = e.urlState,
                           a = e.isHistory,
                           n = this.checkIfUnbxdKey();
                        if (this.getHashMode())
                           if (decodeURIComponent(window.location.hash) !== "#".concat(decodeURIComponent(r))) {
                              if (this.state.isBack = !0, !n) return void this.options.onNoUnbxdKeyRouting();
                              this.renderFromUrl(t.state)
                           } else this.callBack(this, "lastBack");
                        else if (a) {
                           if (this.state.isBack = !0, !n) return void this.options.onNoUnbxdKeyRouting();
                           this.renderFromUrl(t.state)
                        } else this.callBack(this, "lastBack")
                     } catch (t) {
                        this.onError("onLocationChange", t, i)
                     }
                  },
                  et = function () {
                     return this.state.requestId
                  };

               function rt(t, e) {
                  try {
                     var r = {};
                     return Object.keys(e).forEach(function (a) {
                        var n = e[a];
                        r[a] = t[n]
                     }), r
                  } catch (t) {
                     return this.onError("getSwatches.js", t, i), -1
                  }
               }

               function at() {
                  try {
                     var t = this.getResponseObj();
                     if (t && t.facets && t.facets.multilevel) {
                        var e = t.facets.multilevel.bucket || t.facets.multilevel.list || [];
                        return this.modifyFacetsList(e) || []
                     }
                     return []
                  } catch (t) {
                     return this.onError("getBucketedFacets.js", t, i), -1
                  }
               }

               function nt() {
                  var t = this,
                     e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                  try {
                     var r = (this.options || {}).url,
                        a = (void 0 === r ? {} : r).facetsParam,
                        n = void 0 === a ? {} : a,
                        o = {},
                        s = {},
                        c = D(e);
                     if ("KEY_VALUE_REPLACER" === n.algo) {
                        var l = this,
                           u = this.getKeyValueSeparator();
                        "string" == typeof c && (c = Array(c)), c.forEach(function () {
                           var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").split(u),
                              r = decodeURIComponent(e[0]),
                              a = l.getKeyByValue(n.keyReplacer, r),
                              i = n.rangeFacets.includes(a),
                              c = [],
                              d = t.getValuesSeparatorFacets();
                           (c = e[1] && e[1].includes(d) ? e[1].split(d) : e[1] && e[1].includes(encodeURIComponent(d)) ? e[1].split(encodeURIComponent(d)) : [e[1]]) && c.length > 0 && c.forEach(function (e) {
                              var c = decodeURIComponent(e),
                                 u = n.valueReplacer[a] ? l.getKeyByValue(n.valueReplacer[a], c) : c;
                              if (i) {
                                 var d = u.split(t.getRangeSeparator()),
                                    p = "[".concat(Number(d[0]), " TO ").concat(Number(d[1]), "]");
                                 s[r] ? s[r].push(p) : s[r] = [p]
                              } else {
                                 var h = l.getFacetByValue(a, u);
                                 if (h.actualFound) {
                                    var f = h.facetName,
                                       g = h.selectedvalue;
                                    o[f] ? o[f].push(g) : o[f] = Array(g)
                                 } else {
                                    var y = h.facetName,
                                       v = {
                                          name: h.selectedvalue.name,
                                          dataId: l.encodeFacetValue(u),
                                          count: 0
                                       };
                                    o[y] ? o[y].push(v) : "category-filter" !== y && (o[y] = Array(v))
                                 }
                              }
                           })
                        })
                     } else {
                        var d = this;
                        "HASH" === n.algo && (c = window.atob(c) ? window.atob(c).split(this.getQueryParamSeparator()) : []), "string" == typeof c && (c = Array(c)), c.forEach(function () {
                           (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "").split("%20OR%20").forEach(function () {
                              var _raw = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                              var t = _raw.split(/%3A(.+)/);
                              if (t.length < 3) { var _ci = _raw.indexOf(":"); if (_ci > 0) t = [_raw.substring(0, _ci), _raw.substring(_ci + 1), ""]; }
                              if (3 === t.length) {
                                 var e = decodeURIComponent(t[1]);
                                 if (e = e.replace(/(^")|("$)/g, "").replace(/\"{2,}/g, '"').replace(/\\\"/g, '"').replace(/(^\[)|(\]$)/g, ""), t[1].indexOf("TO") > 0) {
                                    var r = e.split(" TO "),
                                       a = t[0],
                                       n = "[".concat(Number(r[0]), " TO ").concat(Number(r[1]), "]");
                                    s[a] ? s[a].push(n) : s[a] = [n]
                                 } else {
                                    var i = t[0],
                                       c = t[1],
                                       l = d.cleanEncodedFacetValue(c),
                                       u = d.decodeFacetValue(l),
                                       p = d.getFacetByValue(i, u);
                                    if (p.actualFound) {
                                       var h = p.facetName,
                                          f = p.selectedvalue;
                                       o[h] ? o[h].push(f) : o[h] = Array(f)
                                    } else {
                                       var g = p.facetName,
                                          y = {
                                             name: p.selectedvalue.name,
                                             dataId: l,
                                             count: 0
                                          };
                                       o[g] ? o[g].push(y) : o[g] = Array(y)
                                    }
                                 }
                              }
                           })
                        })
                     }
                     return {
                        selectedFilters: o,
                        rangeFacet: s
                     }
                  } catch (t) {
                     return this.onError("getFilterFromParams.js", t, i), -1
                  }
               }

               function ot(t) {
                  var e = this;
                  try {
                     var r = t.filter,
                        a = [];
                     if (t["category-filter"] && (a = (r = t["category-filter"]).split(">")), !r) return {};
                     Array.isArray(r) || (r = [r]), r = (r = this.getFilterFromParams(r) || {}).selectedFilters;
                     var n = {};
                     if (Object.keys(r).forEach(function (t) {
                           if (e.isCategoryFacet(t)) {
                              var a = r[t][0].dataId;
                              n[t] = a.split(">")
                           }
                        }), a.length > 0 && a) {
                        var o = [];
                        a.forEach(function (t) {
                           decodeURIComponent(t).split(">").forEach(function (t) {
                              o.push(decodeURIComponent(t))
                           })
                        }), n.categoryPath = o
                     }
                     return n
                  } catch (t) {
                     return this.onError("getCategoryFilterFromParams.js", t, i), -1
                  }
               }

               function it() {
                  try {
                     var t = this.getResponseObj();
                     if (t) {
                        var e = t.facets;
                        return e && e.range && e.range.list ? e.range.list : []
                     }
                     return []
                  } catch (t) {
                     return this.onError("getRangeFacets.js", t, i), -1
                  }
               }

               function st() {
                  try {
                     var t = this.getResponseObj();
                     if (t) {
                        var e = t.facets;
                        return e && e.text && e.text.list ? e.text.list : []
                     }
                     return []
                  } catch (t) {
                     return this.onError("getFacets.js", t, i), -1
                  }
               }

               function ct() {
                  try {
                     return this.state.selectedFacets
                  } catch (t) {
                     return this.onError("getSelectedFacets.js", t, i), -1
                  }
               }

               function lt(t) {
                  try {
                     return this.getFacets().find(function (e) {
                        return e.facetName === t ? e : null
                     })
                  } catch (t) {
                     return this.onError("getSelectedFacet.js", t, i), -1
                  }
               }

               function ut(t) {
                  try {
                     var e = this.state.selectedFacets,
                        r = t.selectedFacetName,
                        a = "",
                        n = "",
                        o = 0,
                        s = this.getSelectedFacetValue(t);
                     if (s) {
                        var c = s.name,
                           l = s.dataId,
                           u = s.count;
                        a = c, n = l, o = u
                     }
                     return !this.isFacetAlreadyAdded(r, n) && (e[r] ? e[r].push({
                        name: a,
                        dataId: n,
                        count: o
                     }) : e[r] = [{
                        name: a,
                        dataId: n,
                        count: o
                     }], this.callBack(this, "added_facet", {
                        selectedFacets: e[r]
                     }), this.options.applyMultipleFilters || (this.setPageStart(0), this.getResults.bind(this)()), !0)
                  } catch (t) {
                     return this.onError("updateFacets.js", t, i), -1
                  }
               }

               function dt(t) {
                  try {
                     var e = this.state.selectedFacets;
                     return this.clearFacets(!1), Object.keys(t).map(function (r) {
                        return e[r] ? delete e[r] : e[r] = t[r], !0
                     }), this.setPageStart(0), this.getResults.bind(this)(), !0
                  } catch (t) {
                     return this.onError("applyFacets.js", t, i), -1
                  }
               }

               function pt() {
                  var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                  try {
                     var e = this.state.selectedFacets;
                     Object.keys(e).map(function (t) {
                        return delete e[t]
                     }), t && (this.setPageStart(0), this.getResults.bind(this)())
                  } catch (t) {
                     this.onError("clearFacets.js", t, i)
                  }
               }

               function ht(t) {
                  return function (t) {
                     if (Array.isArray(t)) return ft(t)
                  }(t) || function (t) {
                     if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t)
                  }(t) || function (t, e) {
                     if (t) {
                        if ("string" == typeof t) return ft(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ft(t, e) : void 0
                     }
                  }(t) || function () {
                     throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                  }()
               }

               function ft(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function gt(t) {
                  try {
                     var e = this.state.selectedFacets;
                     return Object.keys(t).map(function (r) {
                        var a = e[r] || [];
                        return e[r] = [].concat(ht(a), ht(t[r])), !0
                     }), !0
                  } catch (t) {
                     return this.onError("addFacets.js", t, i), -1
                  }
               }

               function yt(t) {
                  try {
                     return this.state.selectedFacets[t]
                  } catch (t) {
                     return this.onError("findSelectedFacet.js", t, i), -1
                  }
               }

               function vt() {
                  var t = this,
                     e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  try {
                     var r = e.parent,
                        a = void 0 === r ? null : r,
                        n = e.level,
                        o = void 0 === n ? null : n;
                     if (o)
                        if (this.state.categoryFilter[a]) 0 == (o = Number(o) - 1) ? delete this.state.categoryFilter[a] : this.state.categoryFilter[a].splice(o, 6);
                        else {
                           var s = this.getBreadCrumbsList(a);
                           o > 1 && (this.state.categoryFilter[a] = [], s.forEach(function (e, r) {
                              if (r < o - 1) {
                                 var n = e.value;
                                 t.state.categoryFilter[a].push(n)
                              }
                           }))
                        }
                  } catch (t) {
                     this.onError("deleteCategoryFilter.js", t, i)
                  }
               }

               function mt(t, e) {
                  try {
                     var r = this.getSelectedFacets();
                     if (e) {
                        var a = r[t];
                        this.state.selectedFacets[t] = a.filter(function (t) {
                           return t.dataId !== e
                        })
                     } else delete this.state.selectedFacets[t];
                     return this.state.selectedFacets
                  } catch (t) {
                     return this.onError("deleteFacet.js", t, i), -1
                  }
               }

               function bt(t) {
                  return bt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, bt(t)
               }

               function St(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                     var a = Object.getOwnPropertySymbols(t);
                     e && (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable
                     })), r.push.apply(r, a)
                  }
                  return r
               }

               function Et(t) {
                  for (var e = 1; e < arguments.length; e++) {
                     var r = null != arguments[e] ? arguments[e] : {};
                     e % 2 ? St(Object(r), !0).forEach(function (e) {
                        Pt(t, e, r[e])
                     }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : St(Object(r)).forEach(function (e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e))
                     })
                  }
                  return t
               }

               function Pt(t, e, r) {
                  return (e = function (t) {
                     var e = function (t) {
                        if ("object" != bt(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                           var r = e.call(t, "string");
                           if ("object" != bt(r)) return r;
                           throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return String(t)
                     }(t);
                     return "symbol" == bt(e) ? e : e + ""
                  }(e)) in t ? Object.defineProperty(t, e, {
                     value: r,
                     enumerable: !0,
                     configurable: !0,
                     writable: !0
                  }) : t[e] = r, t
               }

               function Ft(t, e) {
                  try {
                     var r = this.getSelectedFacet(t) || {
                           facetName: t
                        },
                        a = !1,
                        n = r.values,
                        o = void 0 === n ? [] : n,
                        s = {
                           name: e
                        };
                     if (o.length > 0)
                        for (var c = 0; c < o.length; c++) {
                           var l = o[c];
                           if (l.name === e) {
                              a = !0, s = l;
                              break
                           }
                        }
                     return a ? Et(Et({}, r), {}, {
                        selectedvalue: s,
                        actualFound: a
                     }) : {
                        facetName: t,
                        actualFound: a,
                        selectedvalue: {
                           name: e,
                           dataId: e,
                           count: 0
                        }
                     }
                  } catch (t) {
                     return this.onError("getFacetByValue.js", t, i), -1
                  }
               }

               function At(t) {
                  try {
                     var e = t.selectedFacetId;
                     return t.facetData.values.find(function (t) {
                        return t.dataId === e
                     })
                  } catch (t) {
                     return this.onError("getSelectedFacetValue.js", t, i), -1
                  }
               }

               function wt() {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  try {
                     var e = t.parent,
                        r = void 0 === e ? null : e,
                        a = t.name,
                        n = void 0 === a ? null : a,
                        o = t.level,
                        s = void 0 === o ? null : o,
                        c = this.getCategoryFacetByValue(n),
                        l = this.getBreadCrumbsList(r);
                     if ((s = Number(s)) && c)
                        if (this.state.categoryFilter[r] && s <= l.length) this.state.categoryFilter[r][s - 1] = c, this.callBack(this, "deletedcategoryFilter");
                        else {
                           var u = [];
                           (u = l.map(function (t) {
                              return t.value
                           })).push(c), this.state.categoryFilter[r] = u, this.callBack(this, "setCategoryFilter")
                        }
                  } catch (t) {
                     this.onError("setCategoryFilter.js", t, i)
                  }
               }

               function Rt(t) {
                  try {
                     if (t.length) {
                        var e = this.options.extraParams["facet.multilevel"];
                        this.state.categoryFilter[e] = [t]
                     }
                  } catch (t) {
                     this.onError("setDefaultCategoryFilter.js", t, i)
                  }
               }

               function Ut(t) {
                  try {
                     var e = t.start,
                        r = t.end,
                        a = t.facetName,
                        n = t.applyMultiple,
                        o = "[".concat(e, " TO ").concat(r, "]");
                     if (n)
                        if (this.state.rangeFacet[a]) {
                           var s = this.state.rangeFacet[a].indexOf(o);
                           s < 0 ? this.state.rangeFacet[a].push(o) : this.state.rangeFacet[a].splice(s, 1)
                        } else this.state.rangeFacet[a] = [o];
                     else this.state.rangeFacet[a] = [o];
                     this.callBack(this, "added_facet", {
                        rangeFacet: this.state.rangeFacet[a]
                     })
                  } catch (t) {
                     this.onError("setRangeFacet", t, i)
                  }
               }

               function Ct(t) {
                  try {
                     var e = (this.state || {}).rangeFacet,
                        r = void 0 === e ? {} : e;
                     r[t] && delete r[t], this.state.rangeFacet = r
                  } catch (t) {
                     this.onError("clearARangeFacet.js", t, i)
                  }
               }

               function Nt(t, e) {
                  try {
                     this.deleteFacet(t, e), this.callBack(this, "deleted_facet"), this.options.applyMultipleFilters || (this.setPageStart(0), this.getResults.bind(this)())
                  } catch (t) {
                     this.onError("deleteAFacet.js", t, i)
                  }
               }

               function Ot(t, e) {
                  try {
                     var r = this.getSelectedFacets()[t] || [],
                        a = !1;
                     return r && (a = r.some(function () {
                        return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).dataId === e
                     })), a
                  } catch (t) {
                     return this.onError("isFacetAlreadyAdded.js", t, i), -1
                  }
               }

               function Tt(t) {
                  try {
                     var e = this.state.rangeFacet;
                     return t ? e[t] : e
                  } catch (t) {
                     return this.onError("getSelectedRanges.js", t, i), -1
                  }
               }

               function Lt(t) {
                  return Lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, Lt(t)
               }

               function It(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                     var a = Object.getOwnPropertySymbols(t);
                     e && (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable
                     })), r.push.apply(r, a)
                  }
                  return r
               }

               function jt(t) {
                  for (var e = 1; e < arguments.length; e++) {
                     var r = null != arguments[e] ? arguments[e] : {};
                     e % 2 ? It(Object(r), !0).forEach(function (e) {
                        kt(t, e, r[e])
                     }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : It(Object(r)).forEach(function (e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e))
                     })
                  }
                  return t
               }

               function kt(t, e, r) {
                  return (e = function (t) {
                     var e = function (t) {
                        if ("object" != Lt(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                           var r = e.call(t, "string");
                           if ("object" != Lt(r)) return r;
                           throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return String(t)
                     }(t);
                     return "symbol" == Lt(e) ? e : e + ""
                  }(e)) in t ? Object.defineProperty(t, e, {
                     value: r,
                     enumerable: !0,
                     configurable: !0,
                     writable: !0
                  }) : t[e] = r, t
               }

               function _t() {
                  try {
                     var t;
                     return function (t) {
                        try {
                           var e = [];
                           return (t || []).forEach(function (t) {
                              for (var r = t.values, a = r.counts, n = r.gap, o = D(t), i = [], s = [], c = 0; c < a.length; c += 2) {
                                 var l = Number(a[c]),
                                    u = {
                                       name: l,
                                       count: a[c + 1],
                                       dataId: l
                                    };
                                 if (s.push(u), s.length >= 2) {
                                    var d = s[0],
                                       p = s[1];
                                    i.push({
                                       from: d,
                                       end: p
                                    }), s.shift()
                                 }
                              }
                              if (1 === s.length) {
                                 var h = s[0],
                                    f = h.dataId + n,
                                    g = {
                                       name: f,
                                       count: 0,
                                       dataId: f
                                    };
                                 i.push({
                                    from: h,
                                    end: g
                                 })
                              }
                              var y = i[0].from.dataId,
                                 v = i[i.length - 1].end.dataId;
                              o.start = y, o.end = v, o.max = v, o.gap = n || 1, o.min = y, o.values = i, e.push(jt(jt({}, o), {}, {
                                 values: i
                              }))
                           }), e
                        } catch (t) {
                           return (void 0).onError("processRangeFacets.js", t, i), -1
                        }
                     }(this.getRangeFacets())
                  } catch (t) {
                     return this.onError("getRanges.js", t, i), -1
                  }
               }

               function Vt(t) {
                  try {
                     var e = this.getAFacetByName(t)[0];
                     return !!e && "category" === e.facetType
                  } catch (t) {
                     return this.onError("isCategoryFacet.js", t, i), -1
                  }
               }

               function xt(t) {
                  return function (t) {
                     if (Array.isArray(t)) return Mt(t)
                  }(t) || function (t) {
                     if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t)
                  }(t) || function (t, e) {
                     if (t) {
                        if ("string" == typeof t) return Mt(t, e);
                        var r = {}.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Mt(t, e) : void 0
                     }
                  }(t) || function () {
                     throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                  }()
               }

               function Mt(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function Xt() {
                  try {
                     var t = this.getAllTextFacets(),
                        e = this.getAllRangeFacets(),
                        r = this.getAllCategory();
                     return [].concat(xt(r), xt(t), xt(e)).sort(this.sortFacets)
                  } catch (t) {
                     return this.onError("getAllFacets.js", t, i), -1
                  }
               }

               function Dt(t) {
                  try {
                     var e = this.getAllFacets(),
                        r = [];
                     return t && (r = e.filter(function (e) {
                        return e.facetName === t
                     })), r
                  } catch (t) {
                     return this.onError("getAFacetByName.js", t, i), -1
                  }
               }

               function Bt() {
                  try {
                     var t = this.state.categoryFilter;
                     return t ? Object.keys(t) : null
                  } catch (t) {
                     return this.onError("getSelectedMultilevelFacet.js", t, i), -1
                  }
               }

               function Wt(t) {
                  return Wt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, Wt(t)
               }

               function Ht(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                     var a = Object.getOwnPropertySymbols(t);
                     e && (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable
                     })), r.push.apply(r, a)
                  }
                  return r
               }

               function zt(t) {
                  for (var e = 1; e < arguments.length; e++) {
                     var r = null != arguments[e] ? arguments[e] : {};
                     e % 2 ? Ht(Object(r), !0).forEach(function (e) {
                        Qt(t, e, r[e])
                     }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ht(Object(r)).forEach(function (e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e))
                     })
                  }
                  return t
               }

               function Qt(t, e, r) {
                  return (e = function (t) {
                     var e = function (t) {
                        if ("object" != Wt(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                           var r = e.call(t, "string");
                           if ("object" != Wt(r)) return r;
                           throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return String(t)
                     }(t);
                     return "symbol" == Wt(e) ? e : e + ""
                  }(e)) in t ? Object.defineProperty(t, e, {
                     value: r,
                     enumerable: !0,
                     configurable: !0,
                     writable: !0
                  }) : t[e] = r, t
               }

               function Kt() {
                  try {
                     var t = this.getSelectedBucketedFacet(),
                        e = this.getSelectedRanges(),
                        r = this.getSelectedFacets();
                     return zt(zt(zt({}, t), e), r)
                  } catch (t) {
                     return this.onError("getAllSelectedFacets.js", t, i), -1
                  }
               }

               function qt() {
                  try {
                     var t = this.getAllSelectedFacets() || {};
                     return Object.keys(t).length
                  } catch (t) {
                     return this.onError("getSelectedFacetsCount.js", t, i), -1
                  }
               }

               function Yt() {
                  try {
                     var t = this.getAllSelectedFacets() || {},
                        e = Object.keys(t),
                        r = 0;
                     return e.forEach(function (e) {
                        var a = t[e];
                        Array.isArray(a) && (r += a.length)
                     }), r
                  } catch (t) {
                     return this.onError("getSelectedFacetValueCount.js", t, i), -1
                  }
               }

               function Gt(t) {
                  try {
                     var e = this.getBucketedFacets(),
                        r = null;
                     if (e)
                        for (var a = 0; a < e.length; a++)
                           for (var n = e[a].values, o = 0; o < n.length; o++) {
                              var s = n[o],
                                 c = s.dataId,
                                 l = s.name;
                              if (c === t) {
                                 r = l;
                                 break
                              }
                           }
                     return r
                  } catch (t) {
                     return this.onError("getCategoryFacetByValue.js", t, i), -1
                  }
               }

               function $t(t) {
                  return $t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, $t(t)
               }

               function Zt(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function Jt(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                     var a = Object.getOwnPropertySymbols(t);
                     e && (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable
                     })), r.push.apply(r, a)
                  }
                  return r
               }

               function te(t) {
                  for (var e = 1; e < arguments.length; e++) {
                     var r = null != arguments[e] ? arguments[e] : {};
                     e % 2 ? Jt(Object(r), !0).forEach(function (e) {
                        ee(t, e, r[e])
                     }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Jt(Object(r)).forEach(function (e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e))
                     })
                  }
                  return t
               }

               function ee(t, e, r) {
                  return (e = function (t) {
                     var e = function (t) {
                        if ("object" != $t(t) || !t) return t;
                        var e = t[Symbol.toPrimitive];
                        if (void 0 !== e) {
                           var r = e.call(t, "string");
                           if ("object" != $t(r)) return r;
                           throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return String(t)
                     }(t);
                     return "symbol" == $t(e) ? e : e + ""
                  }(e)) in t ? Object.defineProperty(t, e, {
                     value: r,
                     enumerable: !0,
                     configurable: !0,
                     writable: !0
                  }) : t[e] = r, t
               }
               var re = function () {
                     var t = this,
                        e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                     try {
                        var r = [];
                        return e.forEach(function (a, n) {
                           var o = a;
                           if (a.name) r.push(te(te({}, o), {}, {
                              dataId: t.encodeFacetValue(a.name)
                           }));
                           else {
                              var i = "";
                              n % 2 == 1 && (i = e[n - 1], r.push({
                                 name: i,
                                 count: o,
                                 dataId: t.encodeFacetValue(i)
                              }))
                           }
                        }), r
                     } catch (t) {
                        return this.onError("modifyValues", t, i), -1
                     }
                  },
                  ae = function (t) {
                     var e = this;
                     try {
                        var r = [];
                        return (t || []).forEach(function (t) {
                           var a = D(t),
                              n = a.values,
                              o = a.displayName,
                              i = a.facetName,
                              s = a.filterField;
                           i || (o && (a.facetName = o), s && (a.facetName = s)), a.values = e.modifyValues(n), r.push(a)
                        }), r
                     } catch (t) {
                        return this.onError("modifyFacetsList", t, i), -1
                     }
                  };

               function ne(t) {
                  try {
                     var e = "0".concat(t.charCodeAt(0).toString(16));
                     return "\\x".concat(e.substr(e.length - 2))
                  } catch (t) {
                     return this.onError("hex", t, i), -1
                  }
               }
               var oe = function (t) {
                     try {
                        var e = t.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/'/g, "'").replace(/"/g, '\\"').replace(/[\x00-\x1F\x80-\x9F]/g, ne);
                        return encodeURIComponent(e)
                     } catch (t) {
                        return (void 0).onError("encodeFacetValue", t, i), -1
                     }
                  },
                  ie = function (t) {
                     try {
                        var e = t.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/'/g, "'").replace(/"/g, '\\"').replace(/[\x00-\x1F\x80-\x9F]/g, ne);
                        return encodeURIComponent(e)
                     } catch (t) {
                        return this.onError("encodeCategoryFacetValue", t, i), -1
                     }
                  },
                  se = function (t) {
                     try {
                        return decodeURIComponent(t).replace(/\\"/g, '"')
                     } catch (t) {
                        return this.onError("decodeFacetValue", t, i), -1
                     }
                  },
                  ce = function (t) {
                     try {
                        return t.replace(/[^\w\d]/g, "")
                     } catch (t) {
                        return this.onError("cleanFacetValue", t, i), -1
                     }
                  },
                  le = function (t) {
                     try {
                        var e = "",
                           r = t.split("%22");
                        return e = 1 === r.length ? function (t, e) {
                           return function (t) {
                              if (Array.isArray(t)) return t
                           }(t) || function (t, e) {
                              var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                              if (null != r) {
                                 var a, n, o, i, s = [],
                                    c = !0,
                                    l = !1;
                                 try {
                                    if (o = (r = r.call(t)).next, 0 === e) {
                                       if (Object(r) !== r) return;
                                       c = !1
                                    } else
                                       for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                                 } catch (t) {
                                    l = !0, n = t
                                 } finally {
                                    try {
                                       if (!c && null != r.return && (i = r.return(), Object(i) !== i)) return
                                    } finally {
                                       if (l) throw n
                                    }
                                 }
                                 return s
                              }
                           }(t, e) || function (t, e) {
                              if (t) {
                                 if ("string" == typeof t) return Zt(t, e);
                                 var r = {}.toString.call(t).slice(8, -1);
                                 return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Zt(t, e) : void 0
                              }
                           }(t, e) || function () {
                              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                           }()
                        }(r, 2)[1] : (r = r.slice(1, -1)).join("%22"), e
                     } catch (t) {
                        return this.onError("cleanEncodedFacetValue", t, i), -1
                     }
                  },
                  ue = function (t, e) {
                     return Object.keys(t).find(function (r) {
                        return t[r] === e
                     }) || e
                  },
                  de = function () {
                     try {
                        return this.state.categoryFilter
                     } catch (t) {
                        return this.onError("getSelectedBucketedFacet", t, i), -1
                     }
                  },
                  pe = function () {
                     try {
                        this.setPageStart(0), this.getResults.bind(this)()
                     } catch (t) {
                        this.onError("applyRangeFacet", t, i)
                     }
                  },
                  he = function (t, e) {
                     try {
                        return t.position > e.position ? 1 : -1
                     } catch (t) {
                        return this.onError("sortFacets", t, i), -1
                     }
                  },
                  fe = function () {
                     try {
                        return this.getFacets().map(function (t) {
                           var e = D(t);
                           return e.facetType = "text", e
                        })
                     } catch (t) {
                        return this.onError("getAllTextFacets", t, i), -1
                     }
                  },
                  ge = function () {
                     try {
                        return this.getRanges().map(function (t) {
                           var e = D(t);
                           return e.facetType = "range", e
                        })
                     } catch (t) {
                        return this.onError("getAllRangeFacets", t, i), -1
                     }
                  },
                  ye = function () {
                     try {
                        return this.getBucketedFacets().map(function (t) {
                           var e = D(t);
                           return e.facetType = "category", e
                        })
                     } catch (t) {
                        return this.onError("getAllCategory", t, i), -1
                     }
                  };

               function ve(t) {
                  try {
                     var e = this.getBreadCrumbs(t),
                        r = [],
                        a = e;
                     if (e)
                        for (var n = function () {
                              if (a.level) {
                                 var t = a,
                                    e = t.level,
                                    n = t.values,
                                    o = t.filterField;
                                 n.forEach(function (t) {
                                    r.push({
                                       level: e,
                                       filterField: o,
                                       value: t.value || t.name
                                    })
                                 })
                              }
                              if (!a.child) return 1;
                              a = a.child
                           }, o = 0; o < this.options.facetDepth && !n(); o++);
                     return r
                  } catch (t) {
                     return this.onError("getBreadCrumbsList.js", t, i), -1
                  }
               }

               function me(t) {
                  try {
                     var e = this.getResponseObj(),
                        r = [];
                     if (e && e.facets && e.facets.multilevel && t) {
                        var a = e.facets.multilevel.list;
                        if (a) a.forEach(function (e) {
                           var a = e.filterField,
                              n = e.breadcrumb;
                           a === t && (r = n)
                        });
                        else {
                           var n = e.facets.multilevel.breadcrumb;
                           r = n || null
                        }
                     }
                     return r
                  } catch (t) {
                     return this.onError("getBreadCrumbs.js", t, i), -1
                  }
               }

               function be(t) {
                  try {
                     this.setSort(t), this.setPageStart(0), this.getResults.bind(this)()
                  } catch (t) {
                     this.onError("applySort.js", t, i)
                  }
               }

               function Se(t) {
                  try {
                     if (void 0 !== t) this.state.selectedSort = t;
                     else {
                        var e = this.getSearchQueryParams();
                        this.state.selectedSort = e.sort ? e.sort : ""
                     }
                  } catch (t) {
                     this.onError("setSort.js", t, i)
                  }
               }
               var Ee = function () {
                  return this.state.selectedSort
               };

               function Pe() {
                  try {
                     var t = this.getResponseObj() || {};
                     return t && t.didYouMean ? t.didYouMean : []
                  } catch (t) {
                     return this.onError("getDidYouMeanFromResponse.js", t, i), -1
                  }
               }

               function Fe() {
                  try {
                     return (this.state.didYouMean || []).map(function (t) {
                        return t.suggestion
                     })
                  } catch (t) {
                     return this.onError("getSpellCheckSuggested.js", t, i), -1
                  }
               }

               function Ae(t) {
                  this.options.spellCheck.enabled = !!t
               }

               function we() {
                  try {
                     var t = this.getResponseObj() || {};
                     return t && t.banner && t.banner.banners && t.banner.banners || []
                  } catch (t) {
                     return this.onError("getbanners.js", t, i), -1
                  }
               }
               var Re = function (t, e) {
                     this.state.userInput = t, this.callBack(this, e, {
                        value: t
                     })
                  },
                  Ue = function () {
                     this.state.selectedFacets = {}, this.state.rangeFacet = {}, this.state.categoryFilter = {}, this.state.breadcrumbs = {}
                  },
                  Ce = function () {
                     this.resetFacets(), this.state.didYouMean = null, this.state.startPageNo = 0, this.state.selectedSort = "", this.state.responseObj = null, this.state.userInput = "", this.state.pageSize = this.state.pageSize || this.options.pagesize.pageSize
                  };

               function Ne(t) {
                  return Ne = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, Ne(t)
               }
               const Oe = function t(e) {
                  if (!e) return e;
                  var r, a = Array.isArray(e) ? [] : {};
                  return Object.keys(e).forEach(function (n) {
                     r = e[n], a[n] = "object" === Ne(r) ? t(r) : r
                  }), a
               };

               function Te(t) {
                  return Te = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
                     return typeof t
                  } : function (t) {
                     return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                  }, Te(t)
               }

               function Le(t) {
                  return function (t) {
                     if (Array.isArray(t)) return je(t)
                  }(t) || function (t) {
                     if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t)
                  }(t) || Ie(t) || function () {
                     throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                  }()
               }

               function Ie(t, e) {
                  if (t) {
                     if ("string" == typeof t) return je(t, e);
                     var r = {}.toString.call(t).slice(8, -1);
                     return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? je(t, e) : void 0
                  }
               }

               function je(t, e) {
                  (null == e || e > t.length) && (e = t.length);
                  for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
                  return a
               }

               function ke(t, e) {
                  var r = Object.keys(t);
                  if (Object.getOwnPropertySymbols) {
                     var a = Object.getOwnPropertySymbols(t);
                     e && (a = a.filter(function (e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable
                     })), r.push.apply(r, a)
                  }
                  return r
               }

               function _e(t) {
                  for (var e = 1; e < arguments.length; e++) {
                     var r = null != arguments[e] ? arguments[e] : {};
                     e % 2 ? ke(Object(r), !0).forEach(function (e) {
                        Ve(t, e, r[e])
                     }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ke(Object(r)).forEach(function (e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e))
                     })
                  }
                  return t
               }

               function Ve(t, e, r) {
                  return (e = Me(e)) in t ? Object.defineProperty(t, e, {
                     value: r,
                     enumerable: !0,
                     configurable: !0,
                     writable: !0
                  }) : t[e] = r, t
               }

               function xe(t, e) {
                  for (var r = 0; r < e.length; r++) {
                     var a = e[r];
                     a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, Me(a.key), a)
                  }
               }

               function Me(t) {
                  var e = function (t) {
                     if ("object" != Te(t) || !t) return t;
                     var e = t[Symbol.toPrimitive];
                     if (void 0 !== e) {
                        var r = e.call(t, "string");
                        if ("object" != Te(r)) return r;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                     }
                     return String(t)
                  }(t);
                  return "symbol" == Te(e) ? e : e + ""
               }
               var Xe = function () {
                  return t = function t(e) {
                     ! function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
                     }(this, t), this.options = _e(_e({}, r), e), this.state = {
                        queryRef: {},
                        userInput: "",
                        responseObj: null,
                        selectedFacets: {},
                        currentWebUrl: "",
                        currentApiUrl: "",
                        didYouMean: null,
                        startPageNo: this.options.startPageNo || 0,
                        isLoading: !1,
                        selectedSort: "",
                        isUrlUpdated: !1,
                        rangeSliderList: [],
                        rangeFacet: {},
                        categoryFilter: {},
                        breadcrumbs: {},
                        urlState: "",
                        noResultQuery: "",
                        pageSize: this.options.pagesize && this.options.pagesize.pageSize ? this.options.pagesize.pageSize : 12,
                        urlLoad: !1,
                        isHistory: window.history,
                        isBack: !1,
                        products: [],
                        requestId: null,
                        unbxdKeys: ["filter", "category-filter", "rows", "start", "page", "count", "sort", "viewType", this.getBrowseQueryParam(), this.getSearchQueryParam(), this.getSortParam(), this.getPageViewParam(), this.getPageSizeParam(), this.getPageNoParam(), "uc_param"]
                     };
                     var a = this.options,
                        n = a.getCategoryId,
                        o = a.setCategoryId,
                        i = "/search?";
                     "CATEGORY" === this.getProductType() && (i = "/category?"), this.getCategoryId = n, this.setCategoryId = o, this.apiUrl = this.getBaseUrl() + i, this.webUrl = this.getBaseUrl() + i
                  }, e = [{
                     key: "getResponseObj",
                     value: function () {
                        try {
                           var t = this.state.responseObj;
                           return t ? Oe(t) : null
                        } catch (t) {
                           this.onError("getResponseObj", t, i)
                        }
                     }
                  }, {
                     key: "orderQueryParams",
                     value: function () {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        try {
                           var e = (this.options || {}).url,
                              r = (void 0 === e ? {} : e).orderOfQueryParams,
                              a = void 0 === r ? [] : r,
                              n = Object.values(t),
                              o = a.filter(function (t) {
                                 return n.includes(t)
                              }),
                              s = n.filter(function (t) {
                                 return !o.includes(t)
                              });
                           return [].concat(Le(o), Le(s))
                        } catch (t) {
                           return this.onError("orderQueryParams", t, i), -1
                        }
                     }
                  }, {
                     key: "getUrlParamString",
                     value: function () {
                        var t = this,
                           e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                           r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        try {
                           var a = Object.keys(r),
                              n = "",
                              o = (this.options || {}).url,
                              s = void 0 === o ? {} : o,
                              c = s.facetsParam,
                              l = void 0 === c ? {} : c,
                              u = s.seoFriendlyUrl,
                              p = s.orderOfQueryParams,
                              h = void 0 === p ? [] : p,
                              f = this.getQueryParamSeparator(),
                              g = this.getSearchQueryParam(),
                              y = this.getBrowseQueryParam(),
                              v = this.getKeyValueSeparator();
                           return u && h.length && (a = Array.from(new Set([this.orderQueryParams(a), a].flat(1)))), a.forEach(function (e, o) {
                              var i = r[e],
                                 s = "";
                              i.forEach(function (r, a) {
                                 "KEY_VALUE_REPLACER" === l.algo && t.isFilterStr(e) ? n = "".concat(n).concat(e).concat(v).concat(r) : "HASH" === l.algo && t.isFilterStr(e) ? (0 === a ? s = r : s += "&".concat(r), n = "".concat(n).concat(e, "=").concat(window.btoa(d.encodeEachFacetValue(decodeURIComponent(s))))) : n = "".concat(n).concat(encodeURIComponent(e)).concat(v).concat(e === g || e === y ? r : encodeURIComponent(r)), a !== i.length - 1 && (n = "".concat(n).concat(f))
                              }), o !== a.length - 1 && (n = "".concat(n).concat(f))
                           }), n.length > 0 && (n = e + n), n
                        } catch (t) {
                           return this.onError("getUrlParamString", t, i), -1
                        }
                     }
                  }, {
                     key: "getUrlStr",
                     value: function (t) {
                        var e = this;
                        try {
                           var r = (this.options || {}).url,
                              a = (void 0 === r ? {} : r).queryParamSeparator,
                              n = this.getQueryParamSeparator(),
                              o = this.getKeyValueSeparator(),
                              s = this.getSearchQueryParam(),
                              c = this.getBrowseQueryParam(),
                              l = {},
                              u = t.split("".concat(n).concat(s).concat(o))[1] || t.split("?".concat(s).concat(o))[1];
                           void 0 !== u && (l[s] = [u.split(a ? n : /\&\w+\-?\w+?=/gi)[0]]);
                           var d = t.split("".concat(n).concat(c).concat(o))[1] || t.split("?".concat(c).concat(o))[1];
                           void 0 !== d && (l[c] = [d.split(a ? n : /\&\w+\-?\w+?=/gi)[0]]);
                           var p = this.readSortWebUrl(t),
                              h = this.readFacetsWebUrl(t),
                              f = this.readPageSizeWebUrl(t),
                              g = this.readPageViewWebUrl(t),
                              y = this.readPageNoWebUrl(t);
                           if (l = _e(_e(_e(_e(_e(_e({}, l), p), h), f), g), y), this.getAllowExternalUrlParams()) {
                              var v = this.readQueryParamsFromUrl(this.getHashMode() ? window.location.hash.slice(1) : window.location.search);
                              Object.keys(v).forEach(function (t) {
                                 var r = v[t];
                                 (e.state.unbxdKeys.indexOf(t) < 0 || "uc_param" === t) && !e.isFilterStr(t) && v[t].length && "" !== r && (l[t] = v[t])
                              })
                           }
                           return this.getUrlParamString(this.getHashMode() ? "#" : "?", l)
                        } catch (t) {
                           return this.onError("getUrlStr", t, i), -1
                        }
                     }
                  }, {
                     key: "urlSearchParamsToStr",
                     value: function () {
                        var t = this,
                           e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        try {
                           var r = {},
                              a = (this.options || {}).url,
                              n = (void 0 === a ? {} : a).facetsParam,
                              o = void 0 === n ? {} : n,
                              s = this.getSearchQueryParam();
                           return Object.entries(e).forEach(function (a) {
                              var n = function (t, e) {
                                    return function (t) {
                                       if (Array.isArray(t)) return t
                                    }(t) || function (t, e) {
                                       var r = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                                       if (null != r) {
                                          var a, n, o, i, s = [],
                                             c = !0,
                                             l = !1;
                                          try {
                                             if (o = (r = r.call(t)).next, 0 === e) {
                                                if (Object(r) !== r) return;
                                                c = !1
                                             } else
                                                for (; !(c = (a = o.call(r)).done) && (s.push(a.value), s.length !== e); c = !0);
                                          } catch (t) {
                                             l = !0, n = t
                                          } finally {
                                             try {
                                                if (!c && null != r.return && (i = r.return(), Object(i) !== i)) return
                                             } finally {
                                                if (l) throw n
                                             }
                                          }
                                          return s
                                       }
                                    }(t, e) || Ie(t, e) || function () {
                                       throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                                    }()
                                 }(a, 2),
                                 i = n[0],
                                 c = n[1];
                              i !== s && e[i].length && "" !== c && ("HASH" === o.algo && t.isFilterStr(decodeURIComponent(i)) ? r[i] = [window.atob(e[i])] : r[i] = e[i]), i === s && (r[s] = d.encodeQueryParam(e[i]))
                           }), this.getUrlParamString(this.getHashMode() ? "#" : "?", r)
                        } catch (t) {
                           return this.onError("urlSearchParamsToStr", t, i), -1
                        }
                     }
                  }, {
                     key: "checkIfUnbxdKey",
                     value: function () {
                        var t = this;
                        try {
                           var e = new URLSearchParams(this.getHashMode() ? window.location.hash.substring(1) : window.location.search),
                              r = !1;
                           return Object.keys(e).forEach(function (e) {
                              t.state.unbxdKeys.indexOf(e) > -1 && (r = !0)
                           }), r
                        } catch (t) {
                           this.onError("checkIfUnbxdKey", t, i)
                        }
                     }
                  }, {
                     key: "convertToHashString",
                     value: function (t) {
                        try {
                           var e = this.getUrlStr(t);
                           return "?" === e.charAt(0) && (e = e.substring(1)), e
                        } catch (t) {
                           this.onError("convertToHashString", t, i)
                        }
                     }
                  }, {
                     key: "setUrl",
                     value: function (t) {
                        try {
                           var e = this.options,
                              r = e.searchPath,
                              a = e.onQueryRedirect,
                              n = this.getProductType(),
                              o = this.state,
                              s = o.urlLoad,
                              c = o.isHistory,
                              l = o.responseObj,
                              u = void 0 === l ? {} : l,
                              d = u.redirect,
                              p = u.didYouMean,
                              h = void 0 === p ? [] : p;
                           if ("function" == typeof a && d && d.value) {
                              this.state.userInput = "";
                              var f = this.getUrlStr("redirected=true");
                              return this.getHashMode() && (f = "#".concat(this.convertToHashString(f))), void a(this, d, f)
                           }
                           var g = this.getNewUrlState(!1).split("".concat(n.toLocaleLowerCase(), "?"))[1];
                           this.state.urlState = g;
                           var y = window.location.pathname.includes(r);
                           if (h.length && h[0].suggestion ? this.state.queryRef = {
                                 replaceNext: !0
                              } : this.state.queryRef.replaceNext && (this.state.queryRef = {}), this.getHashMode()) {
                              var v = "#".concat(g);
                              if (y && v !== window.location.hash) {
                                 var m = this.convertToHashString(g);
                                 this.setRoutingStrategies(m)
                              }
                           } else {
                              var b = "?".concat(g),
                                 S = this.getUrlStr(b);
                              c && !s && y && (decodeURI(S) !== decodeURI(window.location.search) && this.setRoutingStrategies("".concat(S)), this.state.urlLoad = !1), t && y && (window.location.search = S)
                           }
                        } catch (t) {
                           return this.onError("setUrl", t, i), -1
                        }
                     }
                  }, {
                     key: "updateSelectedFacetsCount",
                     value: function () {
                        var t = this;
                        try {
                           var e = "",
                              r = this.options.url,
                              a = (void 0 === r ? {} : r).facetsParam,
                              n = void 0 === a ? {} : a,
                              o = this.getSearchQueryParam(),
                              s = this.getBrowseQueryParam(),
                              c = this.getKeyValueSeparator();
                           e = "KEY_VALUE_REPLACER" !== n.algo && "HASH" !== n.algo || n.showFilterStr ? this.getQueryParams() : this.getCustomQueryParams();
                           var l = this.getProductType(),
                              u = o;
                           if ("SEARCH" !== l && (e[u = s] = this.getCategoryId()), "object" === Te(e) && e[u]) {
                              var d = e["KEY_VALUE_REPLACER" === n.algo ? n.filterReplacer : "filter"];
                              if ("KEY_VALUE_REPLACER" === n.algo && !n.showFilterStr) {
                                 var p = [];
                                 Object.keys(e).forEach(function (r) {
                                    t.isFilterStr(decodeURIComponent(r)) && (p.length, p.push(r + c + e[r]))
                                 }), d = p
                              }
                              var h = this.getFilterFromParams(d);
                              this.state.selectedFacets = n.addToUrl ? h.selectedFilters : this.state.selectedFacets
                           }
                        } catch (t) {
                           this.onError("updateSelectedFacetsCount", t, i)
                        }
                     }
                  }, {
                     key: "callBack",
                     value: function (t, e) {
                        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        try {
                           (0, this.options.onEvent)(this, e, r)
                        } catch (t) {
                           this.onError("callback", t, i)
                        }
                     }
                  }, {
                     key: "onError",
                     value: function (t) {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                           e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                           r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
                           a = this.options,
                           n = a.debugMode;
                        (0, a.onEvent)(this, r, {
                           error: e
                        }), n && console.error("Something went wrong in ".concat(t, ": ").concat(e))
                     }
                  }], e && xe(t.prototype, e), Object.defineProperty(t, "prototype", {
                     writable: !1
                  }), t;
                  var t, e
               }();
               ! function (t) {
                  var e = t.prototype;
                  e.changeInput = Re, e.resetFacets = Ue, e.resetAll = Ce,
                     function (t) {
                        t = Object.assign(t, U)
                     }(e),
                     function (t) {
                        Object.assign(t, {
                           setPageStart: C,
                           getPaginationInfo: N,
                           setPageSize: O
                        })
                     }(e),
                     function (t) {
                        t = Object.assign(t, {
                           setProductAttributes: T,
                           setShowVariants: L,
                           setVariantsCount: I,
                           setVariantAttributes: j,
                           setVariantsGroupBy: k,
                           getSearchResults: V,
                           getSearchMeta: _,
                           getSearchQueryParams: x,
                           getSearchQuery: M,
                           getResults: q,
                           processVariantMap: G,
                           getProductByPropValue: $,
                           setStateFromData: Z,
                           setSearchConfigurations: J,
                           onLocationChange: tt,
                           getRequestId: et
                        })
                     }(e),
                     function (t) {
                        Object.assign(t, {
                           getSwatches: rt
                        })
                     }(e),
                     function (t) {
                        t = Object.assign(t, {
                           getBucketedFacets: at,
                           getSelectedBucketedFacet: de,
                           getFilterFromParams: nt,
                           getCategoryFilterFromParams: ot,
                           getRangeFacets: it,
                           getFacets: st,
                           getSelectedFacets: ct,
                           getSelectedFacet: lt,
                           updateFacets: ut,
                           applyFacets: dt,
                           clearFacets: pt,
                           addFacets: gt,
                           findSelectedFacet: yt,
                           deleteCategoryFilter: vt,
                           deleteFacet: mt,
                           getFacetByValue: Ft,
                           getSelectedFacetValue: At,
                           setCategoryFilter: wt,
                           setDefaultCategoryFilter: Rt,
                           setRangeFacet: Ut,
                           clearARangeFacet: Ct,
                           deleteAFacet: Nt,
                           applyRangeFacet: pe,
                           isFacetAlreadyAdded: Ot,
                           getSelectedRanges: Tt,
                           getRanges: _t,
                           sortFacets: he,
                           isCategoryFacet: Vt,
                           getAllFacets: Xt,
                           getAFacetByName: Dt,
                           getSelectedMultilevelFacet: Bt,
                           getAllTextFacets: fe,
                           getAllRangeFacets: ge,
                           getAllCategory: ye,
                           getAllSelectedFacets: Kt,
                           getSelectedFacetsCount: qt,
                           getSelectedFacetValueCount: Yt,
                           encodeFacetValue: oe,
                           modifyFacetsList: ae,
                           modifyValues: re,
                           decodeFacetValue: se,
                           cleanFacetValue: ce,
                           getCategoryFacetByValue: Gt,
                           encodeCategoryFacetValue: ie,
                           cleanEncodedFacetValue: le,
                           getKeyByValue: ue
                        })
                     }(e),
                     function (t) {
                        t = Object.assign(t, {
                           getBreadCrumbsList: ve,
                           getBreadCrumbs: me
                        })
                     }(e),
                     function (t) {
                        t = Object.assign(t, {
                           applySort: be,
                           getSelectedSort: Ee,
                           setSort: Se
                        })
                     }(e),
                     function (t) {
                        t = Object.assign(t, {
                           getDidYouMeanFromResponse: Pe,
                           getSpellCheckSuggested: Fe,
                           setSpellCheck: Ae
                        })
                     }(e),
                     function (t) {
                        t = Object.assign(t, {
                           getBanners: we
                        })
                     }(e)
               }(Xe);
               const De = Xe;
               return e.default
            })(), t.exports = e()
         },
         330(t) {
            "use strict";
            t.exports = JSON.parse('{"name":"@unbxd-ui/vanilla-search-library","version":"2.1.14","description":"A JavaScript library for building performant and quick search experiences with Unbxd","main":"public/dist/js/vanillaSearch.js","repository":{"type":"git","url":"git+https://github.com/unbxd/search-JS-library.git"},"bugs":{"url":"https://github.com/unbxd/search-JS-library/issues"},"homepage":"https://github.com/unbxd/search-JS-library#readme","scripts":{"start":"webpack-dev-server --open --config ./webpack/webpack.config.js","build":"webpack --config ./webpack/webpack.prod.config.js","server":"http-server ./public","generate-docs":"jsdoc -c ./docs/jsDoc.json ","upload-s3":"node s3Upload.js","build:dev":"webpack --config ./webpack/webpack.dev.build.js","test":"webpack --config ./webpack/webpack.dev.build.js","prepare":"husky install","pre-commit":"lint-staged"},"devDependencies":{"@babel/core":"^7.26.9","@babel/node":"^7.10.5","@babel/plugin-proposal-class-properties":"^7.10.4","@babel/plugin-proposal-export-default-from":"^7.10.4","@babel/plugin-syntax-dynamic-import":"^7.8.3","@babel/plugin-transform-arrow-functions":"^7.10.4","@babel/preset-env":"^7.26.9","@babel/preset-react":"^7.26.3","autoprefixer":"^9.8.6","babel-loader":"^8.4.1","compression-webpack-plugin":"^11.1.0","css-loader":"^3.6.0","css-minimizer-webpack-plugin":"^7.0.0","eslint":"^8.54.0","file-loader":"^6.2.0","html-loader":"^5.1.0","html-webpack-inline-source-plugin":"0.0.10","html-webpack-plugin":"^5.6.3","http-server":"^14.1.1","husky":"^8.0.0","jsdoc":"^4.0.4","lint-staged":"^14.0.1","minami":"^1.2.3","mini-css-extract-plugin":"^2.9.2","node-forge":">=0.10.0","path":"^0.12.7","postcss-loader":"^3.0.0","prettier":"1.19.1","sass":"^1.85.1","sass-loader":"^8.0.2","style-loader":"^1.3.0","terser-webpack-plugin":"^4.2.3","url-loader":"^4.1.1","webpack":"^5.98.0","webpack-bundle-analyzer":"^4.10.2","webpack-cli":"^5.1.4","webpack-dev-server":"^4.15.2","webpack-s3-plugin":"^0.1.0"},"keywords":["unbxd","search library","ecommerce search"],"author":"Unbxd","license":"ISC","dependencies":{"@unbxd-ui/unbxd-search-core":"0.5.13","babel-runtime":"^6.26.0","dompurify":"^3.2.4","element-dataset":"^2.2.6"},"lint-staged":{"src/**/*.+(js|json|ts|tsx)":["eslint --no-verify"],"src/**/*.{js,jsx,ts,tsx,json,css,scss,md}":["prettier --write"]}}')
         }
      },
      e = {};

   function r(a) {
      var n = e[a];
      if (void 0 !== n) return n.exports;
      var o = e[a] = {
         exports: {}
      };
      return t[a].call(o.exports, o, o.exports, r), o.exports
   }
   r.n = t => {
      var e = t && t.__esModule ? () => t.default : () => t;
      return r.d(e, {
         a: e
      }), e
   }, r.d = (t, e) => {
      for (var a in e) r.o(e, a) && !r.o(t, a) && Object.defineProperty(t, a, {
         enumerable: !0,
         get: e[a]
      })
   }, r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
   var a = {};
   return (() => {
      "use strict";
      r.d(a, {
         default: () => Pe
      });
      var t = r(759),
         e = r.n(t);
      const n = {
         beforeApiCall: "BEFORE_API_CALL",
         afterApiCall: "AFTER_API_CALL",
         beforeRender: "BEFORE_RENDER",
         beforeNoResultRender: "BEFORE_NO_RESULTS_RENDER",
         afterNoResultRender: "AFTER_NO_RESULTS_RENDER",
         afterRender: "AFTER_RENDER",
         deleteFacet: "DELETE_FACET",
         facetClick: "FACETS_CLICK",
         deleteFacetValue: "DELETE_FACET_VALUE",
         clearSort: "CLEAR_SORT",
         changeSort: "CHANGE_SORT",
         pageNext: "PAGE_NEXT",
         pagePrev: "PAGE_PREV",
         changeInput: "CHANGE_INPUT",
         setCategoryFilter: "SET_CATEGORY_FILTER",
         deleteCategoryFilter: "DELETE_CATEGORY_FILTER",
         pageSizeChange: "PAGESIZE_CHANGE",
         configError: "CONFIG_ERROR",
         runtimeError: "RUNTIME_ERROR",
         fetchError: "FETCH_ERROR"
      };
      const o = {
         clearCategoryFilter: "clearCategoryFilter",
         setCategoryFilter: "setCategoryFilter",
         changeSwatch: "changeSwatch",
         clearPriceRange: "clearPriceRange",
         applyRange: "applyRange",
         prev: "prev",
         next: "next",
         firstPage: "firstPage",
         lastPage: "lastPage",
         clearSort: "clearSort",
         changeSort: "changeSort",
         deleteFacet: "deleteFacet",
         deleteFacetValue: "deleteFacetValue",
         changeFacet: "changeFacet"
      };
      var i = {
            openFacet: "UNX-accordian-open",
            closeFacet: "UNX-accordian-close",
            openBtn: "UNX-facet-open",
            closeBtn: "UNX-facet-close",
            viewMore: "UNX-view-more",
            viewLess: "UNX-view-less"
         },
         s = {
            UNX_gridBtn: "UNX_gridBtn",
            UNX_listBtn: "UNX_listBtn",
            UNX_loadMore: "UNX_loadMore",
            UNX_variant: "UNX_variant",
            UNX_spellCheck: "UNX_spellCheck",
            UNX_pagesize: "UNX_pagesize",
            UNX_pageNumber: "UNX_pageNumber",
            UNX_unbxdSorter: "UNX_unbxdSorter",
            UNX_uFilter: "UNX_uFilter",
            UNX_rangeslider: "UNX_rangeslider",
            UNX_facetLevel: "UNX_facetLevel",
            UNX_searchFacets: "UNX_searchFacets",
            UNX_swatchClrBtn: "UNX_swatchClrBtn"
         };
      const c = function (t, e, r, a) {
         try {
            t.addEventListener(e, function (t) {
               for (var e = t.target; e && e !== this;) e.matches(r) && a.call(e, t), e = e.parentNode
            })
         } catch (t) {
            this.onError("delegate.js", t, n.runtimeError)
         }
      };

      function l(t, e) {
         var r = t.facetName,
            a = t.facetType,
            n = e.name,
            o = e.count,
            i = e.dataId,
            s = this.options.facet,
            c = s.facetClass,
            l = s.selectedFacetClass,
            u = s.removeFacetsSelectorClass,
            d = this.testIds.UNX_uFilter,
            p = "deleteSelectedFacetValue";
         "range" === a && (p = "deleteSelectedRange");
         var h = " ".concat(c, " ").concat(l, " ");
         return ['<div class="UNX-selected-facets-wrap">', '<button data-test-id="'.concat(d, '" class="UNX-selected-facet-btn UNX-change-facet ').concat(h, '" data-facet-name="').concat(r, '" data-facet-action="').concat(p, '" data-id="').concat(i, '">'), '<span class="UNX-facet-text">'.concat(n, '</span> <span class="UNX-facet-count">(').concat(o, ")</span>"), "</button>", '<button class="UNX-delete-facet '.concat(u, " ").concat(h, '" data-id="').concat(i, '" data-facet-action="').concat(p, '" data-facet-name="').concat(r, '">x</button></div>')].join("")
      }

      function u(t, e, r) {
         var a = e.clearAllText,
            n = e.clearFacetsSelectorClass,
            o = this.selectedFacetClass ? this.selectedFacetClass : r.selectedFacetClass;
         return t.length > 0 ? ['<div class="UNX-facets-selections">', '<h5 class="UNX-selected-facet-header">Selected Filters</h5>', '<div class="UNX-selected-facets-inner">'.concat(t, "</div>"), '<button class="'.concat(n, " ").concat(o, '" data-facet-action="clearAllFacets">').concat(a, "</button>"), "</div>"].join("") : ""
      }
      const d = function (t, e) {
         if (!t) return "";
         var r = t || {},
            a = r.currentPage,
            n = r.isNext,
            o = r.isPrev,
            i = r.noOfPages,
            s = r.productsLn,
            c = r.numberOfProducts,
            l = r.rows,
            u = e || {},
            d = u.pageClass,
            p = u.selectedPageClass,
            h = u.pageLimit,
            f = this.testIds.UNX_pageNumber,
            g = void 0 === f ? "" : f;
         if (c <= s) return "";
         var y = '<button class="UNX-next-btn UNX-page-next '.concat(d, '" data-page-no="').concat(a * l, '" data-page-action="next">Next <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z"/></svg></button>'),
            v = '<button class="UNX-prev-btn UNX-page-prev '.concat(d, '" data-page-no="').concat((a - 2) * l, '" data-page-action="prev"><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M576-240 336-480l240-240 51 51-189 189 189 189-51 51Z"/></svg> Prev</button>'),
            m = '<button class="UNX-prev-btn UNX-page-next '.concat(d, '"  data-page-action="firstPage"><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M432-240 192-480l240-240 51 51-189 189 189 189-51 51Zm285 0L477-480l240-240 51 51-189 189 189 189-51 51Z"/></svg></button>'),
            b = '<button class="UNX-prev-btn UNX-page-prev '.concat(d, '"  data-page-action="lastPage"><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M381-480 192-669l51-51 240 240-240 240-51-51 189-189Zm285 0L477-669l51-51 240 240-240 240-51-51 189-189Z"/></svg></button>'),
            S = "",
            E = i < h ? i : h,
            P = 1,
            F = Math.ceil(h / 2),
            A = a - F;
         A > 0 && (P = A, E = a + F);
         var w = a + F;
         w >= i && ((P -= w - i) <= 0 && (P = 1), E = i);
         for (var R = P; R <= E; R++) {
            var U = "".concat(g).concat(R),
               C = R === a ? p : "";
            S += '<button data-test-id="'.concat(U, '" data-page-action="paginate" data-page-no="').concat((R - 1) * l, '" class="UNX-page-button ').concat(d, " ").concat(C, '">').concat(R, "</button>")
         }
         return n || (y = '<button disabled class="UNX-next-btn UNX-page-next">Next <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z"/></svg></button>', b = '<button disabled class="UNX-next-btn UNX-page-next"><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M381-480 192-669l51-51 240 240-240 240-51-51 189-189Zm285 0L477-669l51-51 240 240-240 240-51-51 189-189Z"/></svg></button>'), o || (v = '<button disabled class="UNX-prev-btn UNX-page-prev"><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M576-240 336-480l240-240 51 51-189 189 189 189-51 51Z"/></svg> Prev</button>', m = '<button disabled class="UNX-prev-btn UNX-page-next"><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#1f1f1f"><path d="M432-240 192-480l240-240 51 51-189 189 189 189-51 51Zm285 0L477-480l240-240 51 51-189 189 189 189-51 51Z"/></svg></button>'), ['<div class="UNX-pagination-block">', m, v, '<div class="UNX-page-no-block">'.concat(S, "</div>"), y, b, "</div>"].join("")
      };

      function p(t) {
         var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).pageClass,
            r = void 0 === e ? "" : e;
         return '<div class="UNX-click-scroll"><button data-test-id="'.concat(this.testIds.UNX_loadMore, '" data-page-action="next" class="UNX-click-n-scroll ').concat(r, '">Load More</button></div>')
      }
      const h = function (t, e, r, a) {
         var n = "",
            o = a.multiLevelFacetSelectorClass,
            i = a.facetClass,
            s = this.testIds.UNX_facetLevel;
         e && e.forEach(function (t) {
            var e = t.level,
               r = t.filterField,
               a = t.value,
               c = 'data-test-id="'.concat(s).concat(e, '"'),
               l = "".concat(o, "  UNX-category-level-").concat(e);
            n += ["<button ".concat(c, ' data-parent="').concat(r, '" data-level="').concat(e, '" data-name="').concat(a, '"'), 'class=" '.concat(l, " UNX-selected-crumb ").concat(i, '" data-action = "clearCategoryFilter">'), '<span class="UNX-category-icon"></span><label class="UNX-facet-text">'.concat(decodeURIComponent(a), "</label>"), "</button>"].join("")
         });
         var c = t.level,
            l = t.values,
            u = t.filterField,
            d = t.multiLevelField;
         d || (d = u);
         var p = 'data-test-id="'.concat(s).concat(c, '"'),
            h = "UNX-category-level-".concat(c),
            f = l.map(function (t) {
               var e = t.name,
                  a = t.count,
                  n = t.dataId;
               return r && r.length > 0 && e.toUpperCase().indexOf(r.toUpperCase()) < 0 && (i += " UNX-search-hidden"), ["<button ".concat(p, ' data-parent="').concat(d, '" data-level="').concat(c, '"'), 'class="'.concat(o, " ").concat(h, " ").concat(i, '" data-name="').concat(n, '" data-action = "setCategoryFilter">'), '<label class="UNX-facet-text">'.concat(e, '</label><label class="UNX-facet-count">(').concat(a, ")</label></button>")].join("")
            });
         return "" !== (n += '<div class="UNX-category-values">'.concat(f.join(""), "</div>")) ? ['<div class="UNX-multi-facet-wrap">', "".concat(n, "</div>")].join("") : ""
      };
      const f = function () {
         var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            e = "",
            r = ((arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {}).selectorClass,
            a = void 0 === r ? "" : r;
         return t && t.forEach(function (t, r) {
            var n = t.level,
               o = t.filterField,
               i = t.value,
               s = "".concat(a, " UNX-bread-crumb-item");
            r > 0 && (e += '<span class="UNX-slash"> / </span>'), e += ['<button data-parent="'.concat(o, '" data-level="').concat(n, '" class="').concat(s, '" data-name="').concat(i, '" data-action = "clearCategoryFilter">'), "".concat(decodeURIComponent(i), "</button>")].join("")
         }), '<div class="bread-crumb-main">'.concat(e, "</div>")
      };
      const g = function (t) {
         var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {},
            r = e.options,
            a = void 0 === r ? [] : r,
            n = e.pageSizeClass,
            o = void 0 === n ? "" : n,
            i = e.selectedPageSizeClass,
            s = void 0 === i ? "" : i,
            c = this.testIds.UNX_pagesize,
            l = void 0 === c ? "" : c,
            u = '<label class="UNX-hidden" for="unxPageSize">Sort By</label><div class="NX-select-pagesize-wrapper"><select id="unxPageSize" name="unxPageSize" class="UNX-select-pagesize '.concat(o, '"></div>');
         return a && a.forEach(function (e, r) {
            var a = 'data-test-id="'.concat(l).concat(r + 1, '"');
            u += t == e ? "<option selected ".concat(a, ' class="').concat(s, '" id="').concat(e, '">').concat(e, "</option>") : "<option ".concat(a, ' id="').concat(e, '">').concat(e, "</option>")
         }), '<div class="UNX-pagesize-block">'.concat(u += "</select>", "</div>")
      };
      const y = {
         productId: "uniqueId",
         searchBoxEl: null,
         searchButtonEl: null,
         siteKey: "demo-spanish-unbxd809051588861207",
         apiKey: "f19768e22b49909798bc2411fa3dd963",
         searchPath: "",
         searchTrigger: "click",
         searchEndPoint: "https://search.unbxd.io/",
         products: {
            el: null,
            template: function (t, e, r, a, n) {
               var o = t.unxTitle,
                  i = t.unxImageUrl,
                  s = t.uniqueId,
                  c = t.unxStrikePrice,
                  l = t.unxPrice,
                  u = t.unxDescription,
                  d = n.productItemClass,
                  p = n.defaultImage,
                  h = Array.isArray(i) ? i[0] : i;
               h || (h = p);
               var f = '<div class="UNX-img-wrapper"><img class="UNX-img-block" width="100%" height="100%" alt="'.concat(o, '" src="').concat(h, '"/></div>'),
                  g = '<span class="UNX-sale-price">'.concat(l, "</span>"),
                  y = "";
               c && (y = '<span class="UNX-strike-price">'.concat(c, "<span>"));
               var v = "",
                  m = "";
               "GRID" === a ? v = "UNX-grid-card" : (v = "UNX-list-card", m = '<p class="UNX-description">'.concat(u, "</p>"));
               var b = "",
                  S = r || {},
                  E = S.btnList,
                  P = S.imgList;
               return E && (b = '<div class="UNX-swatch-wrapper">'.concat(E, "</div>")), P && (f = P), ['<div id="'.concat(s, '" data-id="').concat(s, '" data-prank="').concat(e, '" data-item="product" class="UNX-product-col ').concat(v, " ").concat(d, '">'), '<h3 class="UNX-product-number">'.concat(Math.floor(e), "</h3>"), '<div class="UNX-images-block">'.concat(f, "</div>"), '<div class="UNX-product-content">', '<h3 class="UNX-product-title">'.concat(o, "</h3>"), b, m, '<div class="UNX-price-row">'.concat(g, " ").concat(y, "</div>"), "</div>", "</div>"].join("")
            },
            productItemClass: "product-item",
            productType: "SEARCH",
            gridCount: 1,
            searchTrigger: "click",
            onProductClick: function (t, e) {},
            productAttributes: ["title", "uniqueId", "price", "sku", "imageUrl", "displayPrice", "salePrice", "sortPrice", "productDescription", "unbxd_color_mapping", "colorName", "color", "productUrl"],
            attributesMap: {
               unxTitle: "title",
               unxImageUrl: "imageUrl",
               unxPrice: "salePrice",
               unxStrikePrice: "displayPrice",
               unxId: "uniqueId",
               unxDescription: "productDescription"
            },
            defaultImage: "https://libraries.unbxdapi.com/sdk-assets/defaultImage.svg",
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-search-results-block UNX-result-wrapper"
            },
            events: {}
         },
         defaultFilters: {},
         noResults: {
            template: function (t) {
               return '<div class="UNX-no-results"> No Results found '.concat(t, " </div>")
            }
         },
         onEvent: function (t, e) {},
         startPageNo: 0,
         productView: {
            enabled: !0,
            el: null,
            template: function (t) {
               var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
               try {
                  var r = !this.getSearchResults(),
                     a = e.selectedViewTypeClass,
                     o = void 0 === a ? "" : a,
                     i = e.viewTypeClass,
                     s = void 0 === i ? "" : i,
                     c = this.testIds,
                     l = c.UNX_gridBtn,
                     u = void 0 === l ? "" : l,
                     d = c.UNX_listBtn,
                     p = void 0 === d ? "" : d,
                     h = "UNX-list-btn ".concat(s),
                     f = "UNX-grid-btn ".concat(s),
                     g = "data-test-id=".concat(u),
                     y = "data-test-id=".concat(p);
                  "LIST" === t && (h += " ".concat(o)), "GRID" === t && (f += " ".concat(o));
                  var v = '<button id="listBtn" class="'.concat(h, '" ').concat(y, ' data-view-action="LIST" >List</button>'),
                     m = "<button ".concat(g, ' id="gridBtn" class="').concat(f, '" data-view-action="GRID" >Grid</button>');
                  return r && (v = "<button ".concat(y, ' id="listBtn" disabled class="').concat(h, ' disabled-btn" data-view-action="LIST" >List</button>'), m = "<button ".concat(g, ' id="gridBtn" disabled class="').concat(f, '  disabled-btn"data-view-action="GRID" >Grid</button>')), "".concat(v, " ").concat(m)
               } catch (t) {
                  this.onError("productViewtype > renderProductViewType", t, n.runtimeError)
               }
            },
            action: "click",
            viewTypeClass: "UNX-product-view",
            selectedViewTypeClass: "UNX-selected-product-view",
            defaultViewType: "GRID",
            tagName: "DIV",
            htmlAttributes: {
               class: "product-view-container"
            },
            events: {}
         },
         loader: {
            template: function () {
               return '<div class="UNX-loader">Loading search results....</div>'
            },
            el: null
         },
         variants: void 0,
         extraParams: {
            version: "V2"
         },
         spellCheck: {
            enabled: !0,
            el: null,
            template: function (t, e) {
               var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                  a = r || {},
                  n = a.start,
                  o = a.productsLn,
                  i = a.numberOfProducts,
                  s = this.options.spellCheck,
                  c = s.selectorClass,
                  l = void 0 === c ? "" : c,
                  u = s.enabled,
                  d = t;
               if ("SEARCH" !== this.options.productType) {
                  var p = this.getCategoryId() || "",
                     h = decodeURIComponent(p).split(">");
                  d = h[h.length - 1] || h[0];
                  d = d.replace(/^categoryPath:["']?/, "").replace(/["']$/, "")
               }
               var f = this.testIds.UNX_spellCheck,
                  g = void 0 === f ? "" : f,
                  y = e ? '<p class="UNX-no-result"> Your search "<strong>'.concat(e, '</strong>" did not match any products. Did you mean <button data-test-id="').concat(g, '" data-action="getSuggestion" class="').concat(l, '">').concat(t, "</button>? </p>") : "",
                  v = "",
                  m = "";
               return i > 0 && (m = '<span class="UNX-result-info">  -  '.concat(n + 1, " to ").concat(o + n, " of ").concat(i, " products</span>")), r && Object.keys(r).length > 0 && d && (u || (d = e || t), v = '<p class="UNX-suggestion-p">Showing results for <strong>'.concat(d, "</strong> ").concat(m, "</p>")), ['<div class="UNX-spellcheck-block">', y, v, "</div>"].join("")
            },
            selectorClass: "UNX-suggestion",
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-spellcheck-wrapper"
            },
            events: {}
         },
         breadcrumb: {
            enabled: !0,
            el: null,
            selectorClass: "UNX-bread-crumb",
            template: f,
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-breadcrumbs-block"
            },
            events: {}
         },
         url: {
            updateUrls: !0,
            hashMode: !1,
            allowExternalUrlParams: !1,
            seoFriendlyUrl: !1,
            searchQueryParam: {
               addToUrl: !0,
               algo: "KEY_VALUE_REPLACER",
               keyReplacer: "q"
            },
            browseQueryParam: {
               addToUrl: !0,
               algo: "KEY_VALUE_REPLACER",
               keyReplacer: "p"
            },
            orderOfQueryParams: [],
            queryParamSeparator: "&",
            keyValueSeparator: "=",
            pageViewParam: {
               addToUrl: !1,
               algo: "KEY_VALUE_REPLACER",
               keyReplacer: "viewType",
               valuesReplacer: {
                  GRID: "GRID",
                  LIST: "LIST"
               }
            },
            sortParam: {
               addToUrl: !0,
               algo: "KEY_VALUE_REPLACER",
               keyReplacer: "sort",
               valueReplacer: {}
            },
            pageSizeParam: {
               addToUrl: !0,
               algo: "KEY_VALUE_REPLACER",
               keyReplacer: "rows"
            },
            pageNoParam: {
               addToUrl: !0,
               algo: "KEY_VALUE_REPLACER",
               keyReplacer: "start",
               usePageNo: !1
            },
            facetsParam: {
               addToUrl: !0,
               algo: "KEY_VALUE_REPLACER",
               showFilterStr: !1,
               filterReplacer: "filter",
               multiValueSeparator: ",",
               valueReplacer: {},
               keyReplacer: {},
               rangeSeparator: "-",
               rangeFacets: []
            }
         },
         sort: {
            enabled: !0,
            el: null,
            selectedSortClass: "UNX-selected-sort",
            sortClass: "UNX-sort-item",
            template: function (t) {
               var e = "",
                  r = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {},
                  a = r.options,
                  n = void 0 === a ? [] : a,
                  o = r.sortClass,
                  i = void 0 === o ? "" : o,
                  s = r.selectedSortClass,
                  c = void 0 === s ? "" : s,
                  l = this.testIds.UNX_unbxdSorter,
                  u = void 0 === l ? "" : l;
               return n && n.forEach(function (r) {
                  var a = r.value,
                     n = void 0 === a ? "" : a,
                     o = r.text,
                     i = void 0 === o ? "" : o;
                  e += n == t ? '<option value="'.concat(n, '" class="').concat(c, '" selected>').concat(i, "</option>") : '<option value="'.concat(n, '">').concat(i, "</option>")
               }), ['<div class="UNX-sort-block">', '<span class="UNX-sort-header">Sort By</span>', '<label class="UNX-hidden" for="unxSortSelect">Sort By</label>', '<div class="block__short-facets"> <select data-test-id="'.concat(u, '" name="unxSortSelect" data-action="changeSort" id="unxSortSelect" class="').concat(i, '">'), '<option value="">Relevancy</option>', e, "</select> </div>", "</div>"].join("")
            },
            options: [{
               value: "price desc",
               text: "Price High to Low"
            }, {
               value: "price asc",
               text: " Price Low to High"
            }],
            action: "change",
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-sort-block-lb"
            },
            events: {}
         },
         selectedFacets: {
            enabled: !0,
            selectedFacetClass: "UNX-selected-facet-btn",
            el: null,
            template: u,
            itemTemplate: l,
            clearAllText: "Clear All",
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-selected-facet-lb"
            },
            events: {},
            facetAction: "click",
            clearFacetsSelectorClass: "UNX-clear-facet",
            removeFacetsSelectorClass: "UNX-remove-facet"
         },
         facet: {
            facetsEl: null,
            facetTemplate: function (t, e, r, a, n) {
               var o = t.displayName,
                  i = t.facetName,
                  s = t.facetType,
                  c = t.values,
                  l = n.facetClass,
                  u = n.applyMultipleFilters,
                  d = n.isCollapsible,
                  p = n.isSearchable,
                  h = n.searchPlaceHolder,
                  f = n.textFacetWrapper,
                  g = n.enableViewMore,
                  y = n.viewMoreText,
                  v = n.viewMoreLimit,
                  m = n.actionBtnClass,
                  b = n.actionChangeClass,
                  S = n.applyButtonText,
                  E = n.clearButtonText,
                  P = "",
                  F = "",
                  A = this.getSelectedFacets()[i],
                  w = !!(A && A.length > 0);
               g && "text" === s && c.length > v && (F = "UNX-view-more", document.querySelector(":root").style.setProperty("--viewMoreHeight", "".concat(32 * v, "px")), P = '<div class="UNX-view-more-row "><button class="'.concat(m, '" data-facet-name="').concat(i, '" data-action="viewMore" data-id="').concat(y[0], '">').concat(y[0], "</button></div>"));
               var R = "",
                  U = "";
               w && (R = '<button class="UNX-facet-clear '.concat(l, ' "data-facet-action="deleteFacet" data-facet-name="').concat(i, '">').concat(E, "</button>")), u && w && (U = '<button class="UNX-facet-primary '.concat(l, ' "data-facet-action="applyFacets" >').concat(S, "</button>"));
               var C = "",
                  N = "";
               return d && (C = r ? '<div class="UNX-facet-header '.concat(m, ' UNX-facet-open"  data-facet-name="').concat(i, '" data-facet-action="facetClose"> <h3>').concat(o, "</h3> </div>") : '<div class="UNX-facet-header '.concat(m, ' UNX-facet-close"  data-facet-name="').concat(i, '" data-facet-action="facetOpen"> <h3>').concat(o, "</h3></div>")), p && null !== a && (N = '<div class="UNX-searchable-facets"><label class="UNX-hidden" for="'.concat(i, '_searchBox">').concat(h, '</label><input  id="').concat(i, '_searchBox" name="').concat(i, '_searchBox" data-test-id="').concat(this.testIds.UNX_searchFacets, '" class="UNX-facet-search ').concat(b, '" value="').concat(a, '"  data-facet-name="').concat(i, '" data-facet-action="searchFacets" type="text" placeholder="').concat(h, '"/></div>')), ['<div class="UNX-text-facet-wrap">', C, '<div class="UNX-facets-all">', N, '<div class="UNX-facets '.concat(f, " ").concat(F, '">').concat(e, "</div>"), P, '<div class="UNX-facet-footer">'.concat(U, " ").concat(R, "</div>"), "</div>", "</div>"].join("")
            },
            facetItemTemplate: function (t, e, r) {
               var a = t.facetName,
                  n = t.isSelected,
                  o = e.name,
                  i = e.count,
                  s = e.dataId,
                  c = this.options.facet,
                  l = c.facetClass,
                  u = c.selectedFacetClass,
                  d = this.testIds.UNX_uFilter;
               r && r.length > 0 && o.toUpperCase().indexOf(r.toUpperCase()) < 0 && (l += " UNX-search-hidden");
               var p = "changeFacet";
               return n && (l += " ".concat(u), p = "deleteFacetValue"), ['<button data-test-id="'.concat(d, '" data-facet-name="').concat(a, '" data-facet-action="').concat(p, '" class="UNX-change-facet ').concat(l, '" data-id="').concat(s, '">'), '<span class="UNX-facet-text">'.concat(o, '</span> <span class="UNX-facet-count">(').concat(i, ")</span>"), "</button>"].join("")
            },
            facetMultiSelect: !0,
            facetClass: "UNX-facets-block",
            facetAction: "click",
            selectedFacetClass: "UNX-selected-facet-btn",
            selectedFacetsEl: null,
            selectedFacetTemplate: u,
            selectedFacetItemTemplate: l,
            selectedFacetConfig: {},
            clearAllText: "Clear All",
            rangeTemplate: function (t, e) {
               var r = this,
                  a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
               try {
                  var o = t.facetName,
                     i = t.values,
                     s = void 0 === i ? [] : i,
                     c = "",
                     l = a.facetClass,
                     u = a.selectedFacetClass,
                     d = a.applyMultipleFilters,
                     p = a.applyButtonText,
                     h = a.clearButtonText,
                     f = e.length > 0;
                  s.forEach(function (t) {
                     var e = t.from,
                        a = t.end,
                        n = r.isSelectedRange(o, t) ? "UNX-selected-facet-btn ".concat(l, " ").concat(u) : "".concat(l);
                     c += ['<button class="'.concat(n, ' UNX-range-facet UNX-change-facet" data-action="setRange" data-facet-name="').concat(o, '" data-start="').concat(e.dataId, '" data-end="').concat(a.dataId, '" >'), '<span class="UNX-facet-text">'.concat(e.name, "  -  ").concat(a.name, "</span>"), '<span class="UNX-facet-count">('.concat(e.count, ")</span>"), "</button>"].join("")
                  });
                  var g = "",
                     y = "";
                  return f && (d && (y = '<button class="UNX-default-btn '.concat(l, ' UNX-facet-primary" data-action="applyRange"> ').concat(p, "</button>")), g = '<button class="UNX-default-btn UNX-facet-clear  '.concat(l, '" data-action="clearRangeFacets">').concat(h, "</button>")), ['<div class="UNX-range-wrapper">', c, '<div class="UNX-price-action-row">', y, g, "<div>", "</div>"].join("")
               } catch (t) {
                  this.onError("facets > renderRangeFacets.js", t, n.runtimeError)
               }
            },
            rangeWidgetConfig: {
               minLabel: "",
               maxLabel: "",
               prefix: "$"
            },
            facetMultilevel: !0,
            facetMultilevelName: "Category",
            multiLevelFacetSelectorClass: "UNX-multilevel-facet",
            multiLevelFacetTemplate: h,
            facetDepth: 4,
            clearFacetsSelectorClass: "UNX-clear-facet",
            removeFacetsSelectorClass: "UNX-remove-facet",
            onFacetLoad: function (t) {},
            applyMultipleFilters: !1,
            applyButtonText: "Apply",
            clearButtonText: "clear",
            actionBtnClass: "UNX-action-item",
            actionChangeClass: "UNX-action-change",
            isCollapsible: !0,
            isSearchable: !0,
            searchPlaceHolder: "Search Filter",
            textFacetWrapper: "UNX-facets-item",
            defaultOpen: "ALL",
            enableViewMore: !1,
            viewMoreText: ["show all", "show less"],
            viewMoreLimit: 3,
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-facets-results-block"
            },
            events: {}
         },
         pagination: {
            enabled: !0,
            el: null,
            template: function (t) {
               var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.options.pagination,
                  r = this.getPaginationType();
               return "CLICK_N_SCROLL" === r ? p.bind(this)(t, e) : "FIXED_PAGINATION" === r ? d.bind(this)(t, e) : ""
            },
            pageClass: "UNX-page-items",
            preloaderClass: "",
            postloaderClass: "",
            selectedPageClass: "UNX-selected-page-item",
            type: "CLICK_N_SCROLL",
            infiniteScrollTriggerEl: window,
            heightDiffToTriggerNextPage: 100,
            virtualization: !0,
            bufferPages: 1,
            onPaginate: function (t) {},
            action: "click",
            pageLimit: 6,
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-pagination-size-block"
            },
            events: {}
         },
         pagesize: {
            enabled: !0,
            pageSize: 12,
            options: [8, 12, 16, 20, 24],
            pageSizeClass: "UNX-pagesize",
            selectedPageSizeClass: "UNX-selected-pagesize",
            action: "change",
            template: g,
            el: null,
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-page-size-block"
            },
            events: {}
         },
         banner: {
            enabled: !0,
            el: null,
            template: function () {
               var t, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                  r = ((arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}) || {}).openNewTab;
               return t = e ? e.map(function (t) {
                  var e = t.imageUrl,
                     a = t.landingUrl,
                     n = t.bannerHtml;
                  if (n) return n;
                  var o = "";
                  return a && (o += "href=".concat(a)), r && (o += '  target="_blank"'), '<a class="UNX-banner-wrap" '.concat(o, ' ><img style="max-width:100%" src="').concat(e, '"/></a>')
               }).join("") : "", "".concat(t)
            },
            count: 1,
            openNewTab: !1,
            tagName: "DIV",
            htmlAttributes: {
               class: "UNX-banner-block"
            },
            events: {}
         },
         swatches: {
            enabled: !1,
            attributesMap: {},
            swatchClass: "UNX-swatch-btn",
            template: function () {
               var t = this,
                  e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                  a = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}) || {}).swatchImgs,
                  n = void 0 === a ? [] : a,
                  o = "",
                  i = "",
                  s = "",
                  c = (e || {}).swatchClass,
                  l = void 0 === c ? "" : c,
                  u = this.testIds.UNX_swatchClrBtn,
                  d = void 0 === u ? "" : u,
                  p = (r || {}).unxTitle,
                  h = void 0 === p ? "" : p;
               return n.length > 1 && (n.forEach(function (e, r) {
                  var a = t.generateRid("unx_swatch_"),
                     n = 0 === r ? "" : " UNX-swatch-hidden",
                     i = 0 === r ? " UNX-selected-swatch" : "",
                     c = e.split("::");
                  c && (o += ['<button value="swatch color '.concat(c[0], '" data-test-id="').concat(d).concat(r, '" data-swatch-id="').concat(a, '" data-action="changeSwatch" class="').concat(l, " ").concat(a, " ").concat(i, '" style="background-color:').concat(c[0], '"> swatch color ').concat(c[0], " </button>")].join(""), s += '<div id="'.concat(a, '" class="UNX-img-wrapper ').concat(n, '"><img alt="').concat(h, " for the ").concat(c[0], '" class="UNX-img-block" src="').concat(c[1], '"/></div>'))
               }), i = '<div class="UNX-swatch-color-list">'.concat(o, "</div>")), {
                  btnList: i,
                  imgList: s
               }
            }
         },
         unbxdAnalytics: !1,
         onAction: function (t, e) {},
         onQueryRedirect: function (t, e, r) {
            if (e) {
               var a = e.value;
               return "url" === e.type && (history.state && history.state.replace && history.replaceState(null, "", r), location.href = a), !1
            }
         },
         onBackFromRedirect: function (t) {
            new URLSearchParams(t ? location.hash.substring(1) : location.search).get("redirected") && history.go(-1)
         },
         onNoUnbxdKeyRouting: function () {
            history.go()
         },
         debugMode: !0
      };
      const v = function () {
         try {
            var t = this.getBanners() || [],
               e = this.options.banner,
               r = void 0 === e ? {} : e;
            this.bannerWrapper.innerHTML = this.options.banner.template(t, r)
         } catch (t) {
            this.onError("Banners > renderBannerUI", t, n.runtimeError)
         }
      };
      var m = function (t) {
         var e = t.target;
         this.viewState.lastDidYouMean = "";
         var r = ("click" === this.options.facet.facetAction ? e : e.options[e.selectedIndex]).dataset,
            a = r.facetName,
            n = r.facetAction,
            o = r.id,
            i = r.action,
            s = r.end,
            c = r.start,
            l = this.getStateFromUrl(),
            u = this.getSelectedFacets(),
            d = u ? Object.keys(u).length : 0,
            p = Object.keys(l.selectedFacets).length,
            h = this.options,
            f = h.productType,
            g = h.facet.applyMultipleFilters,
            y = this.events,
            v = this.actions,
            m = this.state.rangeFacet[a],
            b = Object.keys(l.rangeFacet);
         if (n === v.changeFacet) {
            var S = this.getSelectedFacet(a),
               E = {
                  selectedFacetName: a,
                  selectedFacetId: o,
                  facetData: S
               };
            this.viewState.lastAction = "addedAFacet", this.options.onEvent(this, y.facetClick, {
               facetName: a,
               facetData: S
            }), this.updateFacets(E), this.getCallbackActions({
               facetName: a,
               facetAction: n,
               id: o
            }, "facetClick")
         }
         if ("deleteSelectedFacetValue" === n && this.findSelectedFacet(a) && (this.viewState.lastAction = "deletedAfacet", this.deleteAFacet.bind(this)(a, o), this.options.onEvent(this, y.deleteFacetValue, {
               facetName: a
            }), this.getCallbackActions({
               facetName: a,
               facetAction: n,
               id: o
            }, "facetClick"), this.setPageStart(0), this.getResults()), n === v.deleteFacetValue && this.findSelectedFacet(a)) {
            this.viewState.lastAction = "deletedAfacet", this.deleteAFacet.bind(this)(a, o), this.options.onEvent(this, y.deleteFacetValue, {
               facetName: a
            }), this.getCallbackActions({
               facetName: a,
               facetAction: n,
               id: o
            }, "facetClick");
            var P = u[a].length;
            p > 0 && 1 === d && 0 === P && g && (this.setPageStart(0), this.getResults())
         }
         n === v.deleteFacet && (this.findSelectedFacet(a) && (this.viewState.lastAction = "deletedAfacet", this.deleteAFacet.bind(this)(a), this.options.onEvent(this, y.deleteFacet, {
            facetName: a
         }), this.getCallbackActions({
            facetName: a,
            facetAction: n,
            id: o
         }, "facetClick"), l.selectedFacets[a] && (this.viewState.lastAction = "clearAFacet", this.setPageStart(0), this.getResults())));
         if ("applyFacets" === n && (this.viewState.lastAction = "applyFacets", this.setPageStart(0), this.getResults()), "clearAllFacets" === n && (this.viewState.lastAction = "clearAllFacets", this.state.selectedFacets = [], this.state.rangeFacet = [], this.setPageStart(0), this.getResults()), "deleteSelectedRange" === n) {
            var F = r.facetName,
               A = r.id,
               w = A.replace(/[^\w\s]/gi, "").split(" TO ");
            this.setRangeFacet({
               start: w[0],
               end: w[1],
               facetName: F,
               applyMultiple: !0
            }), this.getCallbackActions({
               facetName: F,
               facetAction: n,
               id: A
            }, "facetClick"), this.setPageStart(0), this.getResults()
         }
         if (i === v.setCategoryFilter && ("SEARCH" === f ? (this.setCategoryFilter(r), this.options.onEvent(this, y.setCategoryFilter, r)) : this.setCategoryId(r, this), this.setPageStart(0), this.getResults(), this.getCallbackActions(r, "facetClick")), i === v.clearCategoryFilter && ("SEARCH" === f ? (this.deleteCategoryFilter(r), this.options.onEvent(this, y.deleteCategoryFilter, r)) : this.setCategoryId(r, this), this.setPageStart(0), this.getResults(), this.getCallbackActions(r, "facetClick")), "setRange" === i) {
            var R = !1;
            m && 1 === m.length && b.length > 0 && (R = this.isSelectedRange(a, {
               from: {
                  name: c
               },
               end: {
                  name: s
               }
            })), R || this.setRangeFacet({
               start: c,
               end: s,
               facetName: a,
               applyMultiple: !0
            }), R && (this.state.rangeFacet = [], this.applyRangeFacet()), g || (this.setPageStart(0), this.applyRangeFacet()), this.getCallbackActions({
               facetName: a,
               facetAction: n,
               id: o
            }, "facetClick")
         }
         "clearRangeFacets" === i && (this.state.rangeFacet = [], this.renderFacets(), b.length > 0 && this.applyRangeFacet()), i === v.applyRange && (this.applyRangeFacet(), this.options.onEvent(this, i, {
            facetName: a
         }), this.getCallbackActions({
            facetName: a
         }, "facetClick")), i === v.clearPriceRange && a && (this.clearARangeFacet(a), this.getResults.bind(this)(), this.options.onEvent(this, i, {
            facetName: a
         }), this.getCallbackActions({
            facetName: a
         }, "facetClick")), this.viewState.lastAction = i
      };

      function b() {
         var t = this;
         try {
            var e = this.options.facet,
               r = void 0 === e ? {} : e,
               a = r.defaultOpen,
               o = r.applyMultipleFilters,
               i = this.viewState,
               s = i.expandedFacets;
            if ("updatedRangeSlider" === i.lastAction && o) return !1;
            var c = this.getAllFacets() || [],
               l = this.facetWrappers,
               u = void 0 === l ? [] : l,
               d = this.getSelectedFacets() || {};
            u.forEach(function (e) {
               e.innerHTML = "", c.forEach(function (r, n) {
                  var o = r.facetType,
                     i = r.facetName;
                  void 0 === s[i] && "ALL" === a && (s[i] = !0), "FIRST" === a && 0 == n && (s[i] = !0);
                  var c = t.isExpandedFacet(i),
                     l = t.getSearchFacetsText(i) || "",
                     u = d[i];
                  "text" === o && (e.innerHTML += t.renderTextFacet(r, u, c, l)), "range" === o && (e.innerHTML += t.renderRangeFacet(r, c, "")), "category" === o && (e.innerHTML += t.renderMultiLevelFacet(r, c, l)), t.viewState.facetElementMap[i] = i
               })
            }), this.options.facet.onFacetLoad.bind(this)(c)
         } catch (t) {
            this.onError("Facets > renderFacets.js", t, n.runtimeError)
         }
      }

      function S(t) {
         var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            r = arguments.length > 2 ? arguments[2] : void 0,
            a = arguments.length > 3 ? arguments[3] : void 0,
            o = arguments.length > 4 ? arguments[4] : void 0;
         try {
            var i = [],
               s = t.facetName,
               c = t.values,
               l = void 0 === c ? [] : c,
               u = this.cssList,
               d = u.openFacet,
               p = u.closeFacet,
               h = this,
               f = this.options.facet,
               g = f.isCollapsible,
               y = !1;
            if (l.length > 0 && (i = l.map(function () {
                  var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                     n = r.dataId;
                  return t.isSelected = e.some(function (t) {
                     return t.dataId === n
                  }), t.isSelected && (y = t.isSelected), h.options.facet.facetItemTemplate.bind(h)(t, r, a)
               })), o) return i.join("");
            t.isSelected = y;
            var v = this.options.facet.facetTemplate.bind(this)(t, i.join(""), r, a, f),
               m = r ? d : p;
            return g || (m = ""), '<div class="UNX-facet-item-d '.concat(s, " ").concat(m, '">').concat(v, "</div>")
         } catch (t) {
            this.onError("facets > renderTextFacet.js", t, n.runtimeError)
         }
      }

      function E() {
         var t = this;
         try {
            for (var e = this.getSelectedFacets() || {}, r = this.getSelectedRanges() || {}, a = Object.keys(e), o = "", i = this.options, s = i.selectedFacets, c = void 0 === s ? {} : s, l = i.facet, u = void 0 === l ? {} : l, d = u.selectedFacetItemTemplate ? u.selectedFacetItemTemplate.bind(this) : c.itemTemplate.bind(this), p = function () {
                  var r = a[h],
                     n = t.isCategoryFacet(r),
                     i = e[r] || [],
                     s = t.getAFacetByName(r);
                  n || i.forEach(function (t) {
                     var e = t.name,
                        r = t.count,
                        a = t.dataId;
                     o += d(s[0], {
                        name: e,
                        dataId: a || e,
                        count: r || 0
                     }, u, c)
                  })
               }, h = 0; h < a.length; h++) p();
            for (var f = Object.keys(r), g = function () {
                  var e = f[y],
                     a = t.getAFacetByName(e);
                  r[e].forEach(function (t) {
                     o += d(a[0], {
                        name: t.replace(/[^\w\s]/gi, ""),
                        dataId: t
                     }, u, c)
                  })
               }, y = 0; y < f.length; y++) g();
            var v = u.selectedFacetTemplate ? u.selectedFacetTemplate.bind(this) : c.template.bind(this);
            this.selectedFacetWrappers.forEach(function (t) {
               t.innerHTML = v(o, u, c)
            })
         } catch (t) {
            this.onError("facets > renderSelectedFacets.js", t, n.runtimeError)
         }
      }

      function P() {
         var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 ? arguments[1] : void 0;
         try {
            var r = "",
               a = this,
               o = this.cssList,
               i = o.openFacet,
               s = void 0 === i ? "" : i,
               c = o.closeFacet,
               l = void 0 === c ? "" : c,
               u = t.facetName,
               d = this.options.facet,
               p = void 0 === d ? {} : d,
               h = p.isCollapsible,
               f = this.getBreadCrumbsList(u) || [],
               g = a.options.facet.multiLevelFacetTemplate.bind(this)(t, f, "", p);
            r += a.options.facet.facetTemplate.bind(a)(t, g, e, null, p);
            var y = e ? s : l;
            return h || (y = ""), '<div class="'.concat(u, " UNX-facet-item-d UNX-multilivel-facets-block UNX-multilevel-block ").concat(y, '">').concat(r, "</div>")
         } catch (t) {
            this.onError("facets > renderMultiLevelFacet.js", t, n.runtimeError)
         }
      }

      function F() {
         var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 ? arguments[1] : void 0;
         try {
            var r = t.facetName,
               a = this.cssList,
               o = a.openFacet,
               i = void 0 === o ? "" : o,
               s = a.closeFacet,
               c = void 0 === s ? "" : s,
               l = this.options.facet,
               u = void 0 === l ? {} : l,
               d = u.isCollapsible,
               p = this.state.rangeFacet[r] || [];
            t.isSelected = p.length > 0;
            var h = this.options.facet.rangeTemplate.bind(this)(t, p, u),
               f = this.options.facet.facetTemplate.bind(this)(t, h, e, null, u),
               g = e ? i : c;
            return d || (g = ""), '<div class="'.concat(r, " UNX-facet-item-d range-facets-block ").concat(g, '">').concat(f, "</div>")
         } catch (t) {
            this.onError("facets > renderRangeFacet.js", t, n.runtimeError)
         }
      }
      var A = function (t, e) {
            var r = this.getSelectedRanges(t),
               a = e.from,
               n = e.end,
               o = "[".concat(a.name, " TO ").concat(n.name, "]");
            return !!(r && r.indexOf(o) >= 0)
         },
         w = function () {
            this.state.selectedFacets = {}, this.state.rangeFacet = [], this.state.categoryFilter = {}
         },
         R = function (t) {
            var e = this.viewState.expandedFacets,
               r = !1;
            return !0 === (void 0 === e ? {} : e)[t] && (r = !0), r
         },
         U = function (t, e) {
            this.viewState.searchFacetsText[t] = e, this.reRenderTextFacet(t)
         },
         C = function (t) {
            return this.viewState.searchFacetsText[t] || ""
         },
         N = function (t) {
            var e = this.options.facet.facetClass,
               r = void 0 === e ? "" : e,
               a = this.getSearchFacetsText(t) || "";
            (document.querySelectorAll(".".concat(t, " .").concat(r)) || []).forEach(function (t) {
               var e = (t.dataset || {}).id;
               e && e.toUpperCase().indexOf(a.toUpperCase()) >= 0 ? t.classList.remove("UNX-search-hidden") : t.classList.add("UNX-search-hidden")
            })
         },
         O = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.setRangeFacet(t);
            var e = t.facetName;
            this.getCallbackActions({
               facetName: e,
               facetAction: "changeFacet",
               id: e
            }, "facetClick"), this.viewState.lastAction = "updatedRangeSlider", this.setPageStart(0), this.applyRangeFacet()
         },
         T = function () {
            if (this.options.facet.applyMultipleFilters) {
               var t = this.getStateFromUrl() || {},
                  e = t.selectedFacets,
                  r = void 0 === e ? {} : e,
                  a = t.selectedRanges;
               this.state.selectedFacets = r, this.state.selectedRanges = a
            }
         };

      function L() {
         var t = this;
         try {
            var e = this.viewState.productViewType,
               r = this.searchResultsWrapper,
               a = this.options.pagination.type,
               o = this.options.noResults,
               i = o.el ? o.el : r.getElementsByClassName("UNX-no-results")[0],
               s = this.viewState,
               c = (s.noResultLoaded, s.isInfiniteStarted),
               l = this.options.products,
               u = (void 0 === l ? {} : l).productItemClass,
               d = "LIST" === e ? "UNX-list-block" : "UNX-grid-block";
            if (r.classList.remove("UNX-list-block"), r.classList.remove("UNX-grid-block"), r.classList.add(d), o.el ? i.innerHTML = "" : r.classList.remove("UNX-no-results-wrap"), r.style.minHeight = "100vh", c) {
               var p, h = this.getSearchResults();
               if (h && 0 === (null === (p = h.products) || void 0 === p ? void 0 : p.length) && (this.viewState.noResultLoaded = !0), this.viewState.noResultLoaded) {
                  if (r.innerHTML = this.renderSearch(), "" !== r.innerHTML) Array.from(r.children).forEach(function (e) {
                     t.individualProductObserver.observe(e)
                  }), window.scrollTo(0, 0), this.viewState.noResultLoaded = !1;
                  else this.preLoaderObserver.disconnect(), this.postLoaderObserver.disconnect(), this.handleNoResults()
               } else {
                  var f = this.getProductsPerPage(),
                     g = r.querySelectorAll(".".concat(u)),
                     y = document.createElement("div");
                  y.innerHTML = this.renderSearch();
                  var v = Array.from(y.children),
                     m = this.getResponseObj().response.start,
                     b = void 0 === m ? 0 : m,
                     S = null,
                     E = new Set;
                  g.forEach(function (t) {
                     var e = parseInt(t.dataset.prank, 10);
                     E.add(e)
                  });
                  for (var P = 0; P < g.length; P++) {
                     var F = g[P];
                     if (parseInt(F.dataset.prank, 10) > b) {
                        S = F;
                        break
                     }
                  }
                  var A = v.filter(function (t) {
                     var e = parseInt(t.dataset.prank, 10);
                     return !E.has(e)
                  });
                  if (S) {
                     A.forEach(function (e) {
                        r.insertBefore(e, S), t.individualProductObserver.observe(e)
                     });
                     var w = document.querySelector(".".concat(u, '[data-prank="').concat(b + f + 1, '"]'));
                     w && w.scrollIntoView()
                  } else {
                     A.forEach(function (e) {
                        r.appendChild(e), "INFINITE_SCROLL" === a && t.individualProductObserver.observe(e)
                     });
                     var R = document.querySelector(".".concat(u, '[data-prank="').concat(b, '"]'));
                     R && R.scrollIntoView()
                  }
                  this.preLoaderObserver.disconnect();
                  var U = document.querySelector(this.options.pagination.preloaderClass ? ".UNX-pre-loader.".concat(this.options.pagination.preloaderClass) : ".UNX-pre-loader");
                  if (this.preLoaderObserver.observe(U), "INFINITE_SCROLL" === this.options.pagination.type) {
                     this.postLoaderObserver.disconnect();
                     var C = document.querySelector(this.options.pagination.postloaderClass ? ".UNX-post-loader.".concat(this.options.pagination.postloaderClass) : ".UNX-post-loader");
                     this.postLoaderObserver.observe(C)
                  }
               }
               this.viewState.isInfiniteStarted = !1
            } else {
               if (r.innerHTML = "", r.innerHTML = this.renderSearch(), "" !== r.innerHTML) {
                  if (window.scrollTo(0, 0), "INFINITE_SCROLL" === a || "CLICK_N_SCROLL" === a) Array.from(r.children).forEach(function (e) {
                     t.individualProductObserver.observe(e)
                  })
               } else "INFINITE_SCROLL" !== a && "CLICK_N_SCROLL" !== a || (this.preLoaderObserver.disconnect(), this.postLoaderObserver.disconnect(), this.handleNoResults())
            }
         } catch (t) {
            this.onError("renderProducts.js", t, n.runtimeError)
         }
      }
      const I = function () {
         var t = this;
         try {
            var e = this.getResponseObj().response;
            if (!e) return "";
            var r = e.products,
               a = this,
               o = this.options.swatches,
               i = this.options.products.gridCount,
               s = this.viewState.productViewType,
               c = "",
               l = e.start,
               u = "";
            return "GRID" === s && i && i > 1 ? r.forEach(function (e, r) {
               var n = r % i;
               0 === n && (c += '<div class="UNX-row">');
               var d = r + l + 1,
                  p = t.mapProductAttrs(e);
               o.enabled && (u = t.renderSwatchBtns(e)), c += a.options.products.template.bind(a)(p, d, u, s, t.options.products), n === i - 1 && (c += "</div>")
            }) : c = r.map(function (e, r) {
               var n = r + l + 1,
                  i = t.mapProductAttrs(e);
               return o.enabled && (u = t.renderSwatchBtns(e)), a.options.products.template.bind(a)(i, n, u, s, t.options.products)
            }).join(""), c
         } catch (t) {
            this.options.onError("searchResults > renderSearch", t, n.runtimeError)
         }
      };
      var j = function (t) {
         var e = t.path || t.composedPath && t.composedPath(),
            r = this.options.products,
            a = r.productItemClass,
            n = r.attributesMap,
            o = a.replace(".", ""),
            i = t.target.dataset,
            s = e.find(function (t) {
               return t.className.indexOf(o) >= 0
            }),
            c = i || {},
            l = c.action,
            u = c.swatchId;
         if (l === this.actions.changeSwatch && u) return s.querySelectorAll(".UNX-img-wrapper").forEach(function (t) {
            var e = s.querySelector(".".concat(t.id));
            t.id === u ? (t.classList.remove("UNX-swatch-hidden"), s.querySelector(".".concat(u)).classList.add("UNX-selected-swatch")) : (t.classList.add("UNX-swatch-hidden"), e.classList.remove("UNX-selected-swatch"))
         }), this.options.onEvent(this, i.action), !1;
         var d = null;
         if ((i = s.dataset).id && (d = this.getProductByPropValue(n.unxId, i.id)), d && s.dataset.prank) {
            var p = this.options.url,
               h = (void 0 === p ? {} : p).pageNoParam,
               f = (void 0 === h ? {} : h).usePageNo,
               g = void 0 !== f && f;
            d.prank = s.dataset.prank;
            var y = Math.ceil(Number(d.prank) / Number(this.getProductsPerPage()));
            g ? this.setPageNoParam(y) : this.setPageNoParam(Number((y - 1) * Number(this.getProductsPerPage())))
         }
         this.options.products.onProductClick(d, t), this.getCallbackActions(d, "click")
      };
      const k = function () {
         var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
         try {
            return this.options.noResults.template(t)
         } catch (t) {
            this.onError("searchresults > renderNoResults", t, n.runtimeError)
         }
      };
      const _ = function () {
         try {
            var t, e = this.searchResultsWrapper,
               r = this.options,
               a = r.onEvent,
               o = r.noResults,
               i = this.events,
               s = i.beforeNoResultRender,
               c = i.afterNoResultRender,
               l = this.getQueryParams() || {},
               u = this.getSearchQuery(),
               d = "UNX-no-results-wrap",
               p = this.state.responseObj.redirect || {};
            if (Object.keys(p).length) return;
            try {
               a(this, s)
            } catch (t) {
               this.onError("reRender", t, n.runtimeError)
            }
            this.viewState.noResultLoaded = !0, null !== (t = this.options.noResults) && void 0 !== t && t.el ? (o.el.classList.add(d), e.innerHTML = "", o.el.innerHTML = this.renderNoResults(u)) : (e.classList.add(d), e.innerHTML = this.renderNoResults(u)), l.filter || this.renderFacets();
            try {
               a(this, c)
            } catch (t) {
               this.onError("reRender", t, n.runtimeError)
            }
         } catch (t) {
            this.onError("searchresults > handleNoResults", t, n.runtimeError)
         }
      };
      var V = function (t) {
         var e = this.options.products.attributesMap;
         return Object.keys(e).forEach(function (r) {
            var a = t[r],
               n = e[r];
            a || (t[r] = t[n])
         }), t
      };
      const x = function () {
         try {
            var t = this.options.productView,
               e = void 0 === t ? {} : t;
            if (e.el) {
               var r = this.viewState.productViewType,
                  a = this.getSearchResults();
               a && 0 === a.numberOfProducts ? this.productViewTypeWrapper.innerHTML = "" : this.productViewTypeWrapper.innerHTML = this.options.productView.template.bind(this)(r, e)
            }
         } catch (t) {
            this.onError("ProductViewType > renderProductViewTypeUI", t, n.runtimeError)
         }
      };
      var M = function () {
         var t = {},
            e = !0,
            r = 0,
            a = arguments.length;
         "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (e = arguments[0], r++);
         for (var n = function (r) {
               for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (e && "[object Object]" === Object.prototype.toString.call(r[a]) ? t[a] = M(!0, t[a], r[a]) : t[a] = r[a])
            }; r < a; r++) {
            n(arguments[r])
         }
         return t
      };
      const X = M;

      function D(t) {
         var e = t.target,
            r = this.options.productView.action,
            a = this.viewState.productViewType,
            n = (("click" === r ? e : e.options[e.selectedIndex]).dataset || {}).viewAction;
         if (this.checkFacets(), a !== n) {
            this.viewState.productViewType = n;
            var o = this.options.extraParams,
               i = void 0 === o ? {} : o;
            this.options.extraParams = X(!0, {}, i, {
               viewType: n
            }), this.state.productViewType = this.viewState.productViewType, this.state.isBack = !1, this.viewState.lastAction = "viewType", this.setUrl(!1), this.renderProductViewTypeUI(), this.renderProducts()
         }
      }
      const B = function () {
         try {
            var t = this.options.pagination,
               e = void 0 === t ? {} : t,
               r = (e || {}).type,
               a = "";
            if ("INFINITE_SCROLL" !== r) {
               var o = this.getPaginationInfo();
               o && (a = e.template.bind(this)(o, e))
            }
            return a
         } catch (t) {
            this.onError("Pagination > renderPagination.js", t, n.runtimeError)
         }
      };
      const W = function () {
         var t = this;
         try {
            return new Promise(function () {
               var e = t.options,
                  r = e.url,
                  a = (void 0 === r ? {} : r).pageNoParam,
                  n = (void 0 === a ? {} : a).usePageNo,
                  o = void 0 !== n && n,
                  i = e.pagination.infiniteScrollTriggerEl,
                  s = (e.products.productItemClass, t.getPaginationType());
               window;
               "INFINITE_SCROLL" === s || "CLICK_N_SCROLL" === s && t.options.products.el;
               var c = document.querySelector(t.options.pagination.postloaderClass ? ".UNX-post-loader.".concat(t.options.pagination.postloaderClass) : ".UNX-post-loader"),
                  l = document.querySelector(t.options.pagination.preloaderClass ? ".UNX-pre-loader.".concat(t.options.pagination.preloaderClass) : ".UNX-pre-loader");
               t.individualProductObserver = new IntersectionObserver(function (e) {
                  e.forEach(function (e) {
                     if (e.isIntersecting) {
                        var r = parseInt(e.target.dataset.prank),
                           a = t.getCurrentUrlPage(),
                           n = t.getProductsPerPage(),
                           i = Math.ceil(r / n);
                        i !== a && (o ? t.setPageNoParam(i) : t.setPageNoParam((i - 1) * n))
                     }
                  })
               }, {
                  threshold: [.5, .75, 1]
               }), t.preLoaderObserver = new IntersectionObserver(function (e) {
                  var r = t.getCurrentUrlPage();
                  e.forEach(function (e) {
                     if (e.isIntersecting && !t.state.isLoading && !t.viewState.isInfiniteStarted && (o ? r > 1 : 1 !== t.getFirstPrank())) {
                        t.preLoaderObserver.disconnect();
                        var a, n = t.getProductsPerPage();
                        if (t.viewState.isInfiniteStarted = !0, o) a = parseInt((r - 2) * n, 10);
                        else {
                           var i = t.getFirstPrank() - n - 1;
                           i < 0 && (i = 0), a = parseInt(i, 10)
                        }
                        t.setPageStart(a), t.getResults("", !0, "prev")
                     }
                  })
               }, {
                  threshold: 0,
                  rootMargin: "0px 0px 0px 0px"
               }), t.postLoaderObserver = new IntersectionObserver(function (e) {
                  if (e[0].isIntersecting && !t.state.isLoading && !t.viewState.isInfiniteStarted) {
                     var r = (t.getPaginationInfo() || {}).numberOfProducts,
                        a = t.getLastPrank();
                     a < r && (t.postLoaderObserver.disconnect(), t.viewState.isInfiniteStarted = !0, t.setPageStart(a), t.getResults("", !0, "next"))
                  }
               }, {
                  threshold: 0,
                  rootMargin: "0px 0px 0px 0px"
               }), t.preLoaderObserver.observe(l), "INFINITE_SCROLL" === s && t.postLoaderObserver.observe(c)
            })
         } catch (t) {
            this.onError("infiniteScroller.js", t, n.runtimeError)
         }
      };
      var H = function (t, e, r) {
         "FIXED_PAGINATION" === t.options.pagination.type && (t.viewState.lastAction = "pagination", t.setPageStart(e)), t.getResults("", !0, r), t.options.onEvent(t, t.events.pageNext, {
            value: e
         })
      };

      function z(t) {
         try {
            var e = this.getPaginationInfo() || {},
               r = this.options.onEvent,
               a = e.start,
               o = e.rows,
               i = e.isNext,
               s = e.isPrev,
               c = e.noOfPages;
            if ("CLICK_N_SCROLL" === this.options.pagination.type) {
               if (t === this.actions.next && i) {
                  this.viewState.isInfiniteStarted = !0;
                  var l = this.getLastPrank();
                  this.setPageStart(l), H(this, null, t)
               }
            } else {
               if (t === this.actions.next) i && H(this, a + o);
               if (t === this.actions.prev) {
                  var u = a - o;
                  s && (this.viewState.lastAction = "pagination", H(this, u), r(this, this.events.pagePrev, {
                     value: u
                  }))
               }
               if (t === this.actions.firstPage) {
                  s && (this.viewState.lastAction = "pagination", H(this, 0))
               }
               if (t === this.actions.lastPage) {
                  var d = (c - 1) * o;
                  i && (this.viewState.lastAction = "pagination", H(this, d))
               }
            }
         } catch (t) {
            this.onError("Pagination > renderNewResults", t, n.runtimeError)
         }
      }

      function Q(t) {
         var e = t.target.dataset,
            r = e.pageAction,
            a = e.pageNo;
         this.checkFacets(), this.viewState.lastDidYouMean = "", "paginate" === r ? (this.viewState.lastAction = "pagination", this.setPageStart(a), this.getResults()) : this.renderNewResults(r)
      }
      var K = function () {
            var t = this.options,
               e = t.url,
               r = (void 0 === e ? {} : e).pageSizeParam,
               a = void 0 === r ? {} : r,
               n = a.keyReplacer,
               o = void 0 === n ? "" : n,
               i = a.addToUrl,
               s = a.algo,
               c = void 0 === s ? "DEFAULT" : s,
               l = t.pagesize,
               u = (void 0 === l ? {} : l).pageSize;
            if (i) {
               var d = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search);
               return Number(d["KEY_VALUE_REPLACER" === c ? o : "rows"])
            }
            return this.state.pageSize || u
         },
         q = function () {
            var t = this.options.url,
               e = (void 0 === t ? {} : t).pageNoParam,
               r = void 0 === e ? {} : e,
               a = r.algo,
               n = void 0 === a ? "DEFAULT" : a,
               o = r.usePageNo,
               i = void 0 !== o && o,
               s = r.keyReplacer,
               c = void 0 === s ? "" : s,
               l = r.addToUrl;
            if (i) {
               if (!this.viewState.page)
                  if (l) {
                     var u = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search),
                        d = Number(u["KEY_VALUE_REPLACER" === n ? c : i ? "page" : "start"]);
                     this.viewState.page = Number(d)
                  } else this.viewState.page = 1;
               return this.viewState.page
            }
            if (!this.viewState.start)
               if (l) {
                  var p = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search),
                     h = Number(p["KEY_VALUE_REPLACER" === n ? c : i ? "page" : "start"]);
                  this.viewState.start = Number(h / K.call(this) + 1)
               } else this.viewState.start = 1;
            return this.viewState.start
         },
         Y = function (t) {
            var e = this.options.url,
               r = (void 0 === e ? {} : e).pageNoParam,
               a = void 0 === r ? {} : r,
               n = a.algo,
               o = a.usePageNo,
               i = void 0 !== o && o,
               s = a.keyReplacer,
               c = a.addToUrl,
               l = t;
            if (this.viewState[i ? "page" : "start"] = Number(t), c) {
               var u = this.readQueryParamsFromUrl(this.options.hashMode ? location.hash.slice(1) : location.search);
               u["KEY_VALUE_REPLACER" === n ? s : i ? "page" : "start"] = [l], history.replaceState(null, null, this.urlSearchParamsToStr(u))
            }
         },
         G = function () {
            var t = document.getElementsByClassName(this.options.products.productItemClass || "product-item");
            return 0 === t.length ? 1 : parseInt(t[0].dataset.prank, 10)
         },
         $ = function () {
            var t = document.getElementsByClassName(this.options.products.productItemClass || "product-item");
            return 0 === t.length ? null : parseInt(t[t.length - 1].dataset.prank, 10)
         };

      function Z(t) {
         var e = t.target;
         this.viewState.lastDidYouMean = "";
         var r = e.dataset,
            a = r.action,
            n = r.value,
            o = e.value || n || "",
            i = this.events.changeSort;
         this.checkFacets(), a === this.actions.clearSort && (this.applySort(""), this.options.onEvent(this, a)), a === this.actions.changeSort && (this.applySort(o), this.options.onEvent(this, i, {
            sort: o
         }))
      }
      const J = function () {
         var t = this;
         try {
            var e = this.getSearchResults(),
               r = this.options.sort,
               a = void 0 === r ? {} : r,
               o = this.sortWrappers,
               i = void 0 === o ? [] : o;
            i && i.forEach(function (r) {
               var n = "";
               e && e.numberOfProducts > 0 && (n = t.options.sort.template.bind(t)(t.getSelectedSort(), a)), r.innerHTML = n
            })
         } catch (t) {
            this.onError("Sort > renderSort", t, n.runtimeError)
         }
      };
      var tt = function () {
         try {
            var e = this.options.searchBoxEl,
               r = e && null != e.value ? e.value : "";
            for (Array.isArray(r) && (r = null != r[0] ? r[0] : ""); Array.isArray(r);) r = null != r[0] ? r[0] : "";
            "string" != typeof r && (r = null == r ? "" : "object" == typeof r && "function" == typeof r.trim ? r.trim() : String(r)), r = r.trim(), e && (e.value = r);
            var t = "" === r ? "*" : r;
            if (!t.replace(/\s/g, "").length) return !1;
            this.options.productType = "SEARCH", (t = 0 === t.indexOf("#") ? t.replace("#", "") : t) ? (this.resetAll(), this.changeInput(t, this.events.changeInput), this.options.products.productType = "SEARCH", this.viewState.loadedFromSuggestion = !1, this.state.selectedSort = "", this.setPageStart(0), this.resetViewState(), this.getResults()) : this.searchResultsWrapper.innerHTML = null
         } catch (t) {
            this.onError("input > setInputValue.js", t, n.runtimeError)
         }
      };
      const et = function () {
         try {
            var t = this.state.userInput,
               e = void 0 === t ? "" : t,
               r = this.getPaginationInfo() || {},
               a = this.getDidYouMeanFromResponse() || [],
               o = this.options.pagination.type,
               i = this.options.spellCheck.enabled,
               s = this.viewState,
               c = s.loadedFromSuggestion,
               l = s.lastDidYouMean;
            if ("FIXED_PAGINATION" !== o && r) {
               var u = r.start,
                  d = r.productsLn;
               r.productsLn = d + u, r.start = 0
            }
            var p = a.length > 0 ? a[0].suggestion : "",
               h = "";
            p && !c ? (this.viewState.lastDidYouMean = e, this.viewState.loadedFromSuggestion = !0, i && this.getResults(p)) : this.viewState.lastDidYouMean = "", h = this.options.spellCheck.template.bind(this)(e, l, r), !i && p && (h = this.options.spellCheck.template.bind(this)(p, e, r)), this.spellCheckWrappers.forEach(function (t) {
               t.innerHTML = h
            })
         } catch (t) {
            this.onError("didYouMean > renderDidYouMean.js", t, n.runtimeError)
         }
      };
      var rt = function (t) {
         var e = this.getSpellCheckSuggested() || [],
            r = e.length,
            a = (t.target || {}).dataset,
            n = this.state.userInput,
            o = void 0 === n ? "" : n;
         a && "getSuggestion" === a.action && (this.resetAll(), this.setPageStart(0), this.getResults(r ? e[0] : o), this.viewState.lastDidYouMean = null, this.viewState.loadedFromSuggestion = !1)
      };

      function at() {}

      function nt() {
         var t = this;
         try {
            var e, r = this.getSelectedMultilevelFacet() || [];
            "CATEGORY" === this.options.products.productType && -1 !== (null === (e = window.unbxdAnalyticsConf) || void 0 === e || null === (e = e.page) || void 0 === e ? void 0 : e.indexOf("categoryPath")) && (r = ["categoryPath"]);
            var a = "";
            return r && r.forEach(function (e) {
               var r = t.getBreadCrumbsList(e) || [],
                  n = t.options.breadcrumb,
                  o = void 0 === n ? {} : n;
               a += t.options.breadcrumb.template(r, o)
            }), a
         } catch (t) {
            this.onError("Breadcrumbs > actions.js", t, n.runtimeError)
         }
      }
      const ot = function () {
         var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
         try {
            var e = this.getSwatches(t, this.options.swatches.attributesMap) || {},
               r = this.options.swatches,
               a = void 0 === r ? {} : r;
            return this.options.swatches.template.bind(this)(e, a, t)
         } catch (t) {
            this.onError("Swatches > renderSwatchBtns", t, n.runtimeError)
         }
      };
      var it = function (t) {
            var e = t.target;
            this.viewState.lastDidYouMean = "";
            var r = ("click" === this.options.pagesize.action ? e : e.options[e.selectedIndex]).id,
               a = this.events.pageSizeChange;
            r && (this.checkFacets(), this.setPageSize(Number(r)), this.getResults.bind(this)(), this.options.onEvent(this, a, {
               count: r
            }))
         },
         st = function () {
            try {
               var t = this.options.pagesize,
                  e = void 0 === t ? {} : t,
                  r = e.pageSize;
               (this.getQueryParams() || {}) && (r = this.state.pageSize);
               var a = this.getSearchResults();
               a && 0 === a.numberOfProducts ? this.pageSizeWrapper.innerHTML = "" : this.pageSizeWrapper.innerHTML = this.options.pagesize.template.bind(this)(r, e)
            } catch (t) {
               this.onError("Pagesize > renderPageSize", t, n.runtimeError)
            }
         },
         ct = function (t) {
            window.Unbxd.track("search", {
               query: t
            })
         },
         lt = function (t) {
            var e = t.uniqueId,
               r = t.sku,
               a = t.prank;
            window.Unbxd.track("click", {
               pid: e || r,
               prank: a,
               requestId: null
            })
         },
         ut = function () {
            var t = this.getSearchResults(),
               e = this.getSearchQuery(),
               r = this.options.productType,
               a = t.products,
               n = {
                  pids_list: []
               };
            if (a) {
               var o = [];
               a.forEach(function (t) {
                  var e = t.sku,
                     r = t.uniqueId || e;
                  o.push(r)
               }), n.pids_list = o, "SEARCH" === r ? (n.query = e, window.Unbxd.track("search_impression", n)) : "CATEGORY" !== r && "BROWSE" !== r || (window.UnbxdAnalyticsConf && (n.page = window.UnbxdAnalyticsConf.page || "", n.page_type = window.UnbxdAnalyticsConf.page_type || ""), window.Unbxd.track("browse_impression", n))
            }
         },
         dt = function () {
            var t = this.getSelectedFacets(),
               e = this.state.rangeFacet,
               r = this.state.categoryFilter,
               a = Object.keys(t),
               n = Object.keys(e),
               o = Object.keys(r),
               i = {};
            a.forEach(function (e) {
               var r = t[e],
                  a = [];
               r.forEach(function (t) {
                  a.push(t.name)
               }), i[e] = a
            }), n.forEach(function (t) {
               var r = e[t][0];
               if (r) {
                  var a = r.replace(/\[|\]/g, "").split(",");
                  i[t] = a
               }
            }), o.forEach(function (t) {
               var e = r[t].join(">");
               i[t] = e
            });
            var s = this.getSearchQuery();
            window.Unbxd.track("facets", {
               query: s,
               facets: i
            })
         },
         pt = function () {
            window.UnbxdAnalyticsConf && window.Unbxd.track("categoryPage", window.UnbxdAnalyticsConf)
         },
         ht = function (t, e) {
            var r = window.Unbxd || null,
               a = this.options.unbxdAnalytics;
            if (!r || !a || r && !r.track) return !1;
            if (t) switch (e) {
               case "CHANGE_INPUT":
                  this.trackSearch(t);
                  break;
               case "click":
                  this.trackProductClick(t);
                  break;
               case "AFTER_API_CALL":
                  this.trackImpression();
                  break;
               case "facetClick":
                  this.trackFacetClick(t, e);
                  break;
               case "categoryPage":
                  this.trackCategoryPageLoad(t, e)
            }
         };
      const ft = {
         unxPageSize: "unxPageSize"
      };
      const gt = function () {
         var t = this,
            e = this.options,
            r = e.onEvent,
            a = e.spellCheck,
            o = e.pagination,
            i = e.productType,
            s = e.searchBoxEl,
            c = e.loader,
            l = e.breadcrumb,
            u = e.productView,
            d = this.getPaginationType(),
            p = this.events,
            h = p.beforeRender,
            f = p.afterRender;
         try {
            r(this, h)
         } catch (t) {
            this.onError("reRender", t, n.runtimeError)
         }
         c.el && (c.el.innerHTML = "");
         var g = this.getSearchResults(),
            y = this.viewState.lastAction;
         "SEARCH" === i && s && (s.value = this.state.userInput), "SEARCH" !== i && s && (s.value = "");
         var v = this.paginationWrappers,
            m = this.breadcrumbWrapper;
         g && 0 === g.numberOfProducts ? this.handleNoResults() : this.renderProducts(), this.renderFacets(), this.renderSelectedFacets(), this.renderBannerUI(), u.enabled && this.renderProductViewTypeUI(), this.renderPageSize(), this.renderSort(), l.enabled && (m.innerHTML = this.renderBreadCrumbs());
         var b = this.getSpellCheckSuggested();
         a.el && this.renderDidYouMean(b), "pagination" === y && o.onPaginate.bind(this)(this.getPaginationInfo()), "INFINITE_SCROLL" !== d && v.forEach(function (e) {
            e.innerHTML = t.renderPagination()
         });
         try {
            r(this, f)
         } catch (t) {
            this.onError("reRender", t, n.runtimeError)
         }
      };
      const yt = function () {
         var t = this,
            e = this.options,
            r = e.searchButtonEl,
            a = e.searchTrigger,
            n = e.products,
            o = e.facet,
            i = e.productView,
            s = e.pagination,
            c = e.sort,
            l = e.pagesize,
            u = e.spellCheck,
            d = e.searchBoxEl,
            p = e.breadcrumb,
            h = e.selectedFacets,
            f = o || {},
            g = f.actionBtnClass,
            y = f.actionChangeClass;
         d && d.addEventListener("keydown", function (e) {
            13 === e.keyCode && (e.preventDefault(), t.setInputValue())
         }), s.enabled && this.paginationWrappers.forEach(function (e) {
            t.delegate(e, s.action, ".".concat(s.pageClass), t.paginationAction.bind(t))
         }), o.facetsEl && this.facetWrappers.forEach(function (e) {
            t.delegate(e, o.facetAction, ".".concat(o.facetClass), t.findChangedFacet.bind(t)), t.delegate(e, "change", "." + y, t.extraActionsChange.bind(t)), t.delegate(e, "keyup", "." + y, t.extraActionsChange.bind(t)), t.delegate(e, "click", "." + g, t.extraActions.bind(t))
         }), r && r.addEventListener(a, this.setInputValue.bind(this)), u.el && this.spellCheckWrappers.forEach(function (e) {
            t.delegate(e, "click", ".".concat(u.selectorClass), t.setSuggestion.bind(t))
         }), this.delegate(this.searchResultsWrapper, "click", ".".concat(n.productItemClass), this.onProductItemClick.bind(this)), c.el && this.sortWrappers.forEach(function (e) {
            t.delegate(e, c.action, ".".concat(c.sortClass), t.sortAction.bind(t))
         }), o.selectedFacetsEl ? this.selectedFacetWrappers.forEach(function (e) {
            t.delegate(e, o.facetAction, ".".concat(o.selectedFacetClass), t.findChangedFacet.bind(t))
         }) : this.selectedFacetWrappers.forEach(function (e) {
            t.delegate(e, h.facetAction, ".".concat(h.selectedFacetClass), t.findChangedFacet.bind(t))
         }), this.breadcrumbWrapper && this.delegate(this.breadcrumbWrapper, "click", "." + p.selectorClass, this.findChangedFacet.bind(this)), this.productViewTypeWrapper && this.delegate(this.productViewTypeWrapper, i.action, "." + i.viewTypeClass, this.onPageViewTypeClick.bind(this));
         var v = this.getPaginationType();
         if ("INFINITE_SCROLL" !== v && "CLICK_N_SCROLL" !== v || this.setUpInfiniteScroll(), this.delegate(this.pageSizeWrapper, l.action, ".".concat(l.pageSizeClass), this.onClickPageSize.bind(this)), !this.viewState.initialised) {
            window.addEventListener("popstate", this.onLocationChange.bind(this), !1);
            var m = this.getQueryParams();
            Object.keys(m).length > 0 && this.renderFromUrl(), this.viewState.initialised = !0
         }
      };

      function vt(t) {
         return vt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
         } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
         }, vt(t)
      }
      const mt = {
         ALLOWED_QUERY_PARAM_SEPARATORS: ["&", "~", "^", ",", "_", ":", ";", "|", "$", "@"],
         ALLOWED_VALUE_SEPARATORS: ["&", "~", "^", ",", "-", "_", ":", ";", "|", "$", "@"],
         ALLOWED_RANGE_SEPARATORS: ["-"]
      };
      var bt = {
            moduleName: "pagination",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               type: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "string",
                  allowedOptions: ["CLICK_N_SCROLL", "FIXED_PAGINATION", "INFINITE_SCROLL"]
               },
               el: {
                  required: function (t) {
                     return t.enabled && "INFINITE_SCROLL" !== t.type
                  },
                  datatype: "element"
               },
               template: {
                  required: function (t) {
                     return t.enabled && "INFINITE_SCROLL" !== t.type
                  },
                  datatype: "function"
               },
               pageClass: {
                  datatype: "string"
               },
               selectedPageClass: {
                  datatype: "string"
               },
               onPaginate: {
                  datatype: "function"
               },
               pageLimit: {
                  required: function (t) {
                     return t.enabled && "FIXED_PAGINATION" === t.type
                  },
                  datatype: "number"
               },
               infiniteScrollTriggerEl: {
                  required: function (t) {
                     return t.enabled && "INFINITE_SCROLL" === t.type
                  },
                  datatype: "element"
               },
               heightDiffToTriggerNextPage: {
                  required: function (t) {
                     return t.enabled && "INFINITE_SCROLL" === t.type
                  },
                  datatype: "number"
               },
               action: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "string",
                  allowedOptions: ["click", "change"]
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         St = {
            moduleName: "banner",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               el: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "element"
               },
               template: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "function"
               },
               openNewTab: {
                  datatype: "boolean"
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Et = {
            moduleName: "loader",
            config: {
               el: {
                  required: !0,
                  datatype: "element"
               },
               template: {
                  required: function (t) {
                     return t.el
                  },
                  datatype: "function"
               }
            }
         },
         Pt = {
            moduleName: "sorting",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               el: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "element"
               },
               options: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "array"
               },
               sortClass: {
                  datatype: "string"
               },
               selectedSortClass: {
                  datatype: "string"
               },
               template: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "function"
               },
               action: {
                  datatype: "string",
                  allowedOptions: ["click", "change"]
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Ft = {
            moduleName: "No results",
            config: {
               el: {
                  required: !0,
                  datatype: "element"
               },
               template: {
                  required: function (t) {
                     return t.el
                  },
                  datatype: "function"
               }
            }
         },
         At = {
            moduleName: "swatches",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               attributesMap: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "object",
                  customValidations: function (t) {
                     t.enabled && 0 === Object.keys(t.attributesMap).length && console.error("SDK Config error in swatches: attributesMap should not be an empty object")
                  }
               },
               swatchClass: {
                  datatype: "string"
               },
               template: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "function"
               }
            }
         },
         wt = {
            moduleName: "spellcheck",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               el: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "element"
               },
               template: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "function"
               },
               selectorClass: {
                  datatype: "string"
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Rt = {
            moduleName: "products",
            config: {
               el: {
                  required: !0,
                  datatype: "element"
               },
               productType: {
                  required: !0,
                  datatype: "string",
                  allowedOptions: ["SEARCH", "CATEGORY"]
               },
               template: {
                  required: !0,
                  datatype: "function"
               },
               productAttributes: {
                  required: !0,
                  datatype: "array",
                  customValidations: function (t) {
                     0 === t.productAttributes.length && console.error("SDK Config error in products: productAttributes should not be an empty array")
                  }
               },
               attributesMap: {
                  required: !0,
                  datatype: "object",
                  customValidations: function (t) {
                     0 === Object.keys(t.attributesMap).length && console.error("SDK Config error in products: attributesMap should not be an empty object")
                  }
               },
               gridCount: {
                  datatype: "number"
               },
               productItemClass: {
                  required: !0,
                  datatype: "string"
               },
               onProductClick: {
                  datatype: "function"
               },
               defaultImage: {
                  datatype: "string"
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Ut = {
            moduleName: "page size",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               el: {
                  required: !0,
                  datatype: "element"
               },
               pageSize: {
                  datatype: "number",
                  customValidations: function (t) {
                     t.options.includes(t.pageSize) || console.error("SDK Config error in pagesize: pageSize should be among options"), t.pageSize < 0 && console.error("SDK Config error in pagesize: pageSize cannot be a negative value")
                  }
               },
               options: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "array",
                  customValidations: function (t) {
                     t.options.some(function (t) {
                        return t < 0
                     }) && console.error("SDK Config error in pagesize: options cannot contain negative values.")
                  }
               },
               pageSizeClass: {
                  datatype: "string"
               },
               selectedPageSizeClass: {
                  datatype: "string"
               },
               action: {
                  datatype: "string",
                  allowedOptions: ["click", "change"]
               },
               template: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "function"
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Ct = {
            moduleName: "product view",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               el: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "element"
               },
               template: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "function"
               },
               defaultViewType: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "string",
                  allowedOptions: ["GRID", "LIST"]
               },
               action: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "string",
                  allowedOptions: ["click", "change"]
               },
               viewTypeClass: {
                  datatype: "string"
               },
               selectedViewTypeClass: {
                  datatype: "string"
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Nt = {
            moduleName: "breadcrumbs",
            config: {
               enabled: {
                  datatype: "boolean"
               },
               el: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "element"
               },
               template: {
                  required: function (t) {
                     return t.enabled
                  },
                  datatype: "function"
               },
               selectorClass: {
                  datatype: "string"
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Ot = {
            moduleName: "facets",
            config: {
               facetsEl: {
                  required: !0,
                  datatype: "element"
               },
               facetTemplate: {
                  required: function (t) {
                     return t.facetsEl
                  },
                  datatype: "function"
               },
               facetItemTemplate: {
                  required: function (t) {
                     return t.facetsEl
                  },
                  datatype: "function"
               },
               facetMultiSelect: {
                  datatype: "boolean"
               },
               facetClass: {
                  datatype: "string"
               },
               facetAction: {
                  required: function (t) {
                     return t.facetsEl
                  },
                  datatype: "string",
                  allowedOptions: ["click", "change"]
               },
               selectedFacetClass: {
                  datatype: "string"
               },
               selectedFacetsEl: {
                  datatype: "element"
               },
               selectedFacetTemplate: {
                  datatype: "function"
               },
               selectedFacetItemTemplate: {
                  datatype: "function"
               },
               selectedFacetConfig: {
                  datatype: "object"
               },
               clearAllText: {
                  datatype: "string"
               },
               rangeTemplate: {
                  datatype: "function"
               },
               rangeWidgetConfig: {
                  datatype: "object"
               },
               facetMultilevel: {
                  datatype: "boolean"
               },
               facetMultilevelName: {
                  required: function (t) {
                     return t.facetsEl && t.facetMultilevel
                  },
                  datatype: "string"
               },
               multiLevelFacetSelectorClass: {
                  datatype: "string"
               },
               multiLevelFacetTemplate: {
                  required: function (t) {
                     return t.facetsEl && t.facetMultilevel
                  },
                  datatype: "function"
               },
               facetDepth: {
                  datatype: "number"
               },
               clearFacetsSelectorClass: {
                  datatype: "string"
               },
               removeFacetsSelectorClass: {
                  datatype: "string"
               },
               onFacetLoad: {
                  datatype: "function"
               },
               applyMultipleFilters: {
                  datatype: "boolean"
               },
               applyButtonText: {
                  required: function (t) {
                     return t.facetsEl && t.applyMultipleFilters
                  },
                  datatype: "string"
               },
               clearButtonText: {
                  required: function (t) {
                     return t.facetsEl && t.applyMultipleFilters
                  },
                  datatype: "string"
               },
               actionBtnClass: {
                  datatype: "string"
               },
               actionChangeClass: {
                  datatype: "string"
               },
               isCollapsible: {
                  datatype: "boolean"
               },
               defaultOpen: {
                  required: function (t) {
                     return t.facetsEl && t.isCollapsible
                  },
                  datatype: "string",
                  allowedOptions: ["ALL", "FIRST", "NONE"]
               },
               isSearchable: {
                  datatype: "boolean"
               },
               searchPlaceHolder: {
                  required: function (t) {
                     return t.facetsEl && t.isSearchable
                  },
                  datatype: "string"
               },
               enableViewMore: {
                  datatype: "boolean"
               },
               viewMoreText: {
                  required: function (t) {
                     return t.facetsEl && t.enableViewMore
                  },
                  datatype: "array"
               },
               viewMoreLimit: {
                  required: function (t) {
                     return t.facetsEl && t.enableViewMore
                  },
                  datatype: "number"
               },
               tagName: {
                  datatype: "string"
               },
               htmlAttributes: {
                  datatype: "object"
               }
            }
         },
         Tt = {
            moduleName: "facetsParam",
            config: {
               addToUrl: {
                  required: !1,
                  datatype: "boolean"
               },
               algo: {
                  required: function (t) {
                     return t.addToUrl
                  },
                  datatype: "string",
                  allowedOptions: ["DEFAULT", "KEY_VALUE_REPLACER", "HASH"]
               },
               multiValueSeparator: {
                  required: function (t) {
                     return "KEY_VALUE_REPLACER" === t.algo
                  },
                  datatype: "string",
                  allowedOptions: mt.ALLOWED_VALUE_SEPARATORS
               },
               keyReplacer: {
                  required: !1,
                  datatype: "object",
                  customValidations: function (t) {
                     var e = Object.values(t.keyReplacer);
                     new Set(e).size !== e.length && console.error("SDK Config error in facetsParam: keysReplacer values should not be duplicate")
                  }
               },
               valueReplacer: {
                  required: !1,
                  datatype: "object",
                  customValidations: function (t) {
                     var e = t.valueReplacer;
                     Object.values(e).forEach(function (t) {
                        var e = Object.values(t);
                        new Set(e).size !== e.length && console.error("SDK Config error in facetsParam: valueReplacer values should not be duplicate")
                     })
                  }
               },
               rangeFacets: {
                  required: function (t) {
                     return "KEY_VALUE_REPLACER" === t.algo
                  },
                  datatype: "array"
               },
               rangeSeparator: {
                  required: function (t) {
                     return "KEY_VALUE_REPLACER" === t.algo
                  },
                  datatype: "string",
                  allowedOptions: mt.ALLOWED_RANGE_SEPARATORS
               }
            }
         },
         Lt = {
            moduleName: "pageViewParam",
            config: {
               addToUrl: {
                  required: !1,
                  datatype: "boolean"
               },
               keyReplacer: {
                  required: !1,
                  datatype: "string"
               },
               valuesReplacer: {
                  required: !1,
                  datatype: "object"
               }
            }
         },
         It = {
            moduleName: "sortParam",
            config: {
               addToUrl: {
                  required: !1,
                  datatype: "boolean"
               },
               keyReplacer: {
                  required: !1,
                  datatype: "string"
               },
               valueReplacer: {
                  required: !1,
                  datatype: "object"
               }
            }
         },
         jt = {
            moduleName: "pageNoParam",
            config: {
               addToUrl: {
                  required: !1,
                  datatype: "boolean"
               },
               keyReplacer: {
                  required: !1,
                  datatype: "string"
               },
               usePageNo: {
                  required: !1,
                  datatype: "boolean"
               }
            }
         },
         kt = {
            moduleName: "pageSizeParam",
            config: {
               addToUrl: {
                  required: !1,
                  datatype: "boolean"
               },
               keyReplacer: {
                  required: !1,
                  datatype: "string"
               }
            }
         },
         _t = {
            moduleName: "url",
            config: {
               seoFriendlyUrl: {
                  required: !1,
                  datatype: "boolean",
                  customValidations: function (t) {
                     t.seoFriendlyUrl || (t.searchQueryParam.addToUrl = !0, t.searchQueryParam.algo = "DEFAULT", t.searchQueryParam.keyReplacer = "q", t.browseQueryParam.addToUrl = !0, t.browseQueryParam.algo = "DEFAULT", t.browseQueryParam.keyReplacer = "p", t.pageViewParam.addToUrl = !1, t.pageViewParam.algo = "DEFAULT", t.pageViewParam.keyReplacer = "viewType", t.sortParam.addToUrl = !0, t.sortParam.algo = "DEFAULT", t.sortParam.keyReplacer = "sort", t.pageSizeParam.addToUrl = !0, t.pageSizeParam.algo = "DEFAULT", t.pageSizeParam.keyReplacer = "rows", t.pageNoParam.addToUrl = !0, t.pageNoParam.algo = "DEFAULT", t.pageNoParam.usePageNo = !1, t.pageNoParam.keyReplacer = "start", t.facetsParam.addToUrl = !0, t.facetsParam.algo = "DEFAULT", t.orderOfQueryParams = ["QUERY", "FILTERS", "PAGE_NUMBER", "PAGE_SIZE", "SORT", "VIEW_TYPE"], t.queryParamSeparator = "&", t.keyValueSeparator = "=")
                  }
               },
               queryParamSeparator: {
                  required: !0,
                  datatype: "string",
                  allowedOptions: mt.ALLOWED_QUERY_PARAM_SEPARATORS
               }
            }
         },
         Vt = {
            moduleName: "Others",
            config: {
               siteKey: {
                  required: !0,
                  datatype: "string"
               },
               apiKey: {
                  required: !0,
                  datatype: "string"
               },
               searchBoxEl: {
                  required: !0,
                  datatype: "element"
               },
               searchButtonEl: {
                  datatype: "element"
               },
               unbxdAnalytics: {
                  datatype: "boolean"
               },
               extraParams: {
                  datatype: "object"
               },
               defaultFilters: {
                  datatype: "object"
               },
               searchEndPoint: {
                  datatype: "string"
               }
            }
         };

      function xt(t) {
         return xt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
         } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
         }, xt(t)
      }
      const Mt = function () {
         var t = this,
            e = this.options,
            r = e.banner,
            a = e.facet,
            o = e.breadcrumb,
            i = e.spellCheck,
            s = e.sort,
            c = e.pagination,
            l = e.loader,
            u = e.noResults,
            d = e.swatches,
            p = e.pagesize,
            h = e.products,
            f = e.productView,
            g = e.url,
            y = g.facetsParam,
            v = g.pageViewParam,
            m = g.sortParam,
            b = g.pageSizeParam,
            S = g.pageNoParam,
            E = function () {
               var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  a = r.moduleName,
                  o = void 0 === a ? "" : a,
                  i = r.config,
                  s = void 0 === i ? {} : i;
               Object.keys(s).map(function (r) {
                  var a, i, c = s[r],
                     l = c.datatype,
                     u = c.required,
                     d = void 0 !== u && u,
                     p = c.allowedOptions,
                     h = void 0 === p ? [] : p,
                     f = c.customValidations,
                     g = void 0 === f ? null : f;
                  if ("function" == typeof d && (d = d(e)), xt(e[r]) !== l || "object" === l && null === e[r])
                     if ("element" === l || "array" === l)
                        if ("element" === l) {
                           var y = !(i = e[r], ("object" === ("undefined" == typeof Node ? "undefined" : vt(Node)) ? i instanceof Node : i && "object" === vt(i) && "number" == typeof i.nodeType && "string" == typeof i.nodeName) || function (t) {
                              return "object" === ("undefined" == typeof HTMLElement ? "undefined" : vt(HTMLElement)) ? t instanceof HTMLElement : t && "object" === vt(t) && null !== t && 1 === t.nodeType && "string" == typeof t.nodeName
                           }(e[r]) || (a = e[r], a instanceof NodeList));
                           if (d && (!e[r] || y) || !d && e[r] && y) {
                              if (e[r] === window) return null;
                              t.onError(o, "'".concat(r, "' is not a valid DOM selector"), n.configError)
                           }
                        } else "array" !== l || Array.isArray(e[r]) || t.onError(o, "'".concat(r, "' should be of ").concat(l, " datatype"), n.configError);
                  else t.onError(o, "'".concat(r, "' should be of ").concat(l, " datatype"), n.configError);
                  d && !e[r] && "element" !== l && t.onError(o, "'".concat(r, "' is required"), n.configError), h.length && !h.includes(e[r]) && t.onError(o, "Only ".concat(h.join(", "), " are allowed for '").concat(r, "'"), n.configError), g && g(e)
               })
            };
         E(c, bt), E(r, St), E(s, Pt), E(u, Ft), E(d, At), E(i, wt), E(p, Ut), E(a, Ot), E(this.options, Vt), E(l, Et), E(u, Ft), E(h, Rt), E(f, Ct), E(o, Nt), E(y, Tt), E(v, Lt), E(m, It), E(S, jt), E(b, kt), E(this.options.url, _t)
      };
      const Xt = function () {
         this.validateConfigs = Mt.bind(this), this.validateConfigs(), this.createLayout(), this.unxSelectors = ft, this.renderDidYouMean.bind(this), this.options.onEvent.bind(this), this.options.products.onProductClick.bind(this), this.reRender = gt.bind(this), this.bindEvents = yt.bind(this), this.bindEvents();
         var t = this.getQueryParams(),
            e = Object.keys(t).length,
            r = this.options.productView,
            a = r.defaultViewType,
            n = r.enabled;
         if (e > 0) {
            var o = t["KEY_VALUE_REPLACER" === this.options.url.pageViewParam.algo ? this.options.url.pageViewParam.keyReplacer : "viewType"],
               i = this.getKeyByValue(this.options.url.pageViewParam.valuesReplacer, decodeURIComponent(o || a));
            i && (this.viewState.productViewType = i, this.options.extraParams.viewType = i, this.state.productViewType = i)
         } else this.options.extraParams.viewType = a;
         n && this.renderProductViewTypeUI()
      };

      function Dt(t) {
         return function (t) {
            if (Array.isArray(t)) return Bt(t)
         }(t) || function (t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t)
         }(t) || function (t, e) {
            if (t) {
               if ("string" == typeof t) return Bt(t, e);
               var r = {}.toString.call(t).slice(8, -1);
               return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Bt(t, e) : void 0
            }
         }(t) || function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
         }()
      }

      function Bt(t, e) {
         (null == e || e > t.length) && (e = t.length);
         for (var r = 0, a = Array(e); r < e; r++) a[r] = t[r];
         return a
      }
      const Wt = function () {
         var t = this;
         this.searchResultsWrapper = this.createtSearchWrapper(), this.bannerWrapper = this.createBannerWrapper(), this.breadcrumbWrapper = this.createBreadcrumbWrapper(), this.pageSizeWrapper = this.createPageSizeWrapper(), this.productViewTypeWrapper = this.createProductViewTypeWrapper(), this.paginationWrappers = [], this.facetWrappers = [], this.sortWrappers = [], this.selectedFacetWrappers = [], this.spellCheckWrappers = [];
         var e = function () {
               var e = t.createSelectedFacetWrapper();
               return t.selectedFacetWrappers.push(e), e
            },
            r = this.options,
            a = r.facet,
            n = r.breadcrumb,
            o = r.banner,
            i = r.sort,
            s = r.products,
            c = r.pagesize,
            l = r.pagination,
            u = r.productView,
            d = r.selectedFacets,
            p = a.facetsEl,
            h = this.options.spellCheck.el,
            f = this.getPaginationType();
         if (h) {
            var g = h;
            g.length || (g = [h]), g.forEach(function (e) {
               var r;
               e.innerHTML = "", e.appendChild((r = t.createSpellCheckWrapper(), t.spellCheckWrappers.push(r), r))
            })
         }
         if (p) {
            var y = p;
            p.length || (y = [p]), y.forEach(function (e) {
               var r;
               e.innerHTML = "", e.appendChild((r = t.createFacetWrapper(), t.facetWrappers.push(r), r))
            })
         }
         var v = i.el;
         if (v) {
            var m = v;
            v.length || (m = [v]), m.forEach(function (e) {
               var r;
               e.innerHTML = "", i.enabled && e.appendChild((r = t.createSortWrapper(), t.sortWrappers.push(r), r))
            })
         }
         if (a.selectedFacetsEl) a.selectedFacetsEl.innerHTML = "", a.selectedFacetsEl.appendChild(e());
         else {
            var b = d.el;
            if (d.enabled && b) {
               var S = b;
               b.length || (S = [b]), S.forEach(function (t) {
                  t.innerHTML = "", t.appendChild(e())
               })
            }
         }
         if (n.el && (n.el.innerHTML = "", n.enabled && n.el.appendChild(this.breadcrumbWrapper)), o.el && (o.el.innerHTML = "", o.enabled && (o.template.bind(this), o.el.appendChild(this.bannerWrapper))), s.el) {
            if (s.el.innerHTML = "", "INFINITE_SCROLL" === f || "CLICK_N_SCROLL" === f) {
               var E, P = document.createElement("div");
               (E = P.classList).add.apply(E, ["UNX-pre-loader"].concat(Dt([l.preloaderClass].filter(Boolean)))), P.style.height = this.getHeightDiffToTriggerNextPage() + "px", s.el.appendChild(P)
            }
            if (s.el.appendChild(this.searchResultsWrapper), "INFINITE_SCROLL" === f) {
               var F, A = document.createElement("div");
               (F = A.classList).add.apply(F, ["UNX-post-loader"].concat(Dt([l.postloaderClass].filter(Boolean)))), A.style.height = this.getHeightDiffToTriggerNextPage() + "px", s.el.appendChild(A)
            }
         }
         c.el && (c.el.innerHTML = "", c.enabled && c.el.appendChild(this.pageSizeWrapper)), u.el && (u.el.innerHTML = "", u.el.appendChild(this.productViewTypeWrapper));
         var w = l.el;
         if (w) {
            var R = w;
            w.length || (R = [w]), R.forEach(function (e) {
               var r;
               e.innerHTML = "", l.enabled && e.appendChild((r = t.createPaginationWrapper(), t.paginationWrappers.push(r), r))
            })
         }
      };

      function Ht() {
         var t = this.options.products,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function zt() {
         var t = this.options.facet,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function Qt() {
         var t = this.options.banner,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function Kt() {
         var t = this.options.breadcrumb,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function qt() {
         var t = this.options.pagesize,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function Yt() {
         var t = this.options.sort,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function Gt() {
         var t = this.options.selectedFacets,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function $t() {
         var t = this.options.spellCheck,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function Zt() {
         var t = this.options.pagination,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }

      function Jt() {
         var t = this.options.productView,
            e = t.tagName,
            r = t.htmlAttributes,
            a = void 0 === r ? {} : r,
            n = t.events;
         return this.createElement(e, Object.assign({}, a), n, this)
      }
      const te = function (t) {
         var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : window,
            n = document.createElement(t);
         Object.keys(e).forEach(function (t) {
            n.setAttribute(t, e[t])
         });
         var o = Object.keys(r);
         return o.length > 0 && o.forEach(function (t) {
            n.addEventListener(t, r[t].bind(a))
         }), n
      };
      var ee = function (t) {
            var e = this.options.products,
               r = Object.assign({}, e, t);
            this.options.products = r
         },
         re = function (t) {
            var e = this.options.facet,
               r = Object.assign({}, e, t);
            this.options.facet = r
         },
         ae = function (t) {
            var e = this.options;
            this.setConfig(e, t), this.initialize()
         },
         ne = function (t) {
            var e = this.options.onAction,
               r = t.target,
               a = r.dataset,
               n = this.cssList,
               o = n.openFacet,
               i = n.closeFacet,
               s = n.openBtn,
               c = n.closeBtn,
               l = n.viewMore,
               u = n.viewLess,
               d = this.options.facet,
               p = d.viewMoreText,
               h = d.textFacetWrapper;
            if (a) {
               var f = a.facetAction,
                  g = a.facetName,
                  y = a.action,
                  v = this.viewState.facetElementMap,
                  m = r.closest(".".concat(v[g]));
               if ("facetOpen" === f && (this.viewState.expandedFacets[g] = !0, r.classList.add(s), r.classList.remove(c), r.setAttribute("data-facet-action", "facetClose"), m.classList.remove(i), m.classList.add(o)), "facetClose" === f && (this.viewState.expandedFacets[g] = !1, r.classList.remove(s), r.classList.add(c), r.setAttribute("data-facet-action", "facetOpen"), m.classList.remove(o), m.classList.add(i)), "viewMore" === y) {
                  r.setAttribute("data-action", "viewLess"), r.innerHTML = p[1];
                  var b = m.querySelector(".".concat(h));
                  b.classList.remove(l), b.classList.add(u)
               }
               if ("viewLess" === y) {
                  r.setAttribute("data-action", "viewMore"), r.innerHTML = p[0];
                  var S = m.querySelector(".".concat(h));
                  S.classList.remove(u), S.classList.add(l)
               }
            }
            e(t, this)
         },
         oe = function (t) {
            var e = this.options.onAction,
               r = t.target.dataset;
            if (r) {
               var a = r.facetAction,
                  n = r.facetName;
               "searchFacets" === a && this.setSearchFacetsText(n, t.target.value)
            }
            e(t, this)
         },
         ie = function () {
            this.resetAll(), this.options.productType = "CATEGORY", this.options.products.productType = "CATEGORY", this.getCallbackActions(this, "categoryPage"), this.getResults()
         },
         se = function () {
            this.resetAll(), this.options.productType = "BROWSE", this.options.products.productType = "BROWSE", this.getCallbackActions(this, "categoryPage"), this.getResults()
         },
         ce = function () {
            this.viewState.lastDidYouMean = null, this.viewState.searchFacetsText = {}, this.viewState.lastDidYouMean = null, this.viewState.expandedFacets = {}
         },
         le = function () {
            return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "unx_") + Math.random().toString(36).substr(2, 9)
         },
         ue = function () {};
      const de = function (t) {
         var e = t.prototype;
         e.renderBannerUI = v, e.setSearchWidget = ee, e.setFacetWidget = re, e.updateConfig = ae, e.createLayout = Wt, e.initialize = Xt, e.extraActions = ne, e.extraActionsChange = oe, e.getCategoryPage = ie, e.getBrowsePage = se, e.resetViewState = ce, e.generateRid = le, e.createElement = te, e.createFacetsLayout = ue,
            function (t) {
               t = Object.assign(t, {
                  createtSearchWrapper: Ht,
                  createFacetWrapper: zt,
                  createBannerWrapper: Qt,
                  createBreadcrumbWrapper: Kt,
                  createPageSizeWrapper: qt,
                  createSortWrapper: Yt,
                  createSelectedFacetWrapper: Gt,
                  createSpellCheckWrapper: $t,
                  createPaginationWrapper: Zt,
                  createProductViewTypeWrapper: Jt
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  setInputValue: tt
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  onPageViewTypeClick: D,
                  renderProductViewTypeUI: x
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  findChangedFacet: m,
                  isSelectedRange: A,
                  clearAllFacets: w,
                  isExpandedFacet: R,
                  setSearchFacetsText: U,
                  getSearchFacetsText: C,
                  reRenderTextFacet: N,
                  renderTextFacet: S,
                  renderRangeFacet: F,
                  renderMultiLevelFacet: P,
                  renderFacets: b,
                  renderSelectedFacets: E,
                  checkFacets: T,
                  setRangeSlider: O
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  renderProducts: L
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  renderSearch: I,
                  onProductItemClick: j,
                  renderNoResults: k,
                  handleNoResults: _,
                  mapProductAttrs: V
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  renderPagination: B,
                  renderNewResults: z,
                  paginationAction: Q,
                  setUpInfiniteScroll: W,
                  getProductsPerPage: K,
                  getCurrentUrlPage: q,
                  setPageNoParam: Y,
                  getFirstPrank: G,
                  getLastPrank: $
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  sortAction: Z,
                  renderSort: J
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  renderDidYouMean: et,
                  setSuggestion: rt
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  onBreadCrumbClick: at,
                  renderBreadCrumbs: nt
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  renderSwatchBtns: ot
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  pageSizeUi: g,
                  onClickPageSize: it,
                  renderPageSize: st
               })
            }(e),
            function (t) {
               t = Object.assign(t, {
                  trackSearch: ct,
                  getCallbackActions: ht,
                  trackProductClick: lt,
                  trackImpression: ut,
                  trackFacetClick: dt,
                  trackCategoryPageLoad: pt
               })
            }(e)
      };
      const pe = function () {
         var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
         this.options = X(!0, {}, t, e);
         var r = e.facet,
            a = e.swatches,
            n = e.products,
            o = e.productView;
         r && (this.options.facetMultilevel = r.facetMultilevel ? r.facetMultilevel : t.facet.facetMultilevel, this.options.facetMultiSelect = "boolean" == typeof r.facetMultiSelect ? r.facetMultiSelect : t.facet.facetMultiSelect, this.options.facetDepth = r.facetDepth ? r.facetDepth : t.facet.facetDepth, this.options.applyMultipleFilters = "boolean" == typeof r.applyMultipleFilters ? r.applyMultipleFilters : t.facet.applyMultipleFilters), this.setPageSize(this.state.pageSize || this.options.pagesize.pageSize), n ? (this.options.productAttributes = n.productAttributes ? n.productAttributes : t.products.productAttributes, this.options.productType = n.productType ? n.productType : t.products.productType) : (this.options.productType = t.products.productType, this.options.productAttributes = t.products.productAttributes), a && (this.options.showSwatches = a && a.enabled ? a.enabled : t.swatches.enabled), o && (this.viewState.productViewType = o.defaultViewType ? o.defaultViewType : t.productView.defaultViewType, this.options.productView.productViewType = this.viewState.productViewType, this.state.productViewType = this.viewState.productViewType)
      };

      function he(t) {
         return he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
         } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
         }, he(t)
      }

      function fe(t, e) {
         for (var r = 0; r < e.length; r++) {
            var a = e[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, ge(a.key), a)
         }
      }

      function ge(t) {
         var e = function (t, e) {
            if ("object" != he(t) || !t) return t;
            var r = t[Symbol.toPrimitive];
            if (void 0 !== r) {
               var a = r.call(t, e || "default");
               if ("object" != he(a)) return a;
               throw new TypeError("@@toPrimitive must return a primitive value.")
            }
            return ("string" === e ? String : Number)(t)
         }(t, "string");
         return "symbol" == he(e) ? e : e + ""
      }

      function ye(t, e, r) {
         return e = me(e),
            function (t, e) {
               if (e && ("object" == he(e) || "function" == typeof e)) return e;
               if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
               return function (t) {
                  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return t
               }(t)
            }(t, ve() ? Reflect.construct(e, r || [], me(t).constructor) : e.apply(t, r))
      }

      function ve() {
         try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}))
         } catch (t) {}
         return (ve = function () {
            return !!t
         })()
      }

      function me(t) {
         return me = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
         }, me(t)
      }

      function be(t, e) {
         return be = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
            return t.__proto__ = e, t
         }, be(t, e)
      }
      var Se = r(330),
         Ee = function (t) {
            function e(t) {
               var r, a, c;
               return function (t, e) {
                  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
               }(this, e), (c = ye(this, e, [t])).viewState = {
                  productViewType: c.state.productViewType || y.productView.defaultViewType,
                  isInfiniteStarted: "INFINITE_SCROLL" === (null === (r = c.options) || void 0 === r || null === (r = r.pagination) || void 0 === r ? void 0 : r.type) || "CLICK_N_SCROLL" === (null === (a = c.options) || void 0 === a || null === (a = a.pagination) || void 0 === a ? void 0 : a.type),
                  lastAction: "",
                  selectedRange: {},
                  expandedFacets: {},
                  searchFacetsText: {},
                  noResultLoaded: !1,
                  lastDidYouMean: null,
                  loadedFromSuggestion: !1,
                  setFromSuggest: !1,
                  facetElementMap: {},
                  initialised: !1
               }, c.setConfig = pe.bind(c), c.setConfig(y, t), c.events = n, c.actions = o, c.cssList = i, c.testIds = s, c.options.onEvent(c, "before_initialised"), c.updateConfig(), c.options.onBackFromRedirect(c.getHashMode()), c.options.onEvent(c, "initialised"), c.sdkVersion = Se.version, c
            }
            return function (t, e) {
               if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
               t.prototype = Object.create(e && e.prototype, {
                  constructor: {
                     value: t,
                     writable: !0,
                     configurable: !0
                  }
               }), Object.defineProperty(t, "prototype", {
                  writable: !1
               }), e && be(t, e)
            }(e, t), r = e, (a = [{
               key: "callBack",
               value: function (t, e) {
                  this.getCallbackActions(t, e);
                  var r = this.options,
                     a = r.onEvent,
                     o = r.loader,
                     i = r.facet,
                     s = r.productView,
                     c = this.events,
                     l = c.beforeApiCall,
                     u = c.afterApiCall,
                     d = (this.getQueryParams() || {})[this.getPageViewParam()];
                  if ("viewType" === this.viewState.lastAction && (d = this.viewState.productViewType, this.options.extraParams.viewType = d, this.viewState.lastAction = ""), d || (d = this.viewState.productViewType || s.defaultViewType, this.viewState.productViewType = d, this.options.extraParams.viewType = d), this.viewState.productViewType !== d && (this.viewState.productViewType = this.getKeyByValue(this.options.url.pageViewParam.valuesReplacer, decodeURIComponent(d)), this.options.extraParams.viewType = d), e === l) {
                     try {
                        a(this, l)
                     } catch (t) {
                        this.onError("callback", t, n.runtimeError)
                     }
                     o && o.el && (o.el.innerHTML = o.template(this))
                  }
                  if (e === u) {
                     try {
                        a(this, u)
                     } catch (t) {
                        this.onError("callback", t, n.runtimeError)
                     }
                     this.state.products.length > 0 && (this.viewState.noResultLoaded = !1), this.reRender()
                  }
                  if (("added_facet" === e || "deleted_facet" === e) && i.applyMultipleFilters) {
                     try {
                        a(this, "added_facet")
                     } catch (t) {
                        this.onError("callback", t, n.runtimeError)
                     }
                     this.renderFacets()
                  }
                  if ("FETCH_ERROR" === e) try {
                     o && o.el && (o.el.innerHTML = ""), a(this, "FETCH_ERROR")
                  } catch (t) {
                     this.onError("callback", t, n.fetchError)
                  }
               }
            }, {
               key: "delegate",
               value: function (t, e, r, a) {
                  return c(t, e, r, a)
               }
            }]) && fe(r.prototype, a), l && fe(r, l), Object.defineProperty(r, "prototype", {
               writable: !1
            }), r;
            var r, a, l
         }(e());
      de(Ee);
      const Pe = Ee
   })(), a = a.default
})());